(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 78831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HK": function() { return /* binding */ $9d939cbc98267846$export$9f8ac96af4b1b2ae; },
/* harmony export */   "gP": function() { return /* binding */ $9d939cbc98267846$export$619500959fc48b26; }
/* harmony export */ });
/* unused harmony export useIsSSR */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9d939cbc98267846$exports = {};

$parcel$export($9d939cbc98267846$exports, "SSRProvider", () => $9d939cbc98267846$export$9f8ac96af4b1b2ae);
$parcel$export($9d939cbc98267846$exports, "useSSRSafeId", () => $9d939cbc98267846$export$619500959fc48b26);
$parcel$export($9d939cbc98267846$exports, "useIsSSR", () => $9d939cbc98267846$export$535bd6ca7f90a273);

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $9d939cbc98267846$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $9d939cbc98267846$var$SSRContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext($9d939cbc98267846$var$defaultContext);
function $9d939cbc98267846$export$9f8ac96af4b1b2ae(props) {
    let cur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)($9d939cbc98267846$var$SSRContext);
    let value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $9d939cbc98267846$var$defaultContext ? '' : `${cur.prefix}-${++cur.current}`,
            current: 0
        })
    , [
        cur
    ]);
    return(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement($9d939cbc98267846$var$SSRContext.Provider, {
        value: value
    }, props.children));
}
let $9d939cbc98267846$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
function $9d939cbc98267846$export$619500959fc48b26(defaultId) {
    let ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)($9d939cbc98267846$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $9d939cbc98267846$var$defaultContext && !$9d939cbc98267846$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`
    , [
        defaultId
    ]);
}
function $9d939cbc98267846$export$535bd6ca7f90a273() {
    let cur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)($9d939cbc98267846$var$SSRContext);
    let isInSSRContext = cur !== $9d939cbc98267846$var$defaultContext;
    let [isSSR, setIsSSR] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== 'undefined' && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}





//# sourceMappingURL=module.js.map


/***/ }),

/***/ 32092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCallbackRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */

function useCallbackRef() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
}

/***/ }),

/***/ 92029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ __webpack_exports__["Z"] = (useCommittedRef);

/***/ }),

/***/ 78146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useCommittedRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92029);


function useEventCallback(fn) {
  var ref = (0,_useCommittedRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/***/ }),

/***/ 35654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeRefs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

/* harmony default export */ __webpack_exports__["Z"] = (useMergedRefs);

/***/ }),

/***/ 6454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */

function useMounted() {
  var mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () {
    return mounted.current;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/***/ }),

/***/ 88833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */

function usePrevious(value) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}

/***/ }),

/***/ 70861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ useButtonProps; }
/* harmony export */ });
/* unused harmony export isTrivialHref */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
const _excluded = ["as", "disabled"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }

  const meta = {
    tagName
  };

  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }

  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    onClick == null ? void 0 : onClick(event);
  };

  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');

    if (disabled) {
      href = undefined;
    }
  }

  return [{
    role: 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: asProp,
    disabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["ZP"] = (Button);

/***/ }),

/***/ 52747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ dataProp; },
/* harmony export */   "PB": function() { return /* binding */ dataAttr; }
/* harmony export */ });
/* unused harmony exports ATTRIBUTE_PREFIX, PROPERTY_PREFIX */
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
  return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
  return `${PROPERTY_PREFIX}${property}`;
}

/***/ }),

/***/ 54194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWaitForDOMRef; }
/* harmony export */ });
/* unused harmony export resolveContainerRef */
/* harmony import */ var dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67216);
/* harmony import */ var dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23004);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12963);




const resolveContainerRef = (ref, document) => {
  var _ref;

  if (!dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) return null;
  if (ref == null) return (document || (0,dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()).body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if ((_ref = ref) != null && _ref.nodeType) return ref || null;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  const window = (0,_useWindow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const [resolvedRef, setRef] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => resolveContainerRef(ref, window == null ? void 0 : window.document));

  if (!resolvedRef) {
    const earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const nextRef = resolveContainerRef(ref);

    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

/***/ }),

/***/ 12963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindow; }
/* harmony export */ });
/* unused harmony export WindowProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23004);


const Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? window : undefined);
const WindowProvider = Context.Provider;
/**
 * The document "window" placed in React context. Helpful for determining
 * SSR context, or when rendering into an iframe.
 *
 * @returns the current window
 */

function useWindow() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
}

/***/ }),

/***/ 9351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports optionsSupported, onceSupported */
/* harmony import */ var _canUseDOM__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23004);
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (_canUseDOM__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ __webpack_exports__["ZP"] = (addEventListener);

/***/ }),

/***/ 23004:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),

/***/ 90424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/***/ }),

/***/ 91505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ css; }
});

// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(67216);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerWindow.js

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = (0,ownerDocument/* default */.Z)(node);
  return doc && doc.defaultView || window;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/getComputedStyle.js

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenate.js
var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenateStyle.js
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */

var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/isTransform.js
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/css.js




function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* harmony default export */ var css = (style);

/***/ }),

/***/ 11132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ hasClass; }
/* harmony export */ });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),

/***/ 72950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9351);
/* harmony import */ var _removeEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30099);



function listen(node, eventName, handler, options) {
  (0,_addEventListener__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(node, eventName, handler, options);
  return function () {
    (0,_removeEventListener__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node, eventName, handler, options);
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (listen);

/***/ }),

/***/ 67216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 60930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ qsa; }
/* harmony export */ });
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}

/***/ }),

/***/ 30099:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ __webpack_exports__["Z"] = (removeEventListener);

/***/ }),

/***/ 94305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ transitionEnd; }
});

// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(72950);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/triggerEvent.js
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {
  if (bubbles === void 0) {
    bubbles = false;
  }

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/transitionEnd.js




function parseDuration(node) {
  var str = (0,css/* default */.Z)(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) triggerEvent(element, 'transitionend', true);
  }, duration + padding);
  var remove = (0,listen/* default */.Z)(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = (0,listen/* default */.Z)(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}

/***/ }),

/***/ 99960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 47915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(99960);
var node_1 = __webpack_require__(97790);
__exportStar(__webpack_require__(97790), exports);
var reWhitespace = /\s+/g;
// Default options
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                lastNode.data += data;
            }
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            if (normalizeWhitespace) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.Text("");
        var node = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 97790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(99960);
var nodeTypes = new Map([
    [domelementtype_1.ElementType.Tag, 1],
    [domelementtype_1.ElementType.Script, 1],
    [domelementtype_1.ElementType.Style, 1],
    [domelementtype_1.ElementType.Directive, 1],
    [domelementtype_1.ElementType.Text, 3],
    [domelementtype_1.ElementType.CDATA, 4],
    [domelementtype_1.ElementType.Comment, 8],
    [domelementtype_1.ElementType.Root, 9],
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    /**
     *
     * @param type The type of the node.
     */
    function Node(type) {
        this.type = type;
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */
        get: function () {
            var _a;
            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text(data) {
        return _super.call(this, domelementtype_1.ElementType.Text, data) || this;
    }
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment(data) {
        return _super.call(this, domelementtype_1.ElementType.Comment, data) || this;
    }
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document(children) {
        return _super.call(this, domelementtype_1.ElementType.Root, children) || this;
    }
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 60885:
/***/ (function(module) {

/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
 */
var CASE_SENSITIVE_TAG_NAMES = [
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussainBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'linearGradient',
  'radialGradient',
  'textPath'
];

module.exports = {
  CASE_SENSITIVE_TAG_NAMES: CASE_SENSITIVE_TAG_NAMES
};


/***/ }),

/***/ 38276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// constants
var HTML = 'html';
var HEAD = 'head';
var BODY = 'body';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
var HEAD_TAG_REGEX = /<head.*>/i;
var BODY_TAG_REGEX = /<body.*>/i;

// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var parseFromDocument = function () {
  throw new Error(
    'This browser does not support `document.implementation.createHTMLDocument`'
  );
};

var parseFromString = function () {
  throw new Error(
    'This browser does not support `DOMParser.prototype.parseFromString`'
  );
};

/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
if (typeof window.DOMParser === 'function') {
  var domParser = new window.DOMParser();
  var mimeType = 'text/html';

  /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromString = function (html, tagName) {
    if (tagName) {
      html = '<' + tagName + '>' + html + '</' + tagName + '>';
    }

    return domParser.parseFromString(html, mimeType);
  };

  parseFromDocument = parseFromString;
}

/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
if (document.implementation) {
  var isIE = (__webpack_require__(1507).isIE);

  // title parameter is required in IE
  // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
  var doc = document.implementation.createHTMLDocument(
    isIE() ? 'html-dom-parser' : undefined
  );

  /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromDocument = function (html, tagName) {
    if (tagName) {
      doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
      return doc;
    }

    doc.documentElement.innerHTML = html;
    return doc;
  };
}

/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var template = document.createElement('template');
var parseFromTemplate;

if (template.content) {
  /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */
  parseFromTemplate = function (html) {
    template.innerHTML = html;
    return template.content.childNodes;
  };
}

/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */
function domparser(html) {
  var firstTagName;
  var match = html.match(FIRST_TAG_REGEX);

  if (match && match[1]) {
    firstTagName = match[1].toLowerCase();
  }

  var doc;
  var element;
  var elements;

  switch (firstTagName) {
    case HTML:
      doc = parseFromString(html);

      // the created document may come with filler head/body elements,
      // so make sure to remove them if they don't actually exist
      if (!HEAD_TAG_REGEX.test(html)) {
        element = doc.getElementsByTagName(HEAD)[0];
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      if (!BODY_TAG_REGEX.test(html)) {
        element = doc.getElementsByTagName(BODY)[0];
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      return doc.getElementsByTagName(HTML);

    case HEAD:
    case BODY:
      elements = parseFromDocument(html).getElementsByTagName(firstTagName);

      // if there's a sibling element, then return both elements
      if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
        return elements[0].parentNode.childNodes;
      }
      return elements;

    // low-level tag or text
    default:
      if (parseFromTemplate) {
        return parseFromTemplate(html);
      }

      return parseFromDocument(html, BODY).getElementsByTagName(BODY)[0]
        .childNodes;
  }
}

module.exports = domparser;


/***/ }),

/***/ 14152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domparser = __webpack_require__(38276);
var formatDOM = (__webpack_require__(1507).formatDOM);

var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param  {string} html  - HTML markup.
 * @return {DomElement[]} - DOM elements.
 */
function HTMLDOMParser(html) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (html === '') {
    return [];
  }

  // match directive
  var match = html.match(DIRECTIVE_REGEX);
  var directive;

  if (match && match[1]) {
    directive = match[1];
  }

  return formatDOM(domparser(html), null, directive);
}

module.exports = HTMLDOMParser;


/***/ }),

/***/ 1507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constants = __webpack_require__(60885);
var domhandler = __webpack_require__(97790);

var CASE_SENSITIVE_TAG_NAMES = constants.CASE_SENSITIVE_TAG_NAMES;

var Comment = domhandler.Comment;
var Element = domhandler.Element;
var ProcessingInstruction = domhandler.ProcessingInstruction;
var Text = domhandler.Text;

var caseSensitiveTagNamesMap = {};
var tagName;

for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
  tagName = CASE_SENSITIVE_TAG_NAMES[i];
  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
}

/**
 * Gets case-sensitive tag name.
 *
 * @param  {string}           tagName - Tag name in lowercase.
 * @return {string|undefined}         - Case-sensitive tag name.
 */
function getCaseSensitiveTagName(tagName) {
  return caseSensitiveTagNamesMap[tagName];
}

/**
 * Formats DOM attributes to a hash map.
 *
 * @param  {NamedNodeMap} attributes - List of attributes.
 * @return {object}                  - Map of attribute name to value.
 */
function formatAttributes(attributes) {
  var result = {};
  var attribute;
  // `NamedNodeMap` is array-like
  for (var i = 0, len = attributes.length; i < len; i++) {
    attribute = attributes[i];
    result[attribute.name] = attribute.value;
  }
  return result;
}

/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param  {string} tagName - Lowercase tag name.
 * @return {string}         - Formatted tag name.
 */
function formatTagName(tagName) {
  tagName = tagName.toLowerCase();
  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
  if (caseSensitiveTagName) {
    return caseSensitiveTagName;
  }
  return tagName;
}

/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param  {NodeList}     nodes         - DOM nodes.
 * @param  {Element|null} [parent=null] - Parent node.
 * @param  {string}       [directive]   - Directive.
 * @return {Array<Comment|Element|ProcessingInstruction|Text>}
 */
function formatDOM(nodes, parent, directive) {
  parent = parent || null;
  var result = [];

  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    var current;

    // set the node data given the type
    switch (node.nodeType) {
      case 1:
        // script, style, or tag
        current = new Element(
          formatTagName(node.nodeName),
          formatAttributes(node.attributes)
        );
        current.children = formatDOM(node.childNodes, current);
        break;

      case 3:
        current = new Text(node.nodeValue);
        break;

      case 8:
        current = new Comment(node.nodeValue);
        break;

      default:
        continue;
    }

    // set previous node next
    var prev = result[index - 1] || null;
    if (prev) {
      prev.next = current;
    }

    // set properties for current node
    current.parent = parent;
    current.prev = prev;
    current.next = null;

    result.push(current);
  }

  if (directive) {
    current = new ProcessingInstruction(
      directive.substring(0, directive.indexOf(' ')).toLowerCase(),
      directive
    );
    current.next = result[0] || null;
    current.parent = parent;
    result.unshift(current);

    if (result[1]) {
      result[1].prev = result[0];
    }
  }

  return result;
}

/**
 * Detects if browser is Internet Explorer.
 *
 * @return {boolean} - Whether IE is detected.
 */
function isIE() {
  return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
}

module.exports = {
  formatAttributes: formatAttributes,
  formatDOM: formatDOM,
  isIE: isIE
};


/***/ }),

/***/ 30488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domToReact = __webpack_require__(53670);
var attributesToProps = __webpack_require__(50484);
var htmlToDOM = __webpack_require__(14152);

// support backwards compatibility for ES Module
htmlToDOM =
  /* istanbul ignore next */
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;

var domParserOptions = { lowerCaseAttributeNames: false };

/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}

HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;
HTMLReactParser.Element = (__webpack_require__(47915).Element);

// support CommonJS and ES Modules
module.exports = HTMLReactParser;
module.exports["default"] = HTMLReactParser;


/***/ }),

/***/ 50484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var reactProperty = __webpack_require__(25726);
var utilities = __webpack_require__(74606);

/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @returns - React props.
 */
module.exports = function attributesToProps(attributes) {
  attributes = attributes || {};

  var valueOnlyInputs = {
    reset: true,
    submit: true
  };

  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];

    // ARIA (aria-*) or custom data (data-*) attribute
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }

    // convert HTML/SVG attribute to React prop
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);

    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);

      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
      // https://reactjs.org/docs/uncontrolled-components.html
      if (
        (propName === 'checked' || propName === 'value') &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }

      props[propName] = attributeValue;

      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }

    // preserve custom attribute if React >=16
    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }

  // transform inline style to object
  utilities.setStyleProp(attributes.style, props);

  return props;
};

/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}


/***/ }),

/***/ 53670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var attributesToProps = __webpack_require__(50484);
var utilities = __webpack_require__(74606);

var setStyleProp = utilities.setStyleProp;
var canTextBeChildOfNode = utilities.canTextBeChildOfNode;

/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */
function domToReact(nodes, options) {
  options = options || {};

  var library = options.library || React;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;

  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if present)
    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;

      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        // We have a whitespace node that can't be nested in its parent
        // so skip it
        continue;
      }

      if (trim && isWhitespace) {
        // Trim is enabled and we have a whitespace node
        // so skip it
        continue;
      }

      // We have a text node that's not whitespace and it can be nested
      // in its parent so add it to the results
      result.push(node.data);
      continue;
    }

    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps(props);
    }

    children = null;

    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;

      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://reactjs.org/docs/forms.html#the-textarea-tag
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact(node.children, options);
        }
        break;

      // skip all other cases (e.g., comment)
      default:
        continue;
    }

    // set "key" prop for sibling elements
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */
function skipAttributesToProps(node) {
  return (
    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities.isCustomComponent(node.name, node.attribs)
  );
}

module.exports = domToReact;


/***/ }),

/***/ 74606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var styleToJS = (__webpack_require__(41476)["default"]);

/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}

var styleToJSOptions = { reactCompat: true };

/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */
function setStyleProp(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}

/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */
var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;

// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);

/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */
function canTextBeChildOfNode(node) {
  return !elementsWithNoTextChildren.has(node.name);
}

module.exports = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp,
  canTextBeChildOfNode: canTextBeChildOfNode,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};


/***/ }),

/***/ 18139:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 70365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(81445)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),

/***/ 81445:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(84805);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 84805:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(20971);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 20971:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(33951);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnboardingWizard_OnboardingWizard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./context/OnboardingContext.tsx
var OnboardingContext = __webpack_require__(22186);
// EXTERNAL MODULE: ./context/WizardOptionsContext.tsx + 1 modules
var WizardOptionsContext = __webpack_require__(25174);
// EXTERNAL MODULE: ./utils/b2c/prefs.ts
var b2c_prefs = __webpack_require__(39156);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
// EXTERNAL MODULE: ./utils/b2cIcons.tsx
var b2cIcons = __webpack_require__(54189);
// EXTERNAL MODULE: ./styles/B2C/ProgressBar.module.scss
var ProgressBar_module = __webpack_require__(88259);
var ProgressBar_module_default = /*#__PURE__*/__webpack_require__.n(ProgressBar_module);
;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/ProgressBar.tsx



const ProgressBar = ({ currentStep , totalSteps  })=>{
    const progress = currentStep / totalSteps * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ProgressBar_module_default()).progressFill,
        style: {
            width: `${progress}%`
        }
    });
};
/* harmony default export */ var OnboardingWizard_ProgressBar = (ProgressBar);

// EXTERNAL MODULE: ./styles/B2C/SearchInput.module.scss
var SearchInput_module = __webpack_require__(12522);
var SearchInput_module_default = /*#__PURE__*/__webpack_require__.n(SearchInput_module);
;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/SearchInput.tsx




const SearchInput = ({ value , onChange , placeholder ="Search..." , sticky =false ,  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(SearchInput_module_default()).searchWrapper} ${sticky ? (SearchInput_module_default()).sticky : ""}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* SearchIcon */.W1, {
                className: (SearchInput_module_default()).searchIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                className: (SearchInput_module_default()).searchInput,
                value: value,
                onChange: (e)=>onChange(e.target.value),
                placeholder: placeholder
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./styles/B2C/OptionGrid.module.scss
var OptionGrid_module = __webpack_require__(29789);
var OptionGrid_module_default = /*#__PURE__*/__webpack_require__.n(OptionGrid_module);
;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/NoSearchResults.tsx



const NoSearchResults = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (OptionGrid_module_default()).noResults,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "No results found. Try a different search."
        })
    });
/* harmony default export */ var OnboardingWizard_NoSearchResults = (NoSearchResults);

// EXTERNAL MODULE: ./styles/B2C/StepLayout.module.scss
var StepLayout_module = __webpack_require__(58386);
var StepLayout_module_default = /*#__PURE__*/__webpack_require__.n(StepLayout_module);
;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/DestinationStep.tsx







const DestinationStep = ({ selected , onSelect  })=>{
    const { countries  } = (0,WizardOptionsContext/* useWizardOptions */.s)();
    const countryList = (0,react.useMemo)(()=>countries ?? [], [
        countries
    ]);
    const { 0: search , 1: setSearch  } = (0,react.useState)("");
    const filteredCountries = (0,react.useMemo)(()=>{
        if (!search.trim()) return countryList;
        return countryList.filter((country)=>country.name.toLowerCase().includes(search.toLowerCase()));
    }, [
        search,
        countryList
    ]);
    const handleSelect = (country)=>{
        if (selected.includes(country)) {
            onSelect(selected);
        } else {
            onSelect([
                country
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (StepLayout_module_default()).stepContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_SearchInput, {
                value: search,
                onChange: setSearch,
                placeholder: "Search..."
            }),
            search.trim() !== "" && filteredCountries.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_NoSearchResults, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OptionGrid_module_default()).optionGridTall,
                children: filteredCountries.map((country)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        title: country.name,
                        className: `${(OptionGrid_module_default()).optionItem} ${selected.includes(country.name) ? (OptionGrid_module_default()).selected : ""}`,
                        onClick: ()=>handleSelect(country.name),
                        children: [
                            country.imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: country.imageUrl,
                                alt: country.imageAltTag || country.name,
                                style: {
                                    width: 24,
                                    height: 24,
                                    marginRight: 8,
                                    borderRadius: "50%",
                                    objectFit: "cover"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (OptionGrid_module_default()).optionLabel,
                                children: country.name
                            })
                        ]
                    }, country.name))
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_DestinationStep = (DestinationStep);

;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/DegreeStep.tsx







const DegreeStep = ({ selected , onSelect  })=>{
    const { degreeLevels  } = (0,WizardOptionsContext/* useWizardOptions */.s)();
    const options = (0,react.useMemo)(()=>degreeLevels ?? [], [
        degreeLevels
    ]);
    const { 0: search , 1: setSearch  } = (0,react.useState)("");
    const filteredOptions = (0,react.useMemo)(()=>{
        if (!search.trim()) return options;
        return options.filter((degree)=>degree.label.toLowerCase().includes(search.toLowerCase()));
    }, [
        search,
        options
    ]);
    const handleSelect = (degree)=>{
        onSelect(degree);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (StepLayout_module_default()).stepContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_SearchInput, {
                value: search,
                onChange: setSearch,
                placeholder: "Search..."
            }),
            search.trim() !== "" && filteredOptions.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_NoSearchResults, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OptionGrid_module_default()).degreeGrid,
                children: filteredOptions.map((degree)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        title: degree.label,
                        className: `${(OptionGrid_module_default()).optionItem} ${selected === degree.label ? (OptionGrid_module_default()).selected : ""}`,
                        onClick: ()=>handleSelect(degree.label),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (OptionGrid_module_default()).optionLabel,
                            children: degree.label
                        })
                    }, degree.label);
                })
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_DegreeStep = (DegreeStep);

;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/OptionGrid.tsx



const OptionGrid = ({ options , selected , onSelect , multiSelect =true ,  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (OptionGrid_module_default()).optionGrid,
        children: options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                title: option,
                className: `${(OptionGrid_module_default()).optionItem} ${selected.includes(option) ? (OptionGrid_module_default()).selected : ""}`,
                onClick: ()=>onSelect(option),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (OptionGrid_module_default()).optionLabel,
                    children: option
                })
            }, option))
    });
};
/* harmony default export */ var OnboardingWizard_OptionGrid = (OptionGrid);

;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/FieldOfStudyStep.tsx







const FieldOfStudyStep = ({ selected , onSelect ,  })=>{
    const { studyAreas  } = (0,WizardOptionsContext/* useWizardOptions */.s)();
    const areaNames = (0,react.useMemo)(()=>(studyAreas ?? []).map((studyArea)=>studyArea.label), [
        studyAreas
    ]);
    const { 0: search , 1: setSearch  } = (0,react.useState)("");
    const filteredAreas = (0,react.useMemo)(()=>{
        if (!search.trim()) return areaNames;
        return areaNames.filter((areaName)=>areaName.toLowerCase().includes(search.toLowerCase()));
    }, [
        search,
        areaNames
    ]);
    const handleSelect = (area)=>{
        if (selected.includes(area)) {
            onSelect(selected);
        } else {
            onSelect([
                area
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (StepLayout_module_default()).stepContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_SearchInput, {
                value: search,
                onChange: setSearch,
                placeholder: "Search..."
            }),
            search.trim() !== "" && filteredAreas.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_NoSearchResults, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_OptionGrid, {
                options: filteredAreas,
                selected: selected,
                onSelect: handleSelect,
                multiSelect: true
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_FieldOfStudyStep = (FieldOfStudyStep);

;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/CityStep.tsx







// Show only the first N options (in response order) until the user searches;
// a search query then filters the full list.
const DEFAULT_VISIBLE_COUNT = 20;
const CityStep = ({ selected , onSelect  })=>{
    const { cities  } = (0,WizardOptionsContext/* useWizardOptions */.s)();
    const cityNames = (0,react.useMemo)(()=>(cities ?? []).map((city)=>city.label), [
        cities
    ]);
    const { 0: search , 1: setSearch  } = (0,react.useState)("");
    const filteredCities = (0,react.useMemo)(()=>{
        if (!search.trim()) return cityNames.slice(0, DEFAULT_VISIBLE_COUNT);
        return cityNames.filter((cityName)=>cityName.toLowerCase().includes(search.toLowerCase()));
    }, [
        search,
        cityNames
    ]);
    const handleSelect = (city)=>{
        onSelect(city);
    };
    // CFM-1514: dynamic count — round down to nearest 10 + "+" (fallback while loading)
    const cityCountLabel = cityNames.length >= 10 ? `${Math.floor(cityNames.length / 10) * 10}+` : "190+";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (StepLayout_module_default()).stepContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_SearchInput, {
                value: search,
                onChange: setSearch,
                placeholder: "Search city...",
                sticky: true
            }),
            !search.trim() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (StepLayout_module_default()).topCities,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (StepLayout_module_default()).topCitiesHeading,
                        children: "Top cities"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (StepLayout_module_default()).topCitiesHelper,
                        children: [
                            "Don't see your city?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (StepLayout_module_default()).topCitiesHelperStrong,
                                children: "Search above"
                            }),
                            " — we cover ",
                            cityCountLabel,
                            " cities."
                        ]
                    })
                ]
            }),
            search.trim() !== "" && filteredCities.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_NoSearchResults, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_OptionGrid, {
                options: filteredCities,
                selected: selected ? [
                    selected
                ] : [],
                onSelect: handleSelect,
                multiSelect: false
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_CityStep = (CityStep);

;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/NearestOfficeStep.tsx







// Show only the first N offices (in response order) until the user searches;
// a search query then filters the full list.
const NearestOfficeStep_DEFAULT_VISIBLE_COUNT = 20;
const NearestOfficeStep = ({ selected , onSelect ,  })=>{
    const { nearestOffices  } = (0,WizardOptionsContext/* useWizardOptions */.s)();
    const options = (0,react.useMemo)(()=>(nearestOffices ?? []).map((office)=>office.label), [
        nearestOffices
    ]);
    const { 0: search , 1: setSearch  } = (0,react.useState)("");
    const filteredOptions = (0,react.useMemo)(()=>{
        if (!search.trim()) return options.slice(0, NearestOfficeStep_DEFAULT_VISIBLE_COUNT);
        return options.filter((label)=>label.toLowerCase().includes(search.toLowerCase()));
    }, [
        search,
        options
    ]);
    const handleSelect = (office)=>{
        onSelect(office);
    };
    // CFM-1514: dynamic count — round down to nearest 10 + "+" (fallback while loading)
    const officeCountLabel = options.length >= 10 ? `${Math.floor(options.length / 10) * 10}+` : "60+";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (StepLayout_module_default()).stepContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_SearchInput, {
                value: search,
                onChange: setSearch,
                placeholder: "Search...",
                sticky: true
            }),
            !search.trim() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (StepLayout_module_default()).topCities,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (StepLayout_module_default()).topCitiesHeading,
                        children: "Nearest offices"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (StepLayout_module_default()).topCitiesHelper,
                        children: [
                            "Don't see your nearest office?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (StepLayout_module_default()).topCitiesHelperStrong,
                                children: "Search above"
                            }),
                            " - we have 60+ offices."
                        ]
                    })
                ]
            }),
            search.trim() !== "" && filteredOptions.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_NoSearchResults, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_OptionGrid, {
                options: filteredOptions,
                selected: selected ? [
                    selected
                ] : [],
                onSelect: handleSelect,
                multiSelect: false
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_NearestOfficeStep = (NearestOfficeStep);

;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/CoachingStep.tsx







// Sentinel option always shown last. Selecting it sends looking_for_coaching = 'No'.
const COACHING_NOT_INTERESTED = "Not Interested";
const CoachingStep = ({ selected , onSelect  })=>{
    const { coachingOptions  } = (0,WizardOptionsContext/* useWizardOptions */.s)();
    const { 0: search , 1: setSearch  } = (0,react.useState)("");
    // Frappe courses + a trailing "Not Interested" (always present, even if the list is empty).
    const options = (0,react.useMemo)(()=>{
        const courses = (coachingOptions ?? []).map((coaching)=>coaching.label).filter(Boolean);
        return [
            ...courses,
            COACHING_NOT_INTERESTED
        ];
    }, [
        coachingOptions
    ]);
    const filteredOptions = (0,react.useMemo)(()=>{
        if (!search.trim()) return options;
        return options.filter((label)=>label.toLowerCase().includes(search.toLowerCase()));
    }, [
        search,
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (StepLayout_module_default()).stepContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_SearchInput, {
                value: search,
                onChange: setSearch,
                placeholder: "Search...",
                sticky: true
            }),
            search.trim() !== "" && filteredOptions.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_NoSearchResults, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_OptionGrid, {
                options: filteredOptions,
                selected: selected ? [
                    selected
                ] : [],
                onSelect: onSelect,
                multiSelect: false
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_CoachingStep = (CoachingStep);

// EXTERNAL MODULE: ./styles/B2C/OnboardingWizard.module.scss
var OnboardingWizard_module = __webpack_require__(69354);
var OnboardingWizard_module_default = /*#__PURE__*/__webpack_require__.n(OnboardingWizard_module);
;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/OnboardingWizard.tsx

















const STEP_CONFIG = {
    [OnboardingContext/* STEP_IDS.DESTINATION */.Xb.DESTINATION]: {
        title: "Select your preferred study destination"
    },
    [OnboardingContext/* STEP_IDS.DEGREE */.Xb.DEGREE]: {
        title: "Select your preferred study level"
    },
    [OnboardingContext/* STEP_IDS.FIELD_OF_STUDY */.Xb.FIELD_OF_STUDY]: {
        title: "Select your preferred study area"
    },
    [OnboardingContext/* STEP_IDS.CITY */.Xb.CITY]: {
        title: "Which city do you live in?"
    },
    [OnboardingContext/* STEP_IDS.NEAREST_OFFICE */.Xb.NEAREST_OFFICE]: {
        title: "Which office is nearest to you?"
    },
    [OnboardingContext/* STEP_IDS.COACHING */.Xb.COACHING]: {
        title: "Select your preferred coaching"
    }
};
const OnboardingWizard = ({ onClose  })=>{
    const router = (0,next_router.useRouter)();
    const { 0: isLoading , 1: setIsLoading  } = (0,react.useState)(false);
    const { 0: stepping , 1: setStepping  } = (0,react.useState)(false);
    const { 0: finishError , 1: setFinishError  } = (0,react.useState)("");
    const wizardBodyRef = (0,react.useRef)(null);
    const { currentStep , totalSteps , activeStepId , data , enableB2cNearestOffice , closeWizard , nextStep , prevStep , updateData ,  } = (0,OnboardingContext/* useOnboarding */.kc)();
    const wizardOptions = (0,WizardOptionsContext/* useWizardOptions */.s)();
    const goBackOrHome = ()=>{
        const referrer =  true ? document.referrer : 0;
        const cameFromSameOrigin = referrer && new URL(referrer).origin === window.location.origin;
        if (cameFromSameOrigin) {
            router.back();
        } else {
            router.push("/");
        }
    };
    const handleBack = ()=>{
        if (currentStep === 1) {
            closeWizard();
            if (onClose) {
                onClose();
            } else {
                goBackOrHome();
            }
        } else {
            prevStep();
        }
    };
    const handleFinish = (0,react.useCallback)(async ()=>{
        setIsLoading(true);
        setFinishError("");
        let counsellorName = "";
        let counsellorEmail = "";
        let counsellorPhone = "";
        let counsellorWhatsapp = "";
        let studentModule = "";
        let partnerUuid = "";
        try {
            const params = new URLSearchParams();
            if (data.city) params.append("student_city", data.city.trim());
            if (data.countries[0]) params.append("preferred_destination_1", data.countries[0].trim());
            if (data.countries[1]) params.append("preferred_destination_2", data.countries[1].trim());
            if (data.countries[2]) params.append("preferred_destination_3", data.countries[2].trim());
            if (data.nearestOffice) params.append("nearest_office", data.nearestOffice.trim());
            const response = await fetch(`${constants/* FRAPPE_URL */.kO}/api/method/retrieve_partner_details?${params.toString()}`, {
                headers: {
                    Authorization: `token ${constants/* FRAPPE_API_KEY */.K7}:${constants/* FRAPPE_API_SECRET */.wS}`
                }
            });
            const result = await response.json();
            const responseData = result?.message?.data;
            if (responseData?.primary_counsellor) {
                counsellorName = responseData.primary_counsellor.full_name || "";
                counsellorEmail = responseData.primary_counsellor.email || "";
                counsellorPhone = responseData.primary_counsellor.phone || "";
                counsellorWhatsapp = responseData.primary_counsellor.whatsapp_link || "";
                partnerUuid = (responseData.primary_counsellor.counsellor_uuid || "").trim();
            }
            if (responseData?.student_module) {
                studentModule = responseData.student_module;
            }
        } catch (error) {
            console.error("[OnboardingWizard] Failed to retrieve partner details:", error);
        }
        // Strict guard: do not advance with missing partnerUuid — downstream CF/Frappe flow requires it
        if (!partnerUuid) {
            setIsLoading(false);
            setStepping(false);
            setFinishError("We couldn't match you to a counsellor right now. Please check your selections and try again.");
            return;
        }
        // Map selected text preferences → cfIds for search API
        const countryCfIds = data.countries.map((name)=>wizardOptions.countries.find((country)=>country.name === name)?.cfId).filter((id)=>id != null);
        // No single cfId represents a unified bucket — expansion happens at the
        // lead-PUT and search boundaries. Field kept for backwards compat with B2cPrefs.
        const degreeLevelCfId = null;
        const studyAreaCfIds = data.studyAreas.map((label)=>wizardOptions.studyAreas.find((studyArea)=>studyArea.label === label)?.cfId).filter((id)=>id != null);
        // Step 6 → Frappe: a course maps to 'Yes' + its name; "Not Interested"/empty → 'No'.
        const coachingType = data.coachingType.trim();
        const lookingForCoaching = coachingType && coachingType !== COACHING_NOT_INTERESTED ? "Yes" : "No";
        const preferredCoaching = lookingForCoaching === "Yes" ? coachingType : "";
        const prefs = {
            countries: data.countries.map((country)=>country.trim()).filter(Boolean),
            degreeLevel: data.degreeLevel.trim(),
            studyAreas: data.studyAreas.map((area)=>area.trim()).filter(Boolean),
            city: data.city.trim(),
            nearestOffice: data.nearestOffice.trim(),
            coachingType,
            lookingForCoaching,
            preferredCoaching,
            nearestOfficeRequired: enableB2cNearestOffice,
            counsellorName,
            counsellorEmail,
            counsellorPhone,
            counsellorWhatsapp,
            studentModule,
            partnerUuid,
            countryCfIds,
            degreeLevelCfId,
            studyAreaCfIds
        };
        (0,b2c_prefs/* writeB2cPrefs */._O)(prefs);
        closeWizard();
        window.location.replace("/search");
    }, [
        data,
        closeWizard,
        router,
        wizardOptions,
        enableB2cNearestOffice
    ]);
    const handleFinishRef = react.useRef(handleFinish);
    handleFinishRef.current = handleFinish;
    const autoAdvance = (0,react.useCallback)(()=>{
        setStepping(true);
        setTimeout(()=>{
            if (currentStep === totalSteps) {
                handleFinishRef.current();
            } else {
                nextStep();
                setStepping(false);
            }
        }, 400);
    }, [
        currentStep,
        totalSteps,
        nextStep
    ]);
    // Reset scroll to top on every step change — covers auto-advance, back button, and
    // direct jumps. Scroll both the internal wizard body (modal mode) and the window
    // (page mode) so it works regardless of which scroller is active.
    (0,react.useEffect)(()=>{
        wizardBodyRef.current?.scrollTo({
            top: 0,
            behavior: "auto"
        });
        if (true) {
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
        }
    }, [
        activeStepId
    ]);
    const renderStep = ()=>{
        switch(activeStepId){
            case OnboardingContext/* STEP_IDS.DESTINATION */.Xb.DESTINATION:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_DestinationStep, {
                    selected: data.countries,
                    onSelect: (countries)=>{
                        updateData({
                            countries
                        });
                        if (countries.length > 0) autoAdvance();
                    }
                });
            case OnboardingContext/* STEP_IDS.DEGREE */.Xb.DEGREE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_DegreeStep, {
                    selected: data.degreeLevel,
                    onSelect: (degreeLevel)=>{
                        if (!degreeLevel) return;
                        updateData({
                            degreeLevel
                        });
                        autoAdvance();
                    }
                });
            case OnboardingContext/* STEP_IDS.FIELD_OF_STUDY */.Xb.FIELD_OF_STUDY:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_FieldOfStudyStep, {
                    selected: data.studyAreas,
                    onSelect: (studyAreas)=>{
                        updateData({
                            studyAreas
                        });
                        if (studyAreas.length > 0) autoAdvance();
                    }
                });
            case OnboardingContext/* STEP_IDS.CITY */.Xb.CITY:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_CityStep, {
                    selected: data.city,
                    onSelect: (city)=>{
                        if (!city) return;
                        updateData({
                            city
                        });
                        autoAdvance();
                    }
                });
            case OnboardingContext/* STEP_IDS.NEAREST_OFFICE */.Xb.NEAREST_OFFICE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_NearestOfficeStep, {
                    selected: data.nearestOffice,
                    onSelect: (nearestOffice)=>{
                        if (!nearestOffice) return;
                        updateData({
                            nearestOffice
                        });
                        autoAdvance();
                    }
                });
            case OnboardingContext/* STEP_IDS.COACHING */.Xb.COACHING:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_CoachingStep, {
                    selected: data.coachingType,
                    onSelect: (coachingType)=>{
                        if (!coachingType) return;
                        updateData({
                            coachingType
                        });
                        autoAdvance();
                    }
                });
            default:
                return null;
        }
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OnboardingWizard_module_default()).counsellorLoading
        });
    }
    if (finishError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OnboardingWizard_module_default()).counsellorLoading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OnboardingWizard_module_default()).counsellorLoadingInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OnboardingWizard_module_default()).counsellorLoadingText,
                        children: finishError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (OnboardingWizard_module_default()).backButton,
                        onClick: ()=>{
                            setFinishError("");
                            setStepping(false);
                        },
                        children: "Go back"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).pageWrapper || ""),
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "a1b98613b6315dd",
                children: '[id^="kiwi-"],iframe[id^="kiwi-"]{display:none!important}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).wizardHeader || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: handleBack,
                        "aria-label": "Go back",
                        className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).backButton || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* BackArrowIcon */.pf, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).mobileStepInfo || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).mobileStepTitle || ""),
                                children: STEP_CONFIG[activeStepId]?.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).mobileStepIndicator || ""),
                                children: [
                                    "Step ",
                                    currentStep,
                                    " of ",
                                    totalSteps
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).headerLogo || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* KcLogoSmall */.at, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            closeWizard();
                            if (onClose) onClose();
                            else goBackOrHome();
                        },
                        "aria-label": "Close",
                        className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).closeButton || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* CloseIcon */.Tw, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_ProgressBar, {
                        currentStep: currentStep,
                        totalSteps: totalSteps
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).wizardCard || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).stepHeader || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).stepIndicator || ""),
                                children: [
                                    "Step ",
                                    currentStep,
                                    " of ",
                                    totalSteps
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).stepTitle || ""),
                                children: STEP_CONFIG[activeStepId]?.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: wizardBodyRef,
                        className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).wizardBody || ""),
                        children: [
                            stepping && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).stepOverlay || "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-a1b98613b6315dd" + " " + ((OnboardingWizard_module_default()).stepContent || ""),
                                children: renderStep()
                            }, activeStepId)
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var OnboardingWizard_OnboardingWizard = (OnboardingWizard);


/***/ }),

/***/ 45992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);




const CustomImage = ({ src , width , height , alt , className , layout ="intrinsic" , objectFit , onClick , onError , priority =false , isLazyLoad =true , srcSet , sizes  })=>{
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!priority || !wrapperRef.current) return;
        const tryInject = ()=>{
            const img = wrapperRef.current?.querySelector("img") || wrapperRef.current?.querySelector("span img") || wrapperRef.current?.querySelector("span span img");
            if (img) {
                img.setAttribute("fetchpriority", "high");
            } else {
                // Retry after delay if img not found yet (hydration delay)
                setTimeout(tryInject, 50);
            }
        };
        tryInject();
    }, [
        priority
    ]);
    const image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: src,
        alt: alt,
        layout: layout,
        width: layout !== "fill" ? width : undefined,
        height: layout !== "fill" ? height : undefined,
        objectFit: objectFit,
        onClick: onClick,
        onError: onError,
        priority: priority,
        loading: isLazyLoad ? "lazy" : "eager",
        className: className,
        unoptimized: true,
        fetchpriority: "high",
        sizes: srcSet
    });
    // Only wrap in div if `priority` is true
    if (priority) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: wrapperRef,
            style: layout === "fill" ? {
                position: "relative",
                width: "100%",
                height: "100%"
            } : undefined,
            children: image
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadComponent, {
        children: image
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomImage);


/***/ }),

/***/ 50282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const CustomLink = (props)=>{
    const { data , children  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: data?.href || "/",
        target: data?.target || null,
        "aria-label": props?.alt,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLink);


/***/ }),

/***/ 59833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EnquiryModal_LeadGenForms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/EnquiryModal/EnquiryModal.module.scss
var EnquiryModal_module = __webpack_require__(4079);
var EnquiryModal_module_default = /*#__PURE__*/__webpack_require__.n(EnquiryModal_module);
// EXTERNAL MODULE: ./components/LazyMedia/index.tsx
var LazyMedia = __webpack_require__(37462);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Shimmer/index.tsx
var Shimmer = __webpack_require__(76663);
// EXTERNAL MODULE: ./components/Shimmer/ShimmerItem.tsx
var ShimmerItem = __webpack_require__(90252);
;// CONCATENATED MODULE: ./components/EnquiryModal/InlineFormShimmer.tsx





const InlineFormShimmer = ()=>{
    const router = (0,next_router.useRouter)();
    const isBlogs = (0,react.useMemo)(()=>{
        return router.asPath.includes("/blogs/") || router.asPath.includes("/news/");
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shimmer/* default */.Z, {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "24px",
                width: "100%"
            }, `shimmer-item-1`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "16px",
                width: "50%",
                align: "center"
            }, `shimmer-item-2`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "16px",
                width: "80%",
                align: "center"
            }, `shimmer-item-3`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                className: "mt-4",
                height: "12px",
                width: "25%"
            }, `shimmer-item-4`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "20px",
                width: "100%"
            }, `shimmer-item-5`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                className: "mt-4",
                height: "12px",
                width: "25%"
            }, `shimmer-item-6`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "20px",
                width: "100%"
            }, `shimmer-item-7`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                className: "mt-4",
                height: "12px",
                width: "25%"
            }, `shimmer-item-8`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "20px",
                width: "100%"
            }, `shimmer-item-9`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                className: "mt-4",
                height: "12px",
                width: "25%"
            }, `shimmer-item-10`),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                height: "20px",
                width: "100%"
            }, `shimmer-item-11`),
            isBlogs && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: Array.from({
                    length: 6
                }).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                className: "mt-4",
                                height: "12px",
                                width: "25%"
                            }, `shimmer-item-full-${index}`),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                                height: "20px",
                                width: "100%"
                            }, `shimmer-item-half-${index}`)
                        ]
                    }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShimmerItem/* default */.Z, {
                align: "center",
                className: "mt-4",
                height: "36px",
                width: "150px"
            }, `shimmer-item-12`)
        ]
    });
};
/* harmony default export */ var EnquiryModal_InlineFormShimmer = (InlineFormShimmer);

;// CONCATENATED MODULE: ./components/EnquiryModal/FrappeFormEmbed.tsx
// components/FrappeFormEmbed.tsx





const FrappeFormEmbed = ({ iframeUrl , frappeWrapperClass , mode ="popup" , loader ="spinner" ,  })=>{
    const iframeRef = (0,react.useRef)(null);
    const { 0: isLoading , 1: setIsLoading  } = (0,react.useState)(true);
    const { 0: encodedUrl , 1: setEncodedUrl  } = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        // This runs only on the client side
        const currentUrl = window.location.href;
        const encoded = encodeURIComponent(currentUrl);
        setEncodedUrl(encoded);
    }, []);
    const handleOnIframeLoad = ()=>{
        setTimeout(()=>setIsLoading(false), 100);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (EnquiryModal_module_default()).loaderBackground,
                children: [
                    loader === "spinner" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (EnquiryModal_module_default()).spinner
                    }),
                    loader === "shimmer" && /*#__PURE__*/ (0,jsx_runtime.jsx)(EnquiryModal_InlineFormShimmer, {})
                ]
            }),
            mode === "popup" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                title: "Form submission",
                src: `${iframeUrl}/new?source_url=${encodedUrl}`,
                width: "100%",
                className: `${(EnquiryModal_module_default()).iframe} ${frappeWrapperClass}`,
                onLoad: handleOnIframeLoad
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                loader: "shimmer",
                src: `${iframeUrl}/new?source_url=${encodedUrl}`,
                width: "100%",
                iframeClassName: `${(EnquiryModal_module_default()).iframe} ${frappeWrapperClass}`,
                onLoad: handleOnIframeLoad
            })
        ]
    });
};
/* harmony default export */ var EnquiryModal_FrappeFormEmbed = (FrappeFormEmbed);

;// CONCATENATED MODULE: ./components/EnquiryModal/LeadGenForms.tsx




const LeadGenForms = ({ type ="frappe" , url , wrapperClass , mode ="popup" , loader ="spinner" , setHeight , onClose  })=>{
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const onMessage = (event)=>{
            if (event.data?.eventName === "HEIGHT_UPDATE" && typeof event.data.iframeHeight === "number") {
                setHeight?.(event.data.iframeHeight);
            }
            if (event.data.type === "FRAPPE_HEIGHT" && typeof event.data.height === "number") {
                setHeight?.(event.data.height);
            }
            if (event.data?.eventName === "FORM_SAVED") {
                if (event?.data?.formData) {
                    sessionStorage.setItem("formData", JSON.stringify(event?.data?.formData));
                }
                if (router.asPath.includes("/student-services/education-loan-for-overseas-education")) {
                    window.open("https://www.elanloans.com/thankyou?msg=success", "_blank");
                } else if (router.asPath.includes("/entrepreneur/franchise-proposal")) {
                    window.open("https://www.studiesabroadfranchisee.com/thankyou", "_blank");
                } else {
                    window.location.href = window.location.origin + "/thank-you";
                }
                onClose?.();
            }
        };
        window.addEventListener("message", onMessage);
        return ()=>window.removeEventListener("message", onMessage);
    }, []);
    if (type === "frappe") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EnquiryModal_FrappeFormEmbed, {
            iframeUrl: url,
            frappeWrapperClass: wrapperClass,
            mode: mode,
            loader: loader
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "Form type not found."
    });
};
/* harmony default export */ var EnquiryModal_LeadGenForms = (LeadGenForms);


/***/ }),

/***/ 37462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyMedia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _LazyMedia_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31878);
/* harmony import */ var _LazyMedia_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LazyMedia_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Shimmer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76663);
/* harmony import */ var _Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90252);
"use client";


 // 👈 import spinner styles


function LazyMedia({ src , tag ="iframe" , title ="Embedded Content" , type ="application/pdf" , height , width , className ="" , rounded =true , embedClassName ="" , allowFullScreen =true , allow ="" , iframeClassName ="" , onLoad =()=>{} , loader ="spinner"  }) {
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: isVisible , 1: setIsVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: "30px"
        });
        if (containerRef.current) observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, []);
    const containerStyle = {};
    if (height) {
        containerStyle.height = height;
        containerStyle.minHeight = height;
    }
    if (width) {
        containerStyle.width = width;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: containerRef,
        style: containerStyle,
        className: `w-100 h-100 ${className}`,
        children: isVisible ? tag === "iframe" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            src: src,
            title: title,
            width: "100%",
            height: "100%",
            style: {
                border: 0,
                minHeight: height || "100%"
            },
            loading: "lazy",
            allowFullScreen: allowFullScreen,
            className: `${rounded ? "rounded" : ""} ${iframeClassName}`,
            allow: allow,
            onLoad: onLoad
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("embed", {
            src: src,
            type: type,
            width: "100%",
            height: "100%",
            className: `${rounded ? "rounded" : ""} ${embedClassName}`
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `d-flex justify-content-center align-items-center h-100 ${rounded ? "rounded" : ""}`,
            style: {
                backgroundColor: "#f8f9fa"
            },
            children: [
                loader === "spinner" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_LazyMedia_module_scss__WEBPACK_IMPORTED_MODULE_4___default().spinner)
                }),
                " ",
                loader === "shimmer" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Shimmer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            height: "24px",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            height: "16px",
                            width: "50%",
                            align: "center"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            height: "16px",
                            width: "80%",
                            align: "center"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "mt-4",
                            height: "16px",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            height: "20px",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            height: "20px",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shimmer_ShimmerItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            height: "20px",
                            width: "100%"
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 90252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShimmerItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Shimmer_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71763);
/* harmony import */ var _Shimmer_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Shimmer_module_scss__WEBPACK_IMPORTED_MODULE_2__);
"use client";



function ShimmerItem({ height ="100px" , width ="100%" , rounded =false , className ="" , align ="start"  }) {
    const style = {
        height,
        width,
        alignSelf: align === "start" ? "flex-start" : align === "center" ? "center" : align === "end" ? "flex-end" : "stretch"
    };
    let roundedClass = "";
    if (rounded === true) roundedClass = "rounded-pill"; // bootstrap pill
    else if (typeof rounded === "string") roundedClass = `rounded-${rounded}`; // e.g. rounded-lg, rounded-circle
    else if (rounded === false) roundedClass = ""; // square
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_Shimmer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().shimmer)} ${roundedClass} ${className}`,
        style: style
    });
}


/***/ }),

/***/ 76663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Shimmer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


function Shimmer({ children , gap ="1rem" , direction ="column" , align ="start" , justify ="start" , className =""  }) {
    const justifyMap = {
        start: "justify-content-start",
        center: "justify-content-center",
        end: "justify-content-end",
        between: "justify-content-between",
        around: "justify-content-around",
        evenly: "justify-content-evenly"
    };
    const alignMap = {
        start: "align-items-start",
        center: "align-items-center",
        end: "align-items-end",
        stretch: "align-items-stretch"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `d-flex flex-${direction} ${justifyMap[justify]} ${alignMap[align]} ${className} w-100 h-100`,
        style: {
            gap
        },
        children: children
    });
}


/***/ }),

/***/ 33434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Accordion_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/UI/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(27842);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
;// CONCATENATED MODULE: ./components/UI/Icons/ArrowCircle.tsx


const ArrowCircle = ({ width =20 , height =20 , color ="#868697"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 7L6 11L14 11L10 7ZM10 -8.74228e-07C11.3833 -7.53293e-07 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.787501 13.9C0.262501 12.6833 7.53293e-07 11.3833 8.74228e-07 10C9.95163e-07 8.61667 0.262502 7.31666 0.787502 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.787499C7.31667 0.2625 8.61667 -9.95163e-07 10 -8.74228e-07ZM10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76666 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z",
            fill: color
        })
    });
};
/* harmony default export */ var Icons_ArrowCircle = (ArrowCircle);

;// CONCATENATED MODULE: ./components/UI/Accordion/Accordion.tsx




const Accordion = ({ items , defaultOpenIndex =0 , theme ="base" , icon ="plus" , titleStyles , contentStyles , accordionItemStyles  })=>{
    const { 0: activeIndex , 1: setActiveIndex  } = (0,react.useState)(defaultOpenIndex);
    const handleToggle = (index)=>{
        setActiveIndex(activeIndex === index ? -1 : index);
    };
    const themeClass = theme === "card" ? (Accordion_module_default())["accordion--card"] : (Accordion_module_default())["accordion--base"];
    const renderIcon = (isOpen)=>{
        switch(icon){
            case "plus":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Accordion_module_default())["accordion-toggle"],
                    children: isOpen ? "−" : "+"
                });
            case "chevron":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: `${(Accordion_module_default())["accordion-icon"]} ${isOpen ? (Accordion_module_default())["accordion-icon--open"] : ""}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "12",
                        height: "8",
                        viewBox: "0 0 12 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M1 1.5L6 6.5L11 1.5",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                });
            case "chevron-circle":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: `${(Accordion_module_default())["accordion-icon"]} ${isOpen ? (Accordion_module_default())["accordion-icon--open"] : ""}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowCircle, {})
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(Accordion_module_default()).accordion} ${themeClass}`,
        children: items.map((item, index)=>{
            const isOpen = activeIndex === index;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: accordionItemStyles,
                className: `${(Accordion_module_default())["accordion-item"]} ${isOpen ? (Accordion_module_default())["accordion-item--active"] : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (Accordion_module_default())["accordion-header"],
                        onClick: ()=>handleToggle(index),
                        "aria-expanded": isOpen,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: titleStyles,
                                className: (Accordion_module_default())["accordion-title"],
                                children: item.title
                            }),
                            renderIcon(isOpen)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(Accordion_module_default())["accordion-body"]} ${isOpen ? (Accordion_module_default())["accordion-body--open"] : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: contentStyles,
                            className: (Accordion_module_default())["accordion-content"],
                            children: item?.description ?? ""
                        })
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var Accordion_Accordion = (Accordion);


/***/ }),

/***/ 91863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ FALLBACK_COUNTRIES; },
/* harmony export */   "F1": function() { return /* binding */ FALLBACK_NEAREST_OFFICES; },
/* harmony export */   "Vr": function() { return /* binding */ FALLBACK_STUDY_AREAS; },
/* harmony export */   "WP": function() { return /* binding */ FALLBACK_CITIES; }
/* harmony export */ });
/* unused harmony export DEGREE_ICON_MAP */
// Last-resort fallbacks used when the CMS / Frappe source returns empty.
// Keeps the wizard usable during outages; CMS data still wins when available.
// Snapshot of CMS pref-countries-lists (sortOrder ASC) as of 2026-05-15.
const FALLBACK_COUNTRIES = [
    {
        cfId: 1,
        name: "United States",
        imageUrl: "https://assets.studies-overseas.com/usaflag_d54c445770.svg"
    },
    {
        cfId: 2,
        name: "Australia",
        imageUrl: "https://assets.studies-overseas.com/australiaflag_3d98752af7.svg"
    },
    {
        cfId: 3,
        name: "Canada",
        imageUrl: "https://assets.studies-overseas.com/canada_a566b56bf5.svg"
    },
    {
        cfId: 4,
        name: "United Kingdom",
        imageUrl: "https://assets.studies-overseas.com/unitedkingdom_64a4833290.svg"
    },
    {
        cfId: 5,
        name: "New Zealand",
        imageUrl: "https://assets.studies-overseas.com/newzealand_a09e3fae3c.svg"
    },
    {
        cfId: 6,
        name: "Singapore",
        imageUrl: "https://flagcdn.com/sg.svg"
    },
    {
        cfId: 7,
        name: "United Arab Emirates",
        imageUrl: "https://flagcdn.com/ae.svg"
    },
    {
        name: "Europe",
        imageUrl: "https://assets.studies-overseas.com/europeanunion_9c5873e410.svg"
    },
    {
        cfId: 8,
        name: "Ireland",
        imageUrl: "https://assets.studies-overseas.com/irelands_b8599fe6d4.svg"
    },
    {
        name: "Asia",
        imageUrl: "https://assets.studies-overseas.com/Dubai_Flag_dd19eef948.jpg"
    },
    {
        cfId: 9,
        name: "Germany",
        imageUrl: "https://flagcdn.com/de.svg"
    },
    {
        name: "Turkey",
        imageUrl: "https://flagcdn.com/tr.svg"
    },
    {
        cfId: 10,
        name: "France",
        imageUrl: "https://flagcdn.com/fr.svg"
    },
    {
        cfId: 11,
        name: "Sweden",
        imageUrl: "https://flagcdn.com/se.svg"
    },
    {
        cfId: 12,
        name: "Netherlands",
        imageUrl: "https://flagcdn.com/nl.svg"
    },
    {
        cfId: 13,
        name: "Austria",
        imageUrl: "https://flagcdn.com/at.svg"
    },
    {
        cfId: 14,
        name: "Denmark",
        imageUrl: "https://flagcdn.com/dk.svg"
    },
    {
        cfId: 15,
        name: "Finland",
        imageUrl: "https://flagcdn.com/fi.svg"
    },
    {
        cfId: 16,
        name: "Italy",
        imageUrl: "https://flagcdn.com/it.svg"
    },
    {
        cfId: 17,
        name: "Hungary",
        imageUrl: "https://flagcdn.com/hu.svg"
    },
    {
        cfId: 18,
        name: "Switzerland",
        imageUrl: "https://flagcdn.com/ch.svg"
    },
    {
        cfId: 19,
        name: "Spain",
        imageUrl: "https://flagcdn.com/es.svg"
    },
    {
        cfId: 20,
        name: "Lithuania",
        imageUrl: "https://flagcdn.com/lt.svg"
    },
    {
        cfId: 21,
        name: "Latvia",
        imageUrl: "https://flagcdn.com/lv.svg"
    },
    {
        cfId: 22,
        name: "Cyprus",
        imageUrl: "https://flagcdn.com/cy.svg"
    },
    {
        cfId: 23,
        name: "Poland",
        imageUrl: "https://flagcdn.com/pl.svg"
    },
    {
        cfId: 24,
        name: "Czech Republic",
        imageUrl: "https://flagcdn.com/cz.svg"
    },
    {
        cfId: 25,
        name: "Malaysia",
        imageUrl: "https://flagcdn.com/my.svg"
    },
    {
        cfId: 26,
        name: "Mauritius",
        imageUrl: "https://flagcdn.com/mu.svg"
    },
    {
        cfId: 27,
        name: "South Africa",
        imageUrl: "https://flagcdn.com/za.svg"
    },
    {
        cfId: 28,
        name: "Hong Kong",
        imageUrl: "https://flagcdn.com/hk.svg"
    },
    {
        cfId: 32,
        name: "China",
        imageUrl: "https://flagcdn.com/cn.svg"
    },
    {
        cfId: 33,
        name: "Bulgaria",
        imageUrl: "https://flagcdn.com/bg.svg"
    },
    {
        cfId: 35,
        name: "Vietnam",
        imageUrl: "https://flagcdn.com/vn.svg"
    },
    {
        cfId: 37,
        name: "Malta",
        imageUrl: "https://flagcdn.com/mt.svg"
    },
    {
        cfId: 38,
        name: "Japan",
        imageUrl: "https://flagcdn.com/jp.svg"
    },
    {
        cfId: 39,
        name: "Belgium",
        imageUrl: "https://flagcdn.com/be.svg"
    },
    {
        cfId: 40,
        name: "Russia",
        imageUrl: "https://flagcdn.com/ru.svg"
    },
    {
        cfId: 41,
        name: "South Korea",
        imageUrl: "https://flagcdn.com/kr.svg"
    },
    {
        cfId: 89,
        name: "India",
        imageUrl: "https://flagcdn.com/in.svg"
    },
    {
        cfId: 110,
        name: "Indonesia",
        imageUrl: "https://flagcdn.com/id.svg"
    },
    {
        cfId: 46,
        name: "Georgia",
        imageUrl: "https://flagcdn.com/ge.svg"
    },
    {
        cfId: 94,
        name: "Zimbabwe",
        imageUrl: "https://flagcdn.com/zw.svg"
    }, 
];
// Snapshot of CMS pref-study-areas (sortOrder ASC) as of 2026-05-15.
const FALLBACK_STUDY_AREAS = [
    {
        cfId: 1,
        label: "Agriculture, Forestry and Fishery"
    },
    {
        cfId: 2,
        label: "Architecture and Building"
    },
    {
        cfId: 3,
        label: "Arts"
    },
    {
        cfId: 4,
        label: "Commerce, Business and Administration"
    },
    {
        cfId: 5,
        label: "Computer Science and Information Technology"
    },
    {
        cfId: 6,
        label: "Education"
    },
    {
        cfId: 7,
        label: "Engineering and Engineering Trades"
    },
    {
        cfId: 8,
        label: "Environmental Science/Protection"
    },
    {
        cfId: 9,
        label: "Health"
    },
    {
        cfId: 10,
        label: "Humanities"
    },
    {
        cfId: 11,
        label: "Journalism and Information"
    },
    {
        cfId: 12,
        label: "Law"
    },
    {
        cfId: 13,
        label: "Life Sciences"
    },
    {
        cfId: 14,
        label: "Manufacturing and Processing"
    },
    {
        cfId: 15,
        label: "Mathematics and Statistics"
    },
    {
        cfId: 16,
        label: "Personal Services"
    },
    {
        cfId: 17,
        label: "Physical Sciences, Sciences"
    },
    {
        cfId: 18,
        label: "Security Services"
    },
    {
        cfId: 19,
        label: "Social and Behavioural Science"
    },
    {
        cfId: 20,
        label: "Social Services"
    },
    {
        cfId: 21,
        label: "Transport Services"
    },
    {
        cfId: 22,
        label: "Veterinary"
    }, 
];
// Fallback city list for the wizard "Which city do you live in?" step.
// Used only when Frappe `get_cities_for_b2c` returns empty or fails.
// Refresh manually by re-syncing from product's master list.
const FALLBACK_CITIES = [
    {
        label: "Achalpur"
    },
    {
        label: "Adilabad"
    },
    {
        label: "Agra"
    },
    {
        label: "Ahilyanagar"
    },
    {
        label: "Ahmedabad"
    },
    {
        label: "Ahmednagar"
    },
    {
        label: "Akola"
    },
    {
        label: "Akurdi"
    },
    {
        label: "Alappuzha"
    },
    {
        label: "Allahabad"
    },
    {
        label: "Amarkantak"
    },
    {
        label: "Amravati"
    },
    {
        label: "Amritsar"
    },
    {
        label: "Anand"
    },
    {
        label: "Anantapur"
    },
    {
        label: "Aurangabad"
    },
    {
        label: "Badnera"
    },
    {
        label: "Balaghat"
    },
    {
        label: "Balco"
    },
    {
        label: "Balharshah"
    },
    {
        label: "Ballarpur"
    },
    {
        label: "Bangalore"
    },
    {
        label: "Bareilli"
    },
    {
        label: "Beed"
    },
    {
        label: "Belgaum"
    },
    {
        label: "Betul"
    },
    {
        label: "Bhadravati"
    },
    {
        label: "Bhandara"
    },
    {
        label: "Bhatapara"
    },
    {
        label: "Bhavnagar"
    },
    {
        label: "Bhilai"
    },
    {
        label: "Bhopal"
    },
    {
        label: "Bhubaneshwar"
    },
    {
        label: "Bhusawal"
    },
    {
        label: "Bilaspur"
    },
    {
        label: "Buldhana"
    },
    {
        label: "Calicut"
    },
    {
        label: "Ch. Sambhajinagar"
    },
    {
        label: "Champa"
    },
    {
        label: "Chandigarh"
    },
    {
        label: "Chandpur"
    },
    {
        label: "Chandrapur"
    },
    {
        label: "Chennai"
    },
    {
        label: "Chhindwara"
    },
    {
        label: "Chimur"
    },
    {
        label: "Chittoor"
    },
    {
        label: "Chittorgarh"
    },
    {
        label: "Coimbatore"
    },
    {
        label: "Daryapur Banosa"
    },
    {
        label: "Dehradun"
    },
    {
        label: "Delhi"
    },
    {
        label: "Dhule"
    },
    {
        label: "Dungarpur"
    },
    {
        label: "Durg"
    },
    {
        label: "Edakkara"
    },
    {
        label: "Ernakulam"
    },
    {
        label: "Faridabad"
    },
    {
        label: "Gadchiroli"
    },
    {
        label: "Gandhinagar"
    },
    {
        label: "Ghaziabad"
    },
    {
        label: "Ghugus"
    },
    {
        label: "Goa"
    },
    {
        label: "Gondia"
    },
    {
        label: "Greater Noida"
    },
    {
        label: "Guntur"
    },
    {
        label: "Gurugram"
    },
    {
        label: "Gwalior"
    },
    {
        label: "Hanamkonda"
    },
    {
        label: "Haridwar"
    },
    {
        label: "Hinganghat"
    },
    {
        label: "Hubli"
    },
    {
        label: "Hyderabad"
    },
    {
        label: "Idukki"
    },
    {
        label: "Indore"
    },
    {
        label: "Jabalpur"
    },
    {
        label: "Jaipur"
    },
    {
        label: "Jalandhar"
    },
    {
        label: "Jalgaon"
    },
    {
        label: "Jalna"
    },
    {
        label: "Jammu"
    },
    {
        label: "Jamnipali"
    },
    {
        label: "Jodhpur"
    },
    {
        label: "Kadappa"
    },
    {
        label: "Kaithal"
    },
    {
        label: "Kakinada"
    },
    {
        label: "Kancheepuram"
    },
    {
        label: "Kannur"
    },
    {
        label: "Kanpur"
    },
    {
        label: "Kanyakumari"
    },
    {
        label: "Karanja"
    },
    {
        label: "Karimnagar"
    },
    {
        label: "Karnal"
    },
    {
        label: "Kasargod"
    },
    {
        label: "Kathmandu"
    },
    {
        label: "Katni"
    },
    {
        label: "Katol"
    },
    {
        label: "Khamgaon"
    },
    {
        label: "Khammam"
    },
    {
        label: "Kochi"
    },
    {
        label: "Kolhapur"
    },
    {
        label: "Kolkata"
    },
    {
        label: "Kollam"
    },
    {
        label: "Korba"
    },
    {
        label: "Kota"
    },
    {
        label: "Kottayam"
    },
    {
        label: "Kozhikode"
    },
    {
        label: "Kurnool"
    },
    {
        label: "Lahore"
    },
    {
        label: "Latur"
    },
    {
        label: "Lucknow"
    },
    {
        label: "Ludhiana"
    },
    {
        label: "Madurai"
    },
    {
        label: "Malegaon"
    },
    {
        label: "Mangalore"
    },
    {
        label: "Mapusa"
    },
    {
        label: "Margaon"
    },
    {
        label: "Medchal"
    },
    {
        label: "Meerut"
    },
    {
        label: "Mehkar"
    },
    {
        label: "Moga"
    },
    {
        label: "Mohali"
    },
    {
        label: "Mul"
    },
    {
        label: "Mumbai"
    },
    {
        label: "Murtizapur"
    },
    {
        label: "Mysore"
    },
    {
        label: "Nagarcoil"
    },
    {
        label: "Nagpur"
    },
    {
        label: "Nagpur-IT Park (Branch)"
    },
    {
        label: "Nagpur-Sadar (Branch)"
    },
    {
        label: "Namakkal"
    },
    {
        label: "Nanded"
    },
    {
        label: "Nandurbar"
    },
    {
        label: "Nashik"
    },
    {
        label: "Navi Mumbai"
    },
    {
        label: "Nellore"
    },
    {
        label: "Nizamabad"
    },
    {
        label: "Noida"
    },
    {
        label: "Osmanabad"
    },
    {
        label: "Other"
    },
    {
        label: "Palakkad"
    },
    {
        label: "Palghar"
    },
    {
        label: "Panipat"
    },
    {
        label: "Panjim"
    },
    {
        label: "Panvel"
    },
    {
        label: "Paratwada"
    },
    {
        label: "Parbhani"
    },
    {
        label: "Pathanamthitta"
    },
    {
        label: "Patiala"
    },
    {
        label: "Patna"
    },
    {
        label: "Pimpri-Chinchwad"
    },
    {
        label: "Pokhara"
    },
    {
        label: "Pondicherry"
    },
    {
        label: "Pulgaon"
    },
    {
        label: "Pune"
    },
    {
        label: "Pusad"
    },
    {
        label: "Raigarh"
    },
    {
        label: "Raipur"
    },
    {
        label: "Rajahmundry"
    },
    {
        label: "Rajkot"
    },
    {
        label: "Rajura"
    },
    {
        label: "Ramtek"
    },
    {
        label: "Ranchi"
    },
    {
        label: "Rohtak"
    },
    {
        label: "Sagar"
    },
    {
        label: "Salem"
    },
    {
        label: "Satna"
    },
    {
        label: "Secunderabad"
    },
    {
        label: "Shegaon"
    },
    {
        label: "Silchar"
    },
    {
        label: "Sillod"
    },
    {
        label: "Sindewahi"
    },
    {
        label: "Solapur"
    },
    {
        label: "Sri Ganganagar"
    },
    {
        label: "Srinagar"
    },
    {
        label: "Sultanpur Lodhi"
    },
    {
        label: "Surat"
    },
    {
        label: "Suryapet"
    },
    {
        label: "Thane"
    },
    {
        label: "Thiruvananthapuram"
    },
    {
        label: "Thrissur"
    },
    {
        label: "Tiruchirappalli"
    },
    {
        label: "Tirupati"
    },
    {
        label: "Trivandrum"
    },
    {
        label: "Udaipur"
    },
    {
        label: "Ujjain"
    },
    {
        label: "Umred"
    },
    {
        label: "Umthatha"
    },
    {
        label: "Vadodara"
    },
    {
        label: "Valsad"
    },
    {
        label: "Vapi"
    },
    {
        label: "Vellore"
    },
    {
        label: "Vijayawada"
    },
    {
        label: "Visakhapatnam"
    },
    {
        label: "Wani"
    },
    {
        label: "Warangal"
    },
    {
        label: "Wardha"
    },
    {
        label: "Warora"
    },
    {
        label: "Warud"
    },
    {
        label: "Washim"
    },
    {
        label: "Yavatmal"
    }, 
];
// Fallback office list for the wizard "Nearest Office" step.
// Used only when Frappe `get_offices_for_b2c` returns empty or fails.
// Refresh manually by re-snapshotting from Frappe `KC Offices`.
const FALLBACK_NEAREST_OFFICES = [
    {
        label: "Ahmedabad (Navrangpura)"
    },
    {
        label: "Amravati"
    },
    {
        label: "Amritsar"
    },
    {
        label: "Bathinda"
    },
    {
        label: "Bengaluru"
    },
    {
        label: "Bharuch"
    },
    {
        label: "Bhopal"
    },
    {
        label: "Calicut"
    },
    {
        label: "Ch. Sambhajinagar"
    },
    {
        label: "Chandigarh"
    },
    {
        label: "Chennai (Velachery)"
    },
    {
        label: "Chitradurga"
    },
    {
        label: "Coimbatore"
    },
    {
        label: "Colombo"
    },
    {
        label: "Delhi (Patel Nagar)"
    },
    {
        label: "Delhi (Rohini)"
    },
    {
        label: "Dhaka"
    },
    {
        label: "Ghaziabad"
    },
    {
        label: "Goa"
    },
    {
        label: "Guntur"
    },
    {
        label: "Gurugram (Golf Course Extension Road)"
    },
    {
        label: "Gurugram (Sushant Lok)"
    },
    {
        label: "Hisar"
    },
    {
        label: "Hyderabad (Dilsukhnagar)"
    },
    {
        label: "Hyderabad (Himayatnagar)"
    },
    {
        label: "Hyderabad (SR Nagar)"
    },
    {
        label: "Jabalpur"
    },
    {
        label: "Jaipur"
    },
    {
        label: "Jalandhar"
    },
    {
        label: "Jammu"
    },
    {
        label: "Karnal"
    },
    {
        label: "Kochi (Pullepady)"
    },
    {
        label: "Kollam"
    },
    {
        label: "Kottayam"
    },
    {
        label: "Ludhiana"
    },
    {
        label: "Madurai"
    },
    {
        label: "Mysuru"
    },
    {
        label: "Nagpur (IT Park)"
    },
    {
        label: "Nagpur (Sadar)"
    },
    {
        label: "Namakkal"
    },
    {
        label: "Nashik"
    },
    {
        label: "Noida"
    },
    {
        label: "Panipat"
    },
    {
        label: "Pathankot"
    },
    {
        label: "Patiala"
    },
    {
        label: "Puducherry"
    },
    {
        label: "Pune (Viman Nagar)"
    },
    {
        label: "Raipur"
    },
    {
        label: "Rajahmundry"
    },
    {
        label: "Rajkot"
    },
    {
        label: "Sangrur"
    },
    {
        label: "Surat"
    },
    {
        label: "Thrissur"
    },
    {
        label: "Trivandrum"
    },
    {
        label: "Vadodara"
    },
    {
        label: "Visakhapatnam"
    },
    {
        label: "Visnagar"
    },
    {
        label: "Wayanad"
    }, 
];
// Fallback icon lookup used only when an option lacks `imageUrl` (e.g. CMS-driven
// entries). Earlier entries win.
const DEGREE_ICON_MAP = [
    {
        match: (option)=>option.cfId === 1,
        icon: "/icons/degree/workspace_premium.svg"
    },
    {
        match: (option)=>option.cfId === 2,
        icon: "/icons/degree/account_balance.svg"
    },
    {
        match: (option)=>option.cfId === 3,
        icon: "/icons/degree/cognition_2.svg"
    },
    {
        match: (option)=>option.cfId === 4,
        icon: "/icons/degree/description.svg"
    },
    {
        match: (option)=>option.cfId === 5,
        icon: "/icons/degree/description.svg"
    },
    {
        match: (option)=>option.cfId === 8,
        icon: "/icons/degree/school.svg"
    },
    {
        match: (option)=>option.cfId === 9,
        icon: "/icons/degree/wb_sunny.svg"
    },
    {
        match: (option)=>option.cfId === 10,
        icon: "/icons/degree/school.svg"
    },
    {
        match: (option)=>option.cfId === 11,
        icon: "/icons/degree/bolt.svg"
    },
    {
        match: (option)=>option.cfId === 12,
        icon: "/icons/degree/partner_exchange_ug.svg"
    },
    {
        match: (option)=>option.cfId === 13,
        icon: "/icons/degree/partner_exchange_pg.svg"
    },
    {
        match: (option)=>option.cfId === 19,
        icon: "/icons/degree/dictionary.svg"
    },
    {
        match: (option)=>option.cfId === 20,
        icon: "/icons/degree/alt_route_ug.svg"
    },
    {
        match: (option)=>option.cfId === 21,
        icon: "/icons/degree/alt_route_pg.svg"
    },
    {
        match: (option)=>option.cfId === 22,
        icon: "/icons/degree/social_distance.svg"
    },
    {
        match: (option)=>/undergraduate/i.test(option.label),
        icon: "/icons/degree/workspace_premium.svg"
    },
    {
        match: (option)=>/postgraduate|masters/i.test(option.label),
        icon: "/icons/degree/account_balance.svg"
    },
    {
        match: (option)=>/\bphd\b/i.test(option.label),
        icon: "/icons/degree/cognition_2.svg"
    },
    {
        match: (option)=>/high school|grades below/i.test(option.label),
        icon: "/icons/degree/school.svg"
    },
    {
        match: (option)=>/ug\+pg|accelerated/i.test(option.label),
        icon: "/icons/degree/bolt.svg"
    },
    {
        match: (option)=>/short.?term|summer program/i.test(option.label),
        icon: "/icons/degree/wb_sunny.svg"
    },
    {
        match: (option)=>/pathway/i.test(option.label) && /\(ug\)/i.test(option.label),
        icon: "/icons/degree/alt_route_ug.svg"
    },
    {
        match: (option)=>/pathway/i.test(option.label) && /\(pg\)/i.test(option.label),
        icon: "/icons/degree/alt_route_pg.svg"
    },
    {
        match: (option)=>/pathway/i.test(option.label),
        icon: "/icons/degree/alt_route_ug.svg"
    },
    {
        match: (option)=>/semester.*abroad|study abroad/i.test(option.label),
        icon: "/icons/degree/social_distance.svg"
    },
    {
        match: (option)=>/twinning/i.test(option.label) && /\(ug\)/i.test(option.label),
        icon: "/icons/degree/partner_exchange_ug.svg"
    },
    {
        match: (option)=>/twinning/i.test(option.label) && /\(pg\)/i.test(option.label),
        icon: "/icons/degree/partner_exchange_pg.svg"
    },
    {
        match: (option)=>/twinning/i.test(option.label),
        icon: "/icons/degree/partner_exchange_ug.svg"
    },
    {
        match: (option)=>/english language/i.test(option.label),
        icon: "/icons/degree/dictionary.svg"
    },
    {
        match: (option)=>/online|distance/i.test(option.label),
        icon: "/icons/degree/devices.svg"
    },
    {
        match: (option)=>/hybrid/i.test(option.label),
        icon: "/icons/degree/split_scene.svg"
    },
    {
        match: (option)=>/diploma|certificate/i.test(option.label),
        icon: "/icons/degree/description.svg"
    }, 
];


/***/ }),

/***/ 22186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xb": function() { return /* binding */ STEP_IDS; },
/* harmony export */   "kc": function() { return /* binding */ useOnboarding; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const STEP_IDS = {
    DESTINATION: 1,
    DEGREE: 2,
    FIELD_OF_STUDY: 3,
    CITY: 4,
    NEAREST_OFFICE: 5,
    COACHING: 6
};
const ALL_STEPS = [
    STEP_IDS.DESTINATION,
    STEP_IDS.DEGREE,
    STEP_IDS.FIELD_OF_STUDY,
    STEP_IDS.CITY,
    STEP_IDS.NEAREST_OFFICE,
    STEP_IDS.COACHING, 
];
const defaultData = {
    countries: [],
    degreeLevel: "",
    studyAreas: [],
    city: "",
    nearestOffice: "",
    needLoan: "",
    coachingType: "",
    franchiseeUuid: "",
    counsellorId: ""
};
const OnboardingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
const useOnboarding = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(OnboardingContext);
    if (!context) {
        throw new Error("useOnboarding must be used within OnboardingProvider");
    }
    return context;
};
const OnboardingProvider = ({ children  })=>{
    const { 0: isOpen , 1: setIsOpen  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: currentStep , 1: setCurrentStep  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const { 0: data , 1: setData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultData);
    const { 0: enableB2cNearestOffice , 1: setEnableB2cNearestOffice  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const { 0: enableB2cCoaching , 1: setEnableB2cCoaching  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const { 0: mode , 1: setMode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("page");
    const activeSteps = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>ALL_STEPS.filter((id)=>{
            if (id === STEP_IDS.NEAREST_OFFICE) return enableB2cNearestOffice;
            if (id === STEP_IDS.COACHING) return enableB2cCoaching;
            return true;
        }), [
        enableB2cNearestOffice,
        enableB2cCoaching
    ]);
    const totalSteps = activeSteps.length;
    const activeStepId = activeSteps[currentStep - 1] ?? STEP_IDS.DESTINATION;
    const openWizard = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((config)=>{
        setEnableB2cNearestOffice(config?.enableB2cNearestOffice ?? true);
        setEnableB2cCoaching(config?.enableB2cCoaching ?? true);
        setMode(config?.mode ?? "page");
        setIsOpen(true);
        setCurrentStep(1);
        setData(defaultData);
    }, []);
    const closeWizard = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setIsOpen(false);
        setCurrentStep(1);
    }, []);
    const nextStep = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setCurrentStep((prev)=>Math.min(prev + 1, totalSteps));
    }, [
        totalSteps
    ]);
    const prevStep = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setCurrentStep((prev)=>Math.max(prev - 1, 1));
    }, []);
    const updateData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((partial)=>{
        setData((prev)=>({
                ...prev,
                ...partial
            }));
    }, []);
    const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            isOpen,
            currentStep,
            totalSteps,
            activeStepId,
            data,
            mode,
            enableB2cNearestOffice,
            enableB2cCoaching,
            openWizard,
            closeWizard,
            nextStep,
            prevStep,
            updateData
        }), [
        isOpen,
        currentStep,
        totalSteps,
        activeStepId,
        data,
        mode,
        enableB2cNearestOffice,
        enableB2cCoaching,
        openWizard,
        closeWizard,
        nextStep,
        prevStep,
        updateData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OnboardingContext.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (OnboardingProvider);


/***/ }),

/***/ 25174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ WizardOptionsProvider; },
  "s": function() { return /* binding */ useWizardOptions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/onboardingFallbacks.ts
var onboardingFallbacks = __webpack_require__(91863);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
// EXTERNAL MODULE: ./utils/b2c/programLevelConstants.ts
var programLevelConstants = __webpack_require__(45984);
;// CONCATENATED MODULE: ./utils/wizardOptionsApi.ts



const API_BASE = "https://cms-staging.studies-overseas.com";
const RETRY_BACKOFF_MS = 500;
// One retry catches transient CMS/Frappe timeouts (the biggest cause of an empty
// wizard list). Anything beyond that is real downtime — let the static fallback
// in fetchWizardOptions take over.
async function fetchWithRetry(url, init) {
    for(let attempt = 0; attempt < 2; attempt++){
        try {
            const res = await fetch(url, init);
            if (res.ok) return res;
        } catch (error) {
            if (attempt === 1) {
                console.error("[wizardOptionsApi] fetch failed after retry:", url, error);
            }
        }
        if (attempt === 0) await new Promise((resolve)=>setTimeout(resolve, RETRY_BACKOFF_MS));
    }
    return null;
}
function parseCfId(value) {
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === "string") {
        const parsed = Number(value);
        if (Number.isFinite(parsed)) return parsed;
    }
    return undefined;
}
function getRawCfId(raw) {
    return parseCfId(raw?.cfId) ?? parseCfId(raw?.cf_id) ?? parseCfId(raw?.courseFinderId) ?? parseCfId(raw?.course_finder_id);
}
function mapCountry(raw) {
    return {
        cfId: getRawCfId(raw),
        name: raw.name || "",
        imageUrl: raw.imageUrl || undefined,
        imageAltTag: raw.imageAltTag || undefined
    };
}
function mapOption(raw) {
    return {
        cfId: getRawCfId(raw),
        label: raw.label || raw.name || "",
        imageUrl: raw.imageUrl || undefined,
        imageAltTag: raw.imageAltTag || undefined
    };
}
async function fetchCollection(endpoint, mapper) {
    const res = await fetchWithRetry(`${API_BASE}/${endpoint}?enabled=true&_sort=sortOrder:ASC`);
    if (!res) return [];
    try {
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
            return data.map(mapper);
        }
    } catch (error) {
        console.error("[wizardOptionsApi] Failed to parse collection JSON:", endpoint, error);
    }
    return [];
}
async function fetchFrappeResource(path) {
    if (!constants/* FRAPPE_URL */.kO || !constants/* FRAPPE_API_KEY */.K7 || !constants/* FRAPPE_API_SECRET */.wS) return [];
    const res = await fetchWithRetry(`${constants/* FRAPPE_URL */.kO}${path}`, {
        headers: {
            Authorization: `token ${constants/* FRAPPE_API_KEY */.K7}:${constants/* FRAPPE_API_SECRET */.wS}`
        }
    });
    if (!res) return [];
    try {
        const data = await res.json();
        return Array.isArray(data.data) ? data.data.map((item)=>({
                label: item.name || ""
            })) : [];
    } catch (error) {
        console.error("[wizardOptionsApi] Failed to parse Frappe JSON:", path, error);
        return [];
    }
}
async function fetchWizardOptions() {
    // pref-degree-levels result is discarded — degreeLevels uses hardcoded buckets.
    // Call is kept so the swap is reversible if product wants CMS options back.
    const [countries, , studyAreas, cities, nearestOffices, coachingOptions] = await Promise.all([
        fetchCollection("pref-countries-lists", mapCountry),
        fetchCollection("pref-degree-levels", mapOption),
        fetchCollection("pref-study-areas", mapOption),
        fetchFrappeResource("/api/method/get_cities_for_b2c"),
        fetchFrappeResource("/api/method/get_offices_for_b2c"),
        // Coaching courses from Frappe (KC Courses, sorted server-side), like cities/offices.
        fetchFrappeResource("/api/method/get_courses_for_b2c"), 
    ]);
    // Substitute static fallbacks for any empty list — keeps the wizard usable
    // when CMS/Frappe is slow or down. Live data still wins when present.
    return {
        countries: countries.length ? countries : onboardingFallbacks/* FALLBACK_COUNTRIES */.AE,
        degreeLevels: programLevelConstants/* PROGRAM_LEVEL_OPTIONS_UNIFIED */.TF,
        studyAreas: studyAreas.length ? studyAreas : onboardingFallbacks/* FALLBACK_STUDY_AREAS */.Vr,
        cities: cities.length ? cities : onboardingFallbacks/* FALLBACK_CITIES */.WP,
        nearestOffices: nearestOffices.length ? nearestOffices : onboardingFallbacks/* FALLBACK_NEAREST_OFFICES */.F1,
        coachingOptions
    };
}

;// CONCATENATED MODULE: ./context/WizardOptionsContext.tsx



const emptyOptions = {
    countries: [],
    degreeLevels: [],
    studyAreas: [],
    cities: [],
    nearestOffices: [],
    coachingOptions: []
};
const WizardOptionsContext = /*#__PURE__*/ (0,react.createContext)(emptyOptions);
const WizardOptionsProvider = ({ value , children ,  })=>{
    const { 0: options , 1: setOptions  } = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        fetchWizardOptions().then((live)=>{
            if (!cancelled) setOptions(live);
        }).catch(()=>{});
        return ()=>{
            cancelled = true;
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WizardOptionsContext.Provider, {
        value: options,
        children: children
    });
};
const useWizardOptions = ()=>{
    return (0,react.useContext)(WizardOptionsContext);
};


/***/ }),

/***/ 71210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        const normalizeLocalePath = (__webpack_require__(78875).normalizeLocalePath);
        const detectDomainLocale = (__webpack_require__(38748).detectDomainLocale);
        const target = locale || normalizeLocalePath(path, locales).detectedLocale;
        const domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            const proto = `http${domain.http ? "" : "s"}://`;
            const finalLocale = target === domain.defaultLocale ? "" : `/${target}`;
            return `${proto}${domain.domain}${basePath}${finalLocale}${path}`;
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var { src , sizes , unoptimized =false , priority =false , loading , lazyRoot =null , lazyBoundary , className , quality , width , height , style , objectFit , objectPosition , onLoadingComplete , placeholder ="empty" , blurDataURL  } = _param, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    const configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    const config = (0, _react).useMemo(()=>{
        const c = configEnv || configContext || _imageConfig.imageConfigDefault;
        const allSizes = [
            ...c.deviceSizes,
            ...c.imageSizes
        ].sort((a, b)=>a - b);
        const deviceSizes = c.deviceSizes.sort((a, b)=>a - b);
        return _extends({}, c, {
            allSizes,
            deviceSizes
        });
    }, [
        configContext
    ]);
    let rest = all;
    let layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    let loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            const customImageLoader = rest.loader;
            var _tmp;
            _tmp = (obj)=>{
                const { config: _  } = obj, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    let staticSrc = "";
    if (isStaticImport(src)) {
        const staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error(`An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ${JSON.stringify(staticImageData)}`);
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error(`An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ${JSON.stringify(staticImageData)}`);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    let isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    const [blurComplete, setBlurComplete] = (0, _react).useState(false);
    const [setIntersection, isIntersected, resetIntersected] = (0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    });
    const isVisible = !isLazy || isIntersected;
    const wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    const sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    let hasSizer = false;
    let sizerSvgUrl;
    const layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit,
        objectPosition
    };
    let widthInt = getInt(width);
    let heightInt = getInt(height);
    const qualityInt = getInt(quality);
    if (false) {}
    const imgStyle = Object.assign({}, style, layoutStyle);
    const blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: `url("${blurDataURL}")`
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        const quotient = heightInt / widthInt;
        const paddingTop = isNaN(quotient) ? "100%" : `${quotient * 100}%`;
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = `data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27${widthInt}%27%20height=%27${heightInt}%27/%3e`;
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    let imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config,
            src,
            unoptimized,
            layout,
            width: widthInt,
            quality: qualityInt,
            sizes,
            loader
        });
    }
    let srcString = src;
    if (false) {}
    let imageSrcSetPropName = "imagesrcset";
    let imageSizesPropName = "imagesizes";
    if (false) {}
    const linkProps = {
        // Note: imagesrcset and imagesizes are not in the link element type with react 17.
        [imageSrcSetPropName]: imgAttributes.srcSet,
        [imageSizesPropName]: imgAttributes.sizes,
        crossOrigin: rest.crossOrigin
    };
    const useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    const onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    const previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(()=>{
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(()=>{
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    const imgElementArgs = _extends({
        isLazy,
        imgAttributes,
        heightInt,
        widthInt,
        qualityInt,
        layout,
        className,
        imgStyle,
        blurStyle,
        loading,
        config,
        unoptimized,
        placeholder,
        loader,
        srcString,
        onLoadingCompleteRef,
        setBlurComplete,
        setIntersection,
        isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
const configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":true};
const loadedImageURLs = new Set();
const allImgs = new Map();
let perfObserver;
const emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
const VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader({ config , src , width , quality  }) {
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    const url = new URL(`${config.path}${normalizeSrc(src)}`);
    const params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader({ config , src , width  }) {
    return `${config.path}${normalizeSrc(src)}?imwidth=${width}`;
}
function cloudinaryLoader({ config , src , width , quality  }) {
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    const params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    const paramsString = params.join(",") + "/";
    return `${config.path}${paramsString}${normalizeSrc(src)}`;
}
function customLoader({ src  }) {
    throw new Error(`Image with src "${src}" is missing "loader" prop.` + `\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader`);
}
function defaultLoader({ config , src , width , quality  }) {
    if (false) {}
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return `${(0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path)}?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`;
}
const loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
const VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths({ deviceSizes , allSizes  }, width, layout, sizes) {
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        const viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        const percentSizes = [];
        for(let match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            const smallestRatio = Math.min(...percentSizes) * 0.01;
            return {
                widths: allSizes.filter((s)=>s >= deviceSizes[0] * smallestRatio),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    const widths = [
        ...new Set(// > are actually 3x in the green color, but only 1.5x in the red and
        // > blue colors. Showing a 3x resolution image in the app vs a 2x
        // > resolution image will be visually the same, though the 3x image
        // > takes significantly more data. Even true 3x resolution screens are
        // > wasteful as the human eye cannot see that level of detail without
        // > something like a magnifying glass.
        // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
        [
            width,
            width * 2 /*, width * 3*/ 
        ].map((w)=>allSizes.find((p)=>p >= w) || allSizes[allSizes.length - 1])), 
    ];
    return {
        widths,
        kind: "x"
    };
}
function generateImgAttrs({ config , src , unoptimized , layout , width , quality , sizes , loader  }) {
    if (unoptimized) {
        return {
            src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    const { widths , kind  } = getWidths(config, width, layout, sizes);
    const last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map((w, i)=>`${loader({
                config,
                src,
                quality,
                width: w
            })} ${kind === "w" ? w : i + 1}${kind}`).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config,
            src,
            quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    const loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    const load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error(`Unknown "loader" found in "next.config.js". Expected: ${_imageConfig.VALID_LOADERS.join(", ")}. Received: ${loaderKey}`);
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    const p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(()=>{}).then(()=>{
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            const { naturalWidth , naturalHeight  } = img;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth,
                naturalHeight
            });
        }
        if (false) { var ref; }
    });
}
const ImageElement = (_param)=>{
    var { imgAttributes , heightInt , widthInt , qualityInt , layout , className , imgStyle , blurStyle , isLazy , placeholder , loading , srcString , config , unoptimized , loader , onLoadingCompleteRef , setBlurComplete , setIntersection , onLoad , onError , isVisible , noscriptSizes  } = _param, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback((img)=>{
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: (event)=>{
            const img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: (event)=>{
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config,
        src: srcString,
        unoptimized,
        layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(false) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 78875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
const normalizeLocalePath = (pathname, locales)=>{
    if (true) {
        return (__webpack_require__(94317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection({ rootRef , rootMargin , disabled  }) {
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error(`Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense`);
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
const { useSyncExternalStore  } =  false ? 0 : __webpack_require__(61688);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 1045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(83454);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    }
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    }
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules1 = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules1[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 60357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(1045).style;


/***/ }),

/***/ 33951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Footer/Footer.module.scss
var Footer_module = __webpack_require__(52836);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./components/Footer/SubscribeNow/SubscribeNow.module.scss
var SubscribeNow_module = __webpack_require__(72014);
var SubscribeNow_module_default = /*#__PURE__*/__webpack_require__.n(SubscribeNow_module);
// EXTERNAL MODULE: ./node_modules/jsonp/index.js
var jsonp = __webpack_require__(70365);
var jsonp_default = /*#__PURE__*/__webpack_require__.n(jsonp);
// EXTERNAL MODULE: ./node_modules/to-querystring/lib/to-querystring.min.js
var to_querystring_min = __webpack_require__(77635);
var to_querystring_min_default = /*#__PURE__*/__webpack_require__.n(to_querystring_min);
;// CONCATENATED MODULE: ./node_modules/react-mailchimp-subscribe/es/SimpleForm.js


// a basic form
var SimpleForm = function SimpleForm(_ref) {
  var status = _ref.status,
      message = _ref.message,
      className = _ref.className,
      style = _ref.style,
      onSubmitted = _ref.onSubmitted;

  var input = void 0;
  var submit = function submit() {
    return input && input.value.indexOf("@") > -1 && onSubmitted({
      EMAIL: input.value
    });
  };

  return react.createElement(
    "div",
    { className: className, style: style },
    status === "sending" && react.createElement(
      "div",
      { style: { color: "blue" } },
      "sending..."
    ),
    status === "error" && react.createElement("div", {
      style: { color: "red" },
      dangerouslySetInnerHTML: { __html: message }
    }),
    status === "success" && react.createElement("div", {
      style: { color: "green" },
      dangerouslySetInnerHTML: { __html: message }
    }),
    react.createElement("input", {
      ref: function ref(node) {
        return input = node;
      },
      type: "email",
      placeholder: "Your email"
    }),
    react.createElement(
      "button",
      { onClick: submit },
      "Submit"
    )
  );
};

/* harmony default export */ var es_SimpleForm = (SimpleForm);
;// CONCATENATED MODULE: ./node_modules/react-mailchimp-subscribe/es/index.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var getAjaxUrl = function getAjaxUrl(url) {
  return url.replace("/post?", "/post-json?");
};

var MailchimpSubscribe = function (_React$Component) {
  _inherits(MailchimpSubscribe, _React$Component);

  function MailchimpSubscribe() {
    var _temp, _this, _ret;

    _classCallCheck(this, MailchimpSubscribe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      status: null,
      message: null
    }, _this.subscribe = function (data) {
      var params = to_querystring_min_default()(data);
      var url = getAjaxUrl(_this.props.url) + "&" + params;
      _this.setState({
        status: "sending",
        message: null
      }, function () {
        return jsonp_default()(url, {
          param: "c"
        }, function (err, data) {
          if (err) {
            _this.setState({
              status: "error",
              message: err
            });
          } else if (data.result !== "success") {
            _this.setState({
              status: "error",
              message: data.msg
            });
          } else {
            _this.setState({
              status: "success",
              message: data.msg
            });
          }
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MailchimpSubscribe.prototype.render = function render() {
    return this.props.render({
      subscribe: this.subscribe,
      status: this.state.status,
      message: this.state.message
    });
  };

  return MailchimpSubscribe;
}(react.Component);

MailchimpSubscribe.propTypes =  false ? 0 : {};

MailchimpSubscribe.defaultProps = {
  render: function render(_ref) {
    var subscribe = _ref.subscribe,
        status = _ref.status,
        message = _ref.message;
    return react.createElement(es_SimpleForm, {
      status: status,
      message: message,
      onSubmitted: function onSubmitted(formData) {
        return subscribe(formData);
      }
    });
  }
};

/* harmony default export */ var es = (MailchimpSubscribe);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Spinner.js




const Spinner = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  variant,
  animation,
  size,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'spinner');
  const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
  });
});
Spinner.displayName = 'Spinner';
/* harmony default export */ var esm_Spinner = (Spinner);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 14 modules
var Form = __webpack_require__(97346);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./components/Footer/SubscribeNow/SubscribeNow.tsx







const SubscribeNow = ()=>{
    const { 0: mail , 1: setMail  } = (0,react.useState)("");
    const { 0: intrestedIn , 1: setIntrestedIn  } = (0,react.useState)("");
    const { 0: intrestError , 1: setIntrestError  } = (0,react.useState)(false);
    const onSubmitStatus = (message, stat)=>{
        setMail("");
        setIntrestedIn(constants/* INTEREST_TEXT */.sA);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                color: stat === "error" ? "red" : "green"
            },
            children: message
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SubscribeNow_module_default()).about,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Stay updated with KC Overseas"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es, {
                url: "https://studies-overseas.us14.list-manage.com/subscribe/post?u=76b1ec46de6597b2c8dfd909e&amp;id=4a9acae075" || 0,
                render: ({ subscribe , status , message  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    intrestedIn === constants/* INTEREST_TEXT */.sA && setIntrestError(true);
                                    if (mail && intrestedIn && intrestedIn !== constants/* INTEREST_TEXT */.sA) {
                                        // @ts-ignore
                                        subscribe({
                                            EMAIL: mail,
                                            MMERGE1: intrestedIn
                                        });
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SubscribeNow_module_default()).subscribeForm,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                id: "emailFooter",
                                                type: "email",
                                                placeholder: "Email ID",
                                                required: true,
                                                value: mail,
                                                onChange: (event)=>setMail(event.target.value)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                                    id: "formselect",
                                                    required: true,
                                                    onChange: (event)=>{
                                                        setIntrestError(false);
                                                        setIntrestedIn(event.target.value);
                                                    },
                                                    "aria-label": "I'm intrested in",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "",
                                                            children: constants/* INTEREST_TEXT */.sA
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            children: "Student"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            children: "Institute"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            children: "Partner"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            children: "Franchisee"
                                                        })
                                                    ]
                                                }),
                                                intrestError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Text */.Z.Text, {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: "Please select this field"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                type: "submit",
                                                disabled: status === "sending",
                                                children: [
                                                    "Subscribe Now",
                                                    status === "sending" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Spinner, {
                                                        as: "span",
                                                        animation: "border",
                                                        size: "sm",
                                                        role: "status",
                                                        "aria-hidden": "true",
                                                        style: {
                                                            margin: "0 0 2px 5px"
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            (status === "error" || status === "success") && onSubmitStatus(message, status)
                        ]
                    })
            })
        ]
    });
};
/* harmony default export */ var SubscribeNow_SubscribeNow = (SubscribeNow);

// EXTERNAL MODULE: ./components/Footer/Recognition/Recognition.module.scss
var Recognition_module = __webpack_require__(13435);
var Recognition_module_default = /*#__PURE__*/__webpack_require__.n(Recognition_module);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
;// CONCATENATED MODULE: ./components/Footer/Recognition/Recognition.tsx





const Recognition = ({ footerData  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Recognition_module_default()).lineBottom
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "RecogLogo",
                className: (Recognition_module_default()).recognitions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: footerData?.recognitionTitle || ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Recognition_module_default()).RegLogo,
                        children: footerData?.recognitiondata?.logoimages?.length > 0 && footerData?.recognitiondata?.logoimages?.map((images, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: images?.imageUrl,
                                alt: images?.alt,
                                height: 50,
                                width: 150
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Recognition_Recognition = (Recognition);

// EXTERNAL MODULE: ./components/Footer/FooterUtilityBar/FooterUtilityBar.module.scss
var FooterUtilityBar_module = __webpack_require__(3514);
var FooterUtilityBar_module_default = /*#__PURE__*/__webpack_require__.n(FooterUtilityBar_module);
// EXTERNAL MODULE: ./components/CustomLink.tsx
var CustomLink = __webpack_require__(50282);
;// CONCATENATED MODULE: ./components/Footer/FooterUtilityBar/FooterUtilityBar.tsx





const FooterUtilityBar = ({ footerData  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FooterUtilityBar_module_default()).lineBottom
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "publicLinks",
                className: (FooterUtilityBar_module_default()).publicLinks,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FooterUtilityBar_module_default()).socialMediaLink,
                        children: footerData?.socialLink?.length > 0 && footerData?.socialLink.map((link)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                data: link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: link?.image?.url || "/",
                                    alt: link?.image?.alternativeText || `alt-image-social-${link.id}`,
                                    width: 40,
                                    height: 40
                                })
                            }, link.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterUtilityBar_module_default()).terms,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: footerData?.copyright || ""
                            }),
                            footerData?.bottomLinks?.length > 0 && footerData?.bottomLinks.map((terms)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                        data: terms,
                                        children: terms.label
                                    })
                                }, terms.id))
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FooterUtilityBar_FooterUtilityBar = (FooterUtilityBar);

// EXTERNAL MODULE: ./components/Footer/FooterMain/FooterMain.module.scss
var FooterMain_module = __webpack_require__(57746);
var FooterMain_module_default = /*#__PURE__*/__webpack_require__.n(FooterMain_module);
;// CONCATENATED MODULE: ./components/Footer/FooterMain/FooterMain.tsx






const customNav = (navData, style = {})=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: style,
        children: navData?.length > 0 && navData.map((nav)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterMain_module_default()).linkHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                data: nav,
                                children: nav.title
                            }),
                            nav.title === "Upcoming Events" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (FooterMain_module_default()).weHireBtn,
                                children: " new! "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: nav?.subNav?.length > 0 && nav.subNav.map((sub)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                        data: sub,
                                        children: sub.label
                                    }),
                                    sub.label === "Careers" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (FooterMain_module_default()).ipadHiring,
                                        children: " wE’RE hIRING! "
                                    }),
                                    sub.label === "Careers" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (FooterMain_module_default()).ipad,
                                        children: " HIRING! "
                                    })
                                ]
                            }, sub.id))
                    })
                ]
            }, nav.id);
        })
    });
};
const FooterMain = ({ footerData  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FooterMain_module_default()).lineBottom
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "footerLinks",
                className: (FooterMain_module_default()).footerLinks,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterMain_module_default()).footerKClogo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "kcLogoFoot",
                                className: (FooterMain_module_default()).kclogo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: footerData?.footerImageUrl,
                                    alt: footerData?.FooterImageAltTag,
                                    height: 35,
                                    width: 160
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (FooterMain_module_default()).aboutkc,
                                children: footerData?.footerTitle || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "kcabtDiscri",
                                children: footerData?.footerDescription || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FooterMain_module_default()).icefBadge,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    id: "iasBadge",
                                    "data-account-id": "1646"
                                })
                            })
                        ]
                    }),
                    footerData?.navigationsThree?.length > 0 && customNav(footerData?.navigationsThree),
                    footerData?.navigationsTwo?.length > 0 && customNav(footerData?.navigationsTwo),
                    footerData?.navigationsOne?.length > 0 && customNav(footerData?.navigationsOne)
                ]
            })
        ]
    });
};
/* harmony default export */ var FooterMain_FooterMain = (FooterMain);

// EXTERNAL MODULE: ./components/Footer/SiteMap/SiteMap.module.scss
var SiteMap_module = __webpack_require__(45150);
var SiteMap_module_default = /*#__PURE__*/__webpack_require__.n(SiteMap_module);
// EXTERNAL MODULE: ./components/UI/Accordion/Accordion.tsx + 1 modules
var Accordion = __webpack_require__(33434);
;// CONCATENATED MODULE: ./components/Footer/SiteMap/SiteMap.tsx






const SiteMap = ({ footerData  })=>{
    const siteMapData = footerData?.siteMapLinks ?? [];
    if (!siteMapData.length) return null;
    const accordionItems = siteMapData.map((item)=>({
            title: item.title,
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SiteMap_module_default()).siteMapList,
                children: item.navLinks.map((el, index, arr)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                data: el.link,
                                children: el.label
                            }),
                            index !== arr.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SiteMap_module_default()).siteMapSeparator,
                                children: "|"
                            })
                        ]
                    }, el.id))
            })
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: siteMapData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SiteMap_module_default()).lineBottom
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    items: accordionItems,
                    icon: "chevron-circle",
                    defaultOpenIndex: -1,
                    accordionItemStyles: {
                        borderBottom: "none"
                    },
                    titleStyles: {
                        color: "#868697"
                    }
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
};
/* harmony default export */ var SiteMap_SiteMap = (SiteMap);

;// CONCATENATED MODULE: ./components/Footer/Footer.tsx









const Footer = (props)=>{
    // ICEF Badge script loader
    (0,react.useEffect)(()=>{
        // Remove any existing script to ensure clean state
        const existingScript = document.querySelector('script[src*="iasbadgeid.js"]');
        if (existingScript) {
            existingScript.remove();
        }
        // Clear the badge container
        const badgeSpan = document.getElementById("iasBadge");
        if (badgeSpan) {
            badgeSpan.innerHTML = "";
        }
        // Create and inject fresh script
        const script = document.createElement("script");
        script.src = "https://www-cdn.icef.com/scripts/iasbadgeid.js";
        script.async = true;
        script.defer = true;
        script.crossOrigin = "anonymous";
        document.body.appendChild(script);
        // Cleanup function
        return ()=>{
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "footer-svg",
                className: (Footer_module_default()).footersvgimg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Footer_module_default()).footerImg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/icons/three_dotted_lines.svg",
                            alt: "decorative lines",
                            width: 100,
                            height: 191
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                id: "about-footer",
                className: (Footer_module_default()).footerMain,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeNow_SubscribeNow, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMain_FooterMain, {
                        footerData: props?.footerData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Recognition_Recognition, {
                        footerData: props?.footerData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteMap_SiteMap, {
                        footerData: props?.footerData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterUtilityBar_FooterUtilityBar, {
                        footerData: props?.footerData
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./styles/Header.module.scss
var Header_module = __webpack_require__(71726);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var b2c_constants = __webpack_require__(90017);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
;// CONCATENATED MODULE: ./components/Header.tsx













const normalizePath = (path)=>{
    const withoutQueryOrHash = path.split(/[?#]/)[0].replace(/\/+$/, "");
    let decodedPath = withoutQueryOrHash;
    try {
        decodedPath = decodeURI(withoutQueryOrHash);
    } catch  {
    // malformed escape sequence: fall back to the raw path
    }
    return decodedPath.toLowerCase() || "/";
};
const getLinkPath = (link)=>{
    try {
        return new URL(link).pathname;
    } catch  {
        return link.startsWith("/") ? link : `/${link}`;
    }
};
const matchesAnyPage = (currentPath, pages)=>Array.isArray(pages) && pages.some((page)=>{
        if (typeof page?.link !== "string" || !page.link) return false;
        const linkPath = getLinkPath(page.link);
        if (linkPath.endsWith("/*")) {
            const basePath = normalizePath(linkPath.slice(0, -2));
            const prefix = basePath === "/" ? "/" : `${basePath}/`;
            return currentPath.startsWith(prefix);
        }
        return currentPath === normalizePath(linkPath);
    });
// alwaysShowOnPages overrides hideOnPages.
const isBookOnlineCounsellingVisible = (currentPath, config)=>{
    const path = normalizePath(currentPath);
    if (matchesAnyPage(path, config?.alwaysShowOnPages ?? [])) return true;
    return !matchesAnyPage(path, config?.hideOnPages ?? []);
};
const Header = (props)=>{
    const router = (0,next_router.useRouter)();
    const isBocBtnVisible = isBookOnlineCounsellingVisible(router?.asPath || "", props?.bookOnlineCounselling);
    // Define the function for redirection
    const handleRedirect = ()=>{
        window.open(b2c_constants/* BOOK_COUNSELLING_URL */.MY, "_blank");
    };
    // Capture the page the user was on when they clicked Student Login,
    // so Frappe can attribute the lead via source_url + primary_source='B2C Login'.
    const handleLoginClick = ()=>{
        if (true) {
            (0,sourceTracking/* persistSourceContext */.jW)({
                sourceUrl: window.location.href,
                primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_LOGIN */.UM
            });
        }
    };
    const { 0: menuNumber , 1: setMenuNumber  } = (0,react.useState)(0);
    const { 0: isMobileMenuOpen , 1: setIsMobileMenuOpen  } = (0,react.useState)(false);
    const clickRef = (0,react.useRef)(null);
    const { 0: viewportWidth , 1: setViewportWidth  } = (0,react.useState)(0);
    const kcBlackLogoCondition = router?.pathname === "/student-services/steps-to-study-abroad" || router?.pathname === "/partners/institutions-universities" || router?.pathname === "/entrepreneur/franchise-proposal";
    const handleClickOutside = (event)=>{
        if (clickRef.current && !clickRef.current.contains(event.target)) {
            deafultNavTheme();
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside, true);
        return ()=>{
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        setViewportWidth(window.innerWidth);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const deafultNavTheme = ()=>{
        const customStyle = document.documentElement.style;
        const filteredNavColor = (0,helpers/* getColor */.Lq)(location?.pathname)[0];
        customStyle.setProperty("--navbar-color", filteredNavColor.navColor);
        customStyle.setProperty("--navbar-menu-color", filteredNavColor.navMenuColor);
        setMenuNumber(0);
        setIsMobileMenuOpen(false);
    };
    const changeNavTheme = (clickedMenu)=>{
        const customStyle = document.documentElement.style;
        setMenuNumber(clickedMenu);
        customStyle.setProperty("--navbar-color", "#ffffff");
        customStyle.setProperty("--navbar-menu-color", "#0E1B2C");
        customStyle.setProperty("--book-online-link-color", "#FF7361");
        setIsMobileMenuOpen(true);
    };
    const clickMenu = (clickedMenu)=>{
        if (menuNumber && menuNumber === clickedMenu) {
            deafultNavTheme();
        } else {
            changeNavTheme(clickedMenu);
        }
    };
    const activeClass = (activeNumber)=>menuNumber === activeNumber ? (Header_module_default()).activeDiv : "";
    const backMenu = (menuName)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `${(Header_module_default()).linksurl} ${(Header_module_default()).mobileMenu}`,
            onClick: ()=>setMenuNumber(0),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                    src: "/images/header-menu/left_arrow.svg",
                    alt: "Left Arrow",
                    height: "16",
                    width: "19"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Header_module_default()).flag,
                    children: menuName
                })
            ]
        });
    };
    const upArrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: activeClass(1),
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 18.606 11.164",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "data-name": "Path 878",
            d: "M9.3,11.164,0,2.3,2.412,0,9.3,6.567,16.194,0l2.412,2.3Z",
            transform: "translate(18.606 11.164) rotate(180)",
            fill: "#ffffff"
        })
    });
    const downArrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: activeClass(2),
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "20",
        viewBox: "0 0 18.606 11.164",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "data-name": "Path 878",
            d: "M9.3,11.164,0,2.3,2.412,0,9.3,6.567,16.194,0l2.412,2.3Z",
            fill: "#ffffff"
        })
    });
    const showStudentLoginBtn = !constants/* HIDE_STUDENT_LOGIN.includes */.pc.includes(router.pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "mainheader",
            ref: clickRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "topMain",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Header_module_default()).main,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                            id: "header-navbar",
                            className: (Header_module_default()).navbar,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    id: "kc-logo",
                                    href: router.asPath === "/thank-you" ? undefined : "/",
                                    style: {
                                        cursor: router.asPath === "/thank-you" ? "default !important" : "pointer"
                                    },
                                    onClick: ()=>deafultNavTheme(),
                                    children: (()=>{
                                        const selectedLogo = menuNumber || isMobileMenuOpen ? props?.kcLogoBlue : kcBlackLogoCondition ? props?.kcLogoBlack : props?.kcLogoWhite;
                                        const logoSrc = selectedLogo?.url || "/images/franchisee/kc-logo.svg";
                                        const logoAlt = selectedLogo?.alternativeText || "KC Overseas";
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            className: (Header_module_default()).kcLogo,
                                            src: logoSrc,
                                            alt: logoAlt,
                                            width: viewportWidth > 900 ? 247 : viewportWidth > 480 ? 190 : 150,
                                            height: viewportWidth > 900 ? 43 : viewportWidth > 480 ? 33 : 26
                                        });
                                    })()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Header_module_default()).megaMenu,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Header_module_default()).mainMenu,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "stud-dest-menu",
                                                onClick: ()=>clickMenu(1),
                                                className: activeClass(1),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            paddingRight: "7px"
                                                        },
                                                        children: "Study Destinations"
                                                    }),
                                                    menuNumber === 1 ? upArrow : downArrow
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "service-menu",
                                                onClick: ()=>clickMenu(2),
                                                className: activeClass(2),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            paddingRight: "7px"
                                                        },
                                                        children: "Services"
                                                    }),
                                                    menuNumber === 2 ? upArrow : downArrow
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/events",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "upcom-event-menu",
                                                    children: "Upcoming Events"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/contact-us",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "contact-us-link",
                                                    children: "Contact Us"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "company-menu",
                                                onClick: ()=>clickMenu(3),
                                                className: activeClass(3),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Header_module_default()).companyspan,
                                                        children: "Company"
                                                    }),
                                                    menuNumber === 3 ? upArrow : downArrow
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://www.coursefinder.ai",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    id: "cofforPartner",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            lineHeight: "13px",
                                                            display: "block",
                                                            padding: "5px"
                                                        },
                                                        className: `${menuNumber || isMobileMenuOpen ? (Header_module_default()).cfActive : ""} ${(Header_module_default()).externalLinks} ${(Header_module_default()).btnMargin}`,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "coursefinder.ai"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (Header_module_default()).forprtners,
                                                                children: "( For Partners )"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            showStudentLoginBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                id: "loginBtn",
                                                href: "/check-email?from=login",
                                                className: (Header_module_default()).loginBtn,
                                                onClick: handleLoginClick,
                                                children: "Student Login"
                                            }),
                                            isBocBtnVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                id: "book-online-conse",
                                                onClick: handleRedirect,
                                                className: (Header_module_default()).onlineCounselling,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: `${menuNumber || isMobileMenuOpen ? (Header_module_default()).onlineConActive : ""} ${(Header_module_default()).bookOnlineLink}`,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/vedioiconsnew.svg",
                                                            height: 22,
                                                            width: 22,
                                                            alt: "onlineCons.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Book Online Counselling"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Header_module_default()).mobileMenu,
                                    children: menuNumber || isMobileMenuOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: ()=>deafultNavTheme(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: "/cross_icon.svg",
                                            height: "25",
                                            width: "30",
                                            alt: "cross icon"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: ()=>changeNavTheme(0),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: "/new-images/frame-a.svg",
                                            alt: "Frame A",
                                            height: "25",
                                            width: "30"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "mobile-menu",
                            className: (Header_module_default()).mobileMenu,
                            children: isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Header_module_default()).subMenu,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: (Header_module_default()).rowCenter,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            lg: 8,
                                            md: 8,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    id: "stud-destimenu",
                                                    className: (Header_module_default()).linksurl,
                                                    onClick: ()=>clickMenu(1),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/images/header-menu/study_dest.svg",
                                                            alt: "Study Destination",
                                                            height: "18",
                                                            width: "17"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (Header_module_default()).flag,
                                                            children: [
                                                                "Study Destinations",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        " ",
                                                                        menuNumber === 1 ? upArrow : downArrow
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    id: "services-menu",
                                                    className: (Header_module_default()).linksurl,
                                                    onClick: ()=>clickMenu(2),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/images/header-menu/services.svg",
                                                            alt: "Services",
                                                            height: "18",
                                                            width: "18"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (Header_module_default()).flag,
                                                            children: [
                                                                "Services",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        " ",
                                                                        menuNumber === 2 ? upArrow : downArrow
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/events",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Header_module_default()).linksurl,
                                                        onClick: ()=>deafultNavTheme(),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/images/header-menu/upcoming.svg",
                                                                alt: "Upcoming Events",
                                                                height: "18",
                                                                width: "18"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                id: "upcom-events-menu",
                                                                className: (Header_module_default()).flag,
                                                                children: "Upcoming Events"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/contact-us",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Header_module_default()).linksurl,
                                                        onClick: ()=>deafultNavTheme(),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/contactus.svg",
                                                                alt: "Contact Us",
                                                                height: "18",
                                                                width: "18"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                id: "contact-us-link",
                                                                className: (Header_module_default()).flag,
                                                                children: "Contact Us"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    id: "company-menu",
                                                    className: (Header_module_default()).linksurl,
                                                    onClick: ()=>clickMenu(3),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/aboutusmenuicon.svg",
                                                            alt: "About Us",
                                                            height: "18",
                                                            width: "18"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (Header_module_default()).flag,
                                                            children: [
                                                                "Company",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        " ",
                                                                        menuNumber === 3 ? upArrow : downArrow
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.coursefinder.ai",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        id: "coffor-partners",
                                                        target: "_blank",
                                                        className: (Header_module_default()).mobilGalaxy,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: `${(Header_module_default()).cfActive} ${(Header_module_default()).mobileCf}`,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: "coursefinder.ai"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        paddingLeft: "10px"
                                                                    },
                                                                    children: "( For Partners )"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/universities",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        id: "coffor-partners",
                                                        target: "_blank",
                                                        className: (Header_module_default()).mobilGalaxy,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: `${(Header_module_default()).cfActive} ${(Header_module_default()).mobileCf}`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: " Search Universities "
                                                            })
                                                        })
                                                    })
                                                }),
                                                isBocBtnVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    id: "book-onlinecons",
                                                    onClick: handleRedirect,
                                                    className: (Header_module_default()).mobileOnlineCounselling,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: `${(Header_module_default()).cfActive} ${(Header_module_default()).mobileCf} ${(Header_module_default()).mobilGalaxy}`,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/new-images/vediomobileicon.svg",
                                                                height: 22,
                                                                width: 22,
                                                                alt: "onlineCons.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Book Online Counselling"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                showStudentLoginBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    id: "mobile-login-btn",
                                                    href: "/check-email?from=login",
                                                    className: (Header_module_default()).mobilGalaxy,
                                                    onClick: handleLoginClick,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: `${(Header_module_default()).cfActive} ${(Header_module_default()).mobileCf}`,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "Student Login"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }),
                        menuNumber === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Header_module_default()).subMenu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: (Header_module_default()).rowCenter,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        lg: 8,
                                        md: 8,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            children: [
                                                backMenu("Study Destinations"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 4,
                                                    md: 4,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: ()=>router.push("/country/study-in-usa"),
                                                            href: "/country/study-in-usa",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/usaflag.svg",
                                                                        alt: "USA",
                                                                        height: "35",
                                                                        width: "35"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "USA"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/country/study-in-canada",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/canadaflag.svg",
                                                                        alt: "Canada",
                                                                        height: "35",
                                                                        width: "35"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "Canada"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/country/study-in-uk",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/unitedkingdomflag.svg",
                                                                        alt: "United Kingdom",
                                                                        height: "35",
                                                                        width: "35"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "United Kingdom"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 4,
                                                    md: 4,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/country/study-in-ireland",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/ireland-flag.svg",
                                                                        alt: "Ireland",
                                                                        height: "35",
                                                                        width: "35"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "Ireland"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/country/study-in-australia",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/australiaflag.svg",
                                                                        alt: "Australia",
                                                                        height: "35",
                                                                        width: "35"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "Australia"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/country/study-in-new-zealand",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/newzealandflag.svg",
                                                                        alt: "New Zealand",
                                                                        height: "35",
                                                                        width: "35"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "New Zealand"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 4,
                                                    md: 4,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/study-destinations/europe",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/europflag.svg",
                                                                        alt: "Europe",
                                                                        height: "35",
                                                                        width: "35"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "Europe"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/study-destinations/asia",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: `${"https://kc-website-cms-test.s3.ap-south-1.amazonaws.com"}/Group_1_867b98a2d8.svg`,
                                                                        alt: "India",
                                                                        height: "38",
                                                                        width: "38"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: "Asia"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: "/universities",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Header_module_default()).searchUniversity,
                                                                children: "Search Universities "
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }),
                        menuNumber === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Header_module_default()).subMenu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: (Header_module_default()).rowCenter,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        lg: 12,
                                        md: 12,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: (Header_module_default()).studyDesti,
                                            children: [
                                                backMenu("Services"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 9,
                                                    md: 9,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/student-services/steps-to-study-abroad",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                onClick: ()=>deafultNavTheme(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/for-student.svg",
                                                                        alt: "Students",
                                                                        height: "18",
                                                                        width: "18"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: `${(Header_module_default()).flag} ${(Header_module_default()).ipadmenu}`,
                                                                        children: "For Student "
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                                    lg: 5,
                                                                    md: 5,
                                                                    xs: 12,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/student-services/steps-to-study-abroad#1",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Counselling"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/test-preparation",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Test Preparation"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/universities",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Country & University Selection"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                                    lg: 4,
                                                                    md: 4,
                                                                    xs: 12,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/student-services/steps-to-study-abroad#4",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Applications & Admission"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/student-services/study-abroad-scholarships",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Scholarships"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/internships",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Internship"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                                    lg: 3,
                                                                    md: 3,
                                                                    xs: 12,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/student-services/education-loan-for-overseas-education",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Education Loan"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/student-services/steps-to-study-abroad#8",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Visa Processing"
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "/student-services/allied-services",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).sublinksurl,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Header_module_default()).flaginner,
                                                                                    onClick: ()=>deafultNavTheme(),
                                                                                    children: "Allied Services"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 3,
                                                    md: 3,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/partners/institutions-universities",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                onClick: ()=>deafultNavTheme(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/for-institute.svg",
                                                                        alt: "Institutions",
                                                                        height: "18",
                                                                        width: "18"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        children: "For Institutes "
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/partners/study-abroad-association",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                onClick: ()=>deafultNavTheme(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/for-partners.svg",
                                                                        alt: "Partners",
                                                                        height: "18",
                                                                        width: "17"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: `${(Header_module_default()).flag} ${(Header_module_default()).ipadmenu}`,
                                                                        children: "For Partners "
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/entrepreneur/franchise-proposal",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                onClick: ()=>deafultNavTheme(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/for-franchises.svg",
                                                                        alt: "Franchise",
                                                                        height: "18",
                                                                        width: "18"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: `${(Header_module_default()).flag} ${(Header_module_default()).ipadmenu}`,
                                                                        children: "For Franchisees "
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }),
                        menuNumber === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Header_module_default()).subMenu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: (Header_module_default()).rowCenter,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        lg: 12,
                                        md: 12,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: `{styles.studyDesti}, justify-content-center`,
                                            children: [
                                                backMenu("Company"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 3,
                                                    md: 4,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/aboutus",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                onClick: ()=>deafultNavTheme(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/aboutusmenuicon.svg",
                                                                        alt: "About Us",
                                                                        height: "18",
                                                                        width: "18"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        children: "About Us"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/news",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                onClick: ()=>deafultNavTheme(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/newpressmenuicon.svg",
                                                                        height: "18",
                                                                        width: "17",
                                                                        alt: "News and Press"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        children: "News & Press "
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 3,
                                                    md: 4,
                                                    xs: 12,
                                                    className: (Header_module_default()).mobileCompMenu,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/blogs",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).linksurl,
                                                                onClick: ()=>deafultNavTheme(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: "/new-images/blogsmenuicon.svg",
                                                                        alt: "Blogs",
                                                                        height: "18",
                                                                        width: "18"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Header_module_default()).flag,
                                                                        children: "Blog"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/careers",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Header_module_default()).carrerlinkdiv,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (Header_module_default()).linksurl,
                                                                        onClick: ()=>deafultNavTheme(),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: "/new-images/careermenuicon.svg",
                                                                                alt: "Career",
                                                                                height: "18",
                                                                                width: "17"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Header_module_default()).flag,
                                                                                children: "Careers "
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (Header_module_default()).hiring,
                                                                        children: "WE’RE HIRING!"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (Header_module_default()).ipad,
                                                                        children: "HIRING!"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var components_Header = (Header);

// EXTERNAL MODULE: ./styles/StickyFooter.module.scss
var StickyFooter_module = __webpack_require__(80812);
var StickyFooter_module_default = /*#__PURE__*/__webpack_require__.n(StickyFooter_module);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
;// CONCATENATED MODULE: ./components/StickyFooter.tsx







const slugToRegex = (slug)=>{
    // normalize trailing slash
    const normalized = slug.replace(/\/$/, "");
    // replace "_" segments with regex matcher
    const regexStr = normalized.split("/").map((part)=>part === "_" ? "[^/]+" : part).join("/");
    return new RegExp(`^${regexStr}$`);
};
const findMatchingPage = (pages, path)=>{
    const cleanPath = path.replace(/\/$/, "");
    let bestMatch = null;
    let bestDepth = -1;
    for (const page of pages){
        const pageSlug = page.slug.replace(/\/$/, "");
        const regex = slugToRegex(pageSlug);
        if (regex.test(cleanPath)) {
            const depth = pageSlug.split("/").length;
            if (depth > bestDepth) {
                bestMatch = page;
                bestDepth = depth;
            }
        }
    }
    return bestMatch;
};
const StickyFooter = ()=>{
    const { 0: stickyFooterPages , 1: setStickyFooterPages  } = (0,react.useState)([]);
    const { 0: showButton , 1: setShowButton  } = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        let cancelled = false;
        fetch("/sticky-footer-pages.json").then((res)=>res.ok ? res.json() : {
                pages: []
            }).then((data)=>{
            if (!cancelled && Array.isArray(data?.pages)) {
                setStickyFooterPages(data.pages);
            }
        }).catch(()=>{
        // Silently fall back to empty list; StickyFooter is non-essential.
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    const pathWithoutQuery = router.asPath.split("?")[0].split("#")[0];
    let stickyFooterPath = stickyFooterPages.filter((page)=>page.slug === pathWithoutQuery);
    if (stickyFooterPath.length === 0) {
        stickyFooterPath = stickyFooterPages.filter((page)=>page.slug === pathWithoutQuery.split("/")?.[1]);
    }
    // fallback to pattern matching if no match found
    if (stickyFooterPath.length === 0) {
        const matchedPage = findMatchingPage(stickyFooterPages, pathWithoutQuery);
        if (matchedPage) stickyFooterPath = [
            matchedPage
        ];
    }
    const includeStickyFooter = stickyFooterPath.length > 0;
    const checkElementVisibility = ()=>{
        const element = document.querySelector(`#sticky-enquire-form-viewer`);
        if (!element) {
            setShowButton(true);
            return;
        }
        const elementPosition = element.getBoundingClientRect();
        const eightyPercentHeight = window.innerHeight * 0.8;
        // Only show button when element has scrolled past 80% of viewport height AND is not at the very top
        if (elementPosition.top < eightyPercentHeight && elementPosition.top < -eightyPercentHeight) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    };
    (0,react.useEffect)(()=>{
        checkElementVisibility();
        window.addEventListener("scroll", checkElementVisibility);
        return ()=>{
            window.removeEventListener("scroll", checkElementVisibility);
        };
    }, []);
    const handleClick = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: stickyFooterPath?.[0]?.onBoardingFlow?.nearestOffice ?? true,
                    coachingVisible: stickyFooterPath?.[0]?.onBoardingFlow?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: stickyFooterPath?.[0]?.externalLink,
        formId: stickyFooterPath?.[0]?.jotformId,
        toOnboardingEnabled: stickyFooterPath?.[0]?.toOnboardingEnabled,
        sourceUrl: stickyFooterPath?.[0]?.slug === "/" ? "home" : stickyFooterPath?.[0]?.slug?.replace("/", "")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: includeStickyFooter && showButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: handleClick(applyCtaButtonProps),
                className: `d-block d-sm-none btn ${(StickyFooter_module_default()).stickyFooter} ${applyCtaButtonProps.formClassName}`,
                children: stickyFooterPath[0]?.buttonLabel || "Enquire Now"
            })
        })
    });
};
/* harmony default export */ var components_StickyFooter = (StickyFooter);

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./lib/layout-snapshot.json
var layout_snapshot = __webpack_require__(31868);
;// CONCATENATED MODULE: ./components/Layout.tsx









const snapshot = layout_snapshot;
const Layout = (props)=>{
    const chatScriptProps = {
        src: "//in.fw-cdn.com/30827707/437894.js",
        chat: "true"
    };
    const router = (0,next_router.useRouter)();
    const excludeChatScriptPath = constants/* excludeChatScriptPaths.includes */.X5.includes(router.asPath.split("/")[1]) || constants/* excludeChatScriptPaths.includes */.X5.includes(router.asPath);
    const pathCondition = router.pathname.includes("/overseas-education-fair/") || router.pathname.includes("/institution/") || router.pathname.includes("/test-prep/") || router.pathname === "/allied-services/[slug]" || router.pathname.includes("/admissions-day/") || router.pathname.includes("/company/") || router.pathname.includes("/study-abroad-online-counselling") || router.pathname.includes("/virtual-admissions-day/") || router.pathname.includes("/virtual-admissions-week/") || router.pathname.includes("/applications-week/") || router.pathname.includes("/webinar/") || router.pathname.includes("/partners/study-abroad-recruiter") || router.pathname.includes("/branch/") || router.pathname.includes("/landing-page/") || router.pathname.includes("/franchisee/") || router.pathname.includes("/recruiter/") || router.pathname.includes("/thank-you") || router.pathname.includes("/onboarding") || router.pathname.includes("/search") || router.pathname.includes("/check-email");
    const raipurThankYouPage = router.asPath.includes("/raipur-thank-you");
    const raipurBranchPage = router.asPath.includes("/branch/raipur");
    const ghaziabadThankYouPage = router.asPath.includes("/thank-you-ghaziabad");
    const ghaziabadBranchPage = router.asPath.includes("/branch/ghaziabad");
    const goaFairPage = router.asPath.includes("/overseas-education-fair/goa");
    // Consolidated GTM and Google Ads configuration
    const getTrackingScripts = ()=>{
        if (raipurThankYouPage || raipurBranchPage) {
            return {
                gtmId: "GTM-TQ2D3BT",
                googleAdsId: "AW-867475097",
                facebookPixelId: "405893726492108"
            };
        } else if (ghaziabadBranchPage || ghaziabadThankYouPage) {
            return {
                gtmId: "GTM-PSHX9G2",
                googleAdsId: "AW-11132067734"
            };
        } else if (goaFairPage) {
            return {
                gtmId: "GTM-PGK2GNF"
            };
        } else {
            return {
                gtmId: "GTM-TQ2D3BT",
                googleAdsId: "AW-1004683207"
            };
        }
    };
    const trackingConfig = getTrackingScripts();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
             false && /*#__PURE__*/ 0,
            trackingConfig.googleAdsId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "afterInteractive",
                        id: "gtag-aw",
                        src: `https://www.googletagmanager.com/gtag/js?id=${trackingConfig.googleAdsId}`
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "afterInteractive",
                        id: "gtag-init-aw",
                        children: `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${trackingConfig.googleAdsId}');`
                    })
                ]
            }),
            raipurThankYouPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "afterInteractive",
                        children: `function gtag_report_conversion(url) {
                var callback = function () {
                  if (typeof(url) != 'undefined') {
                    window.location = url;
                  }
                };
                gtag('event', 'conversion', {
                    'send_to': 'AW-867475097/-gBrCIXMvs0DEJm90p0D',
                    'event_callback': callback
                });
                return false;
            }`
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "afterInteractive",
                        children: `!function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${trackingConfig.facebookPixelId}');
            fbq('track', 'SubmitApplication');`
                    })
                ]
            }),
            raipurBranchPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                children: `!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${trackingConfig.facebookPixelId}');
            fbq('track', 'PageView');`
            }),
            trackingConfig.googleAdsId === "AW-1004683207" && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                children: `window.addEventListener('load', function() {
            document.querySelectorAll('[id="input_19"]').forEach(function (a) {
              a.onclick = function () {
                gtag('event', 'conversion', { 'send_to': 'AW-1004683207/3m2-CO2E-cEDEMf_iN8D' });
              };
            })
          });`
            }),
             false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "sticky-enquire-form-viewer",
                style: {
                    display: "block",
                    height: 0,
                    width: "100%"
                }
            }),
            !pathCondition && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header, {
                ...snapshot.headerData
            }),
            props.children,
            !pathCondition && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                ...{
                    footerData: snapshot.footerData
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StickyFooter, {})
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);

// EXTERNAL MODULE: ./node_modules/@react-aria/ssr/dist/module.js
var dist_module = __webpack_require__(78831);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/SSRProvider.js

/* harmony default export */ var SSRProvider = (dist_module/* SSRProvider */.HK);
;// CONCATENATED MODULE: ./node_modules/dom-mutator/dist/dom-mutator.esm.js
var validAttributeName = /^[a-zA-Z:_][a-zA-Z0-9:_.-]*$/;
var nullController = {
  revert: function revert() {}
};
var dom_mutator_esm_elements = /*#__PURE__*/new Map();
var mutations = /*#__PURE__*/new Set();

function getObserverInit(attr) {
  return attr === 'html' ? {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  } : {
    childList: false,
    subtree: false,
    attributes: true,
    attributeFilter: [attr]
  };
}

function getElementRecord(element) {
  var record = dom_mutator_esm_elements.get(element);

  if (!record) {
    record = {
      element: element,
      attributes: {}
    };
    dom_mutator_esm_elements.set(element, record);
  }

  return record;
}

function createElementPropertyRecord(el, attr, getCurrentValue, setValue, mutationRunner) {
  var currentValue = getCurrentValue(el);
  var record = {
    isDirty: false,
    originalValue: currentValue,
    virtualValue: currentValue,
    mutations: [],
    el: el,
    _positionTimeout: null,
    observer: new MutationObserver(function () {
      // enact a 1 second timeout that blocks subsequent firing of the
      // observer until the timeout is complete. This will prevent multiple
      // mutations from firing in quick succession, which can cause the
      // mutation to be reverted before the DOM has a chance to update.
      if (attr === 'position' && record._positionTimeout) return;else if (attr === 'position') record._positionTimeout = setTimeout(function () {
        record._positionTimeout = null;
      }, 1000);
      var currentValue = getCurrentValue(el);
      if (attr === 'position' && currentValue.parentNode === record.virtualValue.parentNode && currentValue.insertBeforeNode === record.virtualValue.insertBeforeNode) return;
      if (currentValue === record.virtualValue) return;
      record.originalValue = currentValue;
      mutationRunner(record);
    }),
    mutationRunner: mutationRunner,
    setValue: setValue,
    getCurrentValue: getCurrentValue
  };

  if (attr === 'position' && el.parentNode) {
    record.observer.observe(el.parentNode, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    });
  } else {
    record.observer.observe(el, getObserverInit(attr));
  }

  return record;
}

function queueIfNeeded(val, record) {
  var currentVal = record.getCurrentValue(record.el);
  record.virtualValue = val;

  if (val && typeof val !== 'string') {
    if (!currentVal || val.parentNode !== currentVal.parentNode || val.insertBeforeNode !== currentVal.insertBeforeNode) {
      record.isDirty = true;
      runDOMUpdates();
    }
  } else if (val !== currentVal) {
    record.isDirty = true;
    runDOMUpdates();
  }
}

function htmlMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(getTransformedHTML(val), record);
}

function classMutationRunner(record) {
  var val = new Set(record.originalValue.split(/\s+/).filter(Boolean));
  record.mutations.forEach(function (m) {
    return m.mutate(val);
  });
  queueIfNeeded(Array.from(val).filter(Boolean).join(' '), record);
}

function attrMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(val, record);
}

function _loadDOMNodes(_ref) {
  var parentSelector = _ref.parentSelector,
      insertBeforeSelector = _ref.insertBeforeSelector;
  var parentNode = document.querySelector(parentSelector);
  if (!parentNode) return null;
  var insertBeforeNode = insertBeforeSelector ? document.querySelector(insertBeforeSelector) : null;
  if (insertBeforeSelector && !insertBeforeNode) return null;
  return {
    parentNode: parentNode,
    insertBeforeNode: insertBeforeNode
  };
}

function positionMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    var selectors = m.mutate();

    var newNodes = _loadDOMNodes(selectors);

    val = newNodes || val;
  });
  queueIfNeeded(val, record);
}

var getHTMLValue = function getHTMLValue(el) {
  return el.innerHTML;
};

var setHTMLValue = function setHTMLValue(el, value) {
  return el.innerHTML = value;
};

function getElementHTMLRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.html) {
    elementRecord.html = createElementPropertyRecord(element, 'html', getHTMLValue, setHTMLValue, htmlMutationRunner);
  }

  return elementRecord.html;
}

var getElementPosition = function getElementPosition(el) {
  return {
    parentNode: el.parentElement,
    insertBeforeNode: el.nextElementSibling
  };
};

var setElementPosition = function setElementPosition(el, value) {
  if (value.insertBeforeNode && !value.parentNode.contains(value.insertBeforeNode)) {
    // skip position mutation - insertBeforeNode not a child of parent. happens
    // when mutation observer for indvidual element fires out of order
    return;
  }

  value.parentNode.insertBefore(el, value.insertBeforeNode);
};

function getElementPositionRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.position) {
    elementRecord.position = createElementPropertyRecord(element, 'position', getElementPosition, setElementPosition, positionMutationRunner);
  }

  return elementRecord.position;
}

var setClassValue = function setClassValue(el, val) {
  return val ? el.className = val : el.removeAttribute('class');
};

var getClassValue = function getClassValue(el) {
  return el.className;
};

function getElementClassRecord(el) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.classes) {
    elementRecord.classes = createElementPropertyRecord(el, 'class', getClassValue, setClassValue, classMutationRunner);
  }

  return elementRecord.classes;
}

var getAttrValue = function getAttrValue(attrName) {
  return function (el) {
    var _el$getAttribute;

    return (_el$getAttribute = el.getAttribute(attrName)) != null ? _el$getAttribute : null;
  };
};

var setAttrValue = function setAttrValue(attrName) {
  return function (el, val) {
    return val !== null ? el.setAttribute(attrName, val) : el.removeAttribute(attrName);
  };
};

function getElementAttributeRecord(el, attr) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.attributes[attr]) {
    elementRecord.attributes[attr] = createElementPropertyRecord(el, attr, getAttrValue(attr), setAttrValue(attr), attrMutationRunner);
  }

  return elementRecord.attributes[attr];
}

function deleteElementPropertyRecord(el, attr) {
  var element = dom_mutator_esm_elements.get(el);
  if (!element) return;

  if (attr === 'html') {
    var _element$html, _element$html$observe;

    (_element$html = element.html) == null ? void 0 : (_element$html$observe = _element$html.observer) == null ? void 0 : _element$html$observe.disconnect();
    delete element.html;
  } else if (attr === 'class') {
    var _element$classes, _element$classes$obse;

    (_element$classes = element.classes) == null ? void 0 : (_element$classes$obse = _element$classes.observer) == null ? void 0 : _element$classes$obse.disconnect();
    delete element.classes;
  } else if (attr === 'position') {
    var _element$position, _element$position$obs;

    (_element$position = element.position) == null ? void 0 : (_element$position$obs = _element$position.observer) == null ? void 0 : _element$position$obs.disconnect();
    delete element.position;
  } else {
    var _element$attributes, _element$attributes$a, _element$attributes$a2;

    (_element$attributes = element.attributes) == null ? void 0 : (_element$attributes$a = _element$attributes[attr]) == null ? void 0 : (_element$attributes$a2 = _element$attributes$a.observer) == null ? void 0 : _element$attributes$a2.disconnect();
    delete element.attributes[attr];
  }
}

var transformContainer;

function getTransformedHTML(html) {
  if (!transformContainer) {
    transformContainer = document.createElement('div');
  }

  transformContainer.innerHTML = html;
  return transformContainer.innerHTML;
}

function setPropertyValue(el, attr, m) {
  if (!m.isDirty) return;
  m.isDirty = false;
  var val = m.virtualValue;

  if (!m.mutations.length) {
    deleteElementPropertyRecord(el, attr);
  }

  m.setValue(el, val);
}

function setValue(m, el) {
  m.html && setPropertyValue(el, 'html', m.html);
  m.classes && setPropertyValue(el, 'class', m.classes);
  m.position && setPropertyValue(el, 'position', m.position);
  Object.keys(m.attributes).forEach(function (attr) {
    setPropertyValue(el, attr, m.attributes[attr]);
  });
}

function runDOMUpdates() {
  dom_mutator_esm_elements.forEach(setValue);
} // find or create ElementPropertyRecord, add mutation to it, then run


function startMutating(mutation, element) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(element);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(element);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(element, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(element);
  }

  if (!record) return;
  record.mutations.push(mutation);
  record.mutationRunner(record);
} // get (existing) ElementPropertyRecord, remove mutation from it, then run


function stopMutating(mutation, el) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(el);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(el);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(el, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(el);
  }

  if (!record) return;
  var index = record.mutations.indexOf(mutation);
  if (index !== -1) record.mutations.splice(index, 1);
  record.mutationRunner(record);
} // maintain list of elements associated with mutation


function refreshElementsSet(mutation) {
  // if a position mutation has already found an element to move, don't move
  // any more elements
  if (mutation.kind === 'position' && mutation.elements.size === 1) return;
  var existingElements = new Set(mutation.elements);
  var matchingElements = document.querySelectorAll(mutation.selector);
  matchingElements.forEach(function (el) {
    if (!existingElements.has(el)) {
      mutation.elements.add(el);
      startMutating(mutation, el);
    }
  });
}

function revertMutation(mutation) {
  mutation.elements.forEach(function (el) {
    return stopMutating(mutation, el);
  });
  mutation.elements.clear();
  mutations["delete"](mutation);
}

function refreshAllElementSets() {
  mutations.forEach(refreshElementsSet);
} // Observer for elements that don't exist in the DOM yet


var observer;
function disconnectGlobalObserver() {
  observer && observer.disconnect();
}
function connectGlobalObserver() {
  if (typeof document === 'undefined') return;

  if (!observer) {
    observer = new MutationObserver(function () {
      refreshAllElementSets();
    });
  }

  refreshAllElementSets();
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
} // run on init

connectGlobalObserver();

function newMutation(m) {
  // Not in a browser
  if (typeof document === 'undefined') return nullController; // add to global index of mutations

  mutations.add(m); // run refresh on init to establish list of elements associated w/ mutation

  refreshElementsSet(m);
  return {
    revert: function revert() {
      revertMutation(m);
    }
  };
}

function html(selector, mutate) {
  return newMutation({
    kind: 'html',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function position(selector, mutate) {
  return newMutation({
    kind: 'position',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function classes(selector, mutate) {
  return newMutation({
    kind: 'class',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function attribute(selector, attribute, mutate) {
  if (!validAttributeName.test(attribute)) return nullController;

  if (attribute === 'class' || attribute === 'className') {
    return classes(selector, function (classnames) {
      var mutatedClassnames = mutate(Array.from(classnames).join(' '));
      classnames.clear();
      if (!mutatedClassnames) return;
      mutatedClassnames.split(/\s+/g).filter(Boolean).forEach(function (c) {
        return classnames.add(c);
      });
    });
  }

  return newMutation({
    kind: 'attribute',
    attribute: attribute,
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function declarative(_ref2) {
  var selector = _ref2.selector,
      action = _ref2.action,
      value = _ref2.value,
      attr = _ref2.attribute,
      parentSelector = _ref2.parentSelector,
      insertBeforeSelector = _ref2.insertBeforeSelector;

  if (attr === 'html') {
    if (action === 'append') {
      return html(selector, function (val) {
        return val + (value != null ? value : '');
      });
    } else if (action === 'set') {
      return html(selector, function () {
        return value != null ? value : '';
      });
    }
  } else if (attr === 'class') {
    if (action === 'append') {
      return classes(selector, function (val) {
        if (value) val.add(value);
      });
    } else if (action === 'remove') {
      return classes(selector, function (val) {
        if (value) val["delete"](value);
      });
    } else if (action === 'set') {
      return classes(selector, function (val) {
        val.clear();
        if (value) val.add(value);
      });
    }
  } else if (attr === 'position') {
    if (action === 'set' && parentSelector) {
      return position(selector, function () {
        return {
          insertBeforeSelector: insertBeforeSelector,
          parentSelector: parentSelector
        };
      });
    }
  } else {
    if (action === 'append') {
      return attribute(selector, attr, function (val) {
        return val !== null ? val + (value != null ? value : '') : value != null ? value : '';
      });
    } else if (action === 'set') {
      return attribute(selector, attr, function () {
        return value != null ? value : '';
      });
    } else if (action === 'remove') {
      return attribute(selector, attr, function () {
        return null;
      });
    }
  }

  return nullController;
}

var index = {
  html: html,
  classes: classes,
  attribute: attribute,
  position: position,
  declarative: declarative
};

/* harmony default export */ var dom_mutator_esm = (index);

//# sourceMappingURL=dom-mutator.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/util.mjs
const polyfills = {
  fetch: globalThis.fetch ? globalThis.fetch.bind(globalThis) : undefined,
  SubtleCrypto: globalThis.crypto ? globalThis.crypto.subtle : undefined,
  EventSource: globalThis.EventSource
};
function getPolyfills() {
  return polyfills;
}
function hashFnv32a(str) {
  let hval = 0x811c9dc5;
  const l = str.length;
  for (let i = 0; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  return hval >>> 0;
}
function hash(seed, value, version) {
  // New unbiased hashing algorithm
  if (version === 2) {
    return hashFnv32a(hashFnv32a(seed + value) + "") % 10000 / 10000;
  }
  // Original biased hashing algorithm (keep for backwards compatibility)
  if (version === 1) {
    return hashFnv32a(value + seed) % 1000 / 1000;
  }

  // Unknown hash version
  return null;
}
function getEqualWeights(n) {
  if (n <= 0) return [];
  return new Array(n).fill(1 / n);
}
function inRange(n, range) {
  return n >= range[0] && n < range[1];
}
function inNamespace(hashValue, namespace) {
  const n = hash("__" + namespace[0], hashValue, 1);
  if (n === null) return false;
  return n >= namespace[1] && n < namespace[2];
}
function chooseVariation(n, ranges) {
  for (let i = 0; i < ranges.length; i++) {
    if (inRange(n, ranges[i])) {
      return i;
    }
  }
  return -1;
}
function getUrlRegExp(regexString) {
  try {
    const escaped = regexString.replace(/([^\\])\//g, "$1\\/");
    return new RegExp(escaped);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}
function isURLTargeted(url, targets) {
  if (!targets.length) return false;
  let hasIncludeRules = false;
  let isIncluded = false;
  for (let i = 0; i < targets.length; i++) {
    const match = _evalURLTarget(url, targets[i].type, targets[i].pattern);
    if (targets[i].include === false) {
      if (match) return false;
    } else {
      hasIncludeRules = true;
      if (match) isIncluded = true;
    }
  }
  return isIncluded || !hasIncludeRules;
}
function _evalSimpleUrlPart(actual, pattern, isPath) {
  try {
    // Escape special regex characters and change wildcard `_____` to `.*`
    let escaped = pattern.replace(/[*.+?^${}()|[\]\\]/g, "\\$&").replace(/_____/g, ".*");
    if (isPath) {
      // When matching pathname, make leading/trailing slashes optional
      escaped = "\\/?" + escaped.replace(/(^\/|\/$)/g, "") + "\\/?";
    }
    const regex = new RegExp("^" + escaped + "$", "i");
    return regex.test(actual);
  } catch (e) {
    return false;
  }
}
function _evalSimpleUrlTarget(actual, pattern) {
  try {
    // If a protocol is missing, but a host is specified, add `https://` to the front
    // Use "_____" as the wildcard since `*` is not a valid hostname in some browsers
    const expected = new URL(pattern.replace(/^([^:/?]*)\./i, "https://$1.").replace(/\*/g, "_____"), "https://_____");

    // Compare each part of the URL separately
    const comps = [[actual.host, expected.host, false], [actual.pathname, expected.pathname, true]];
    // We only want to compare hashes if it's explicitly being targeted
    if (expected.hash) {
      comps.push([actual.hash, expected.hash, false]);
    }
    expected.searchParams.forEach((v, k) => {
      comps.push([actual.searchParams.get(k) || "", v, false]);
    });

    // If any comparisons fail, the whole thing fails
    return !comps.some(data => !_evalSimpleUrlPart(data[0], data[1], data[2]));
  } catch (e) {
    return false;
  }
}
function _evalURLTarget(url, type, pattern) {
  try {
    const parsed = new URL(url, "https://_");
    if (type === "regex") {
      const regex = getUrlRegExp(pattern);
      if (!regex) return false;
      return regex.test(parsed.href) || regex.test(parsed.href.substring(parsed.origin.length));
    } else if (type === "simple") {
      return _evalSimpleUrlTarget(parsed, pattern);
    }
    return false;
  } catch (e) {
    return false;
  }
}
function getBucketRanges(numVariations, coverage, weights) {
  coverage = coverage === undefined ? 1 : coverage;

  // Make sure coverage is within bounds
  if (coverage < 0) {
    if (false) {}
    coverage = 0;
  } else if (coverage > 1) {
    if (false) {}
    coverage = 1;
  }

  // Default to equal weights if missing or invalid
  const equal = getEqualWeights(numVariations);
  weights = weights || equal;
  if (weights.length !== numVariations) {
    if (false) {}
    weights = equal;
  }

  // If weights don't add up to 1 (or close to it), default to equal weights
  const totalWeight = weights.reduce((w, sum) => sum + w, 0);
  if (totalWeight < 0.99 || totalWeight > 1.01) {
    if (false) {}
    weights = equal;
  }

  // Covert weights to ranges
  let cumulative = 0;
  return weights.map(w => {
    const start = cumulative;
    cumulative += w;
    return [start, start + coverage * w];
  });
}
function getQueryStringOverride(id, url, numVariations) {
  if (!url) {
    return null;
  }
  const search = url.split("?")[1];
  if (!search) {
    return null;
  }
  const match = search.replace(/#.*/, "") // Get rid of anchor
  .split("&") // Split into key/value pairs
  .map(kv => kv.split("=", 2)).filter(([k]) => k === id) // Look for key that matches the experiment id
  .map(([, v]) => parseInt(v)); // Parse the value into an integer

  if (match.length > 0 && match[0] >= 0 && match[0] < numVariations) return match[0];
  return null;
}
function isIncluded(include) {
  try {
    return include();
  } catch (e) {
    console.error(e);
    return false;
  }
}
const base64ToBuf = b => Uint8Array.from(atob(b), c => c.charCodeAt(0));
async function decrypt(encryptedString, decryptionKey, subtle) {
  decryptionKey = decryptionKey || "";
  subtle = subtle || globalThis.crypto && globalThis.crypto.subtle || polyfills.SubtleCrypto;
  if (!subtle) {
    throw new Error("No SubtleCrypto implementation found");
  }
  try {
    const key = await subtle.importKey("raw", base64ToBuf(decryptionKey), {
      name: "AES-CBC",
      length: 128
    }, true, ["encrypt", "decrypt"]);
    const [iv, cipherText] = encryptedString.split(".");
    const plainTextBuffer = await subtle.decrypt({
      name: "AES-CBC",
      iv: base64ToBuf(iv)
    }, key, base64ToBuf(cipherText));
    return new TextDecoder().decode(plainTextBuffer);
  } catch (e) {
    throw new Error("Failed to decrypt");
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function util_toString(input) {
  if (typeof input === "string") return input;
  return JSON.stringify(input);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function paddedVersionString(input) {
  if (typeof input === "number") {
    input = input + "";
  }
  if (!input || typeof input !== "string") {
    input = "0";
  }
  // Remove build info and leading `v` if any
  // Split version into parts (both core version numbers and pre-release tags)
  // "v1.2.3-rc.1+build123" -> ["1","2","3","rc","1"]
  const parts = input.replace(/(^v|\+.*$)/g, "").split(/[-.]/);

  // If it's SemVer without a pre-release, add `~` to the end
  // ["1","0","0"] -> ["1","0","0","~"]
  // "~" is the largest ASCII character, so this will make "1.0.0" greater than "1.0.0-beta" for example
  if (parts.length === 3) {
    parts.push("~");
  }

  // Left pad each numeric part with spaces so string comparisons will work ("9">"10", but " 9"<"10")
  // Then, join back together into a single string
  return parts.map(v => v.match(/^[0-9]+$/) ? v.padStart(5, " ") : v).join("-");
}
function loadSDKVersion() {
  let version;
  try {
    // @ts-expect-error right-hand value to be replaced by build with string literal
    version = "1.6.5";
  } catch (e) {
    version = "";
  }
  return version;
}
function mergeQueryStrings(oldUrl, newUrl) {
  let currUrl;
  let redirectUrl;
  try {
    currUrl = new URL(oldUrl);
    redirectUrl = new URL(newUrl);
  } catch (e) {
    console.error(`Unable to merge query strings: ${e}`);
    return newUrl;
  }
  currUrl.searchParams.forEach((value, key) => {
    // skip  if search param already exists in redirectUrl
    if (redirectUrl.searchParams.has(key)) {
      return;
    }
    redirectUrl.searchParams.set(key, value);
  });
  return redirectUrl.toString();
}
function isObj(x) {
  return typeof x === "object" && x !== null;
}
function getAutoExperimentChangeType(exp) {
  if (exp.urlPatterns && exp.variations.some(variation => isObj(variation) && "urlRedirect" in variation)) {
    return "redirect";
  } else if (exp.variations.some(variation => isObj(variation) && (variation.domMutations || "js" in variation || "css" in variation))) {
    return "visual";
  }
  return "unknown";
}

// Guarantee the promise always resolves within {timeout} ms
// Resolved value will be `null` when there's an error or it takes too long
// Note: The promise will continue running in the background, even if the timeout is hit
async function promiseTimeout(promise, timeout) {
  return new Promise(resolve => {
    let resolved = false;
    let timer;
    const finish = data => {
      if (resolved) return;
      resolved = true;
      timer && clearTimeout(timer);
      resolve(data || null);
    };
    if (timeout) {
      timer = setTimeout(() => finish(), timeout);
    }
    promise.then(data => finish(data)).catch(() => finish());
  });
}
//# sourceMappingURL=util.mjs.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/feature-repository.mjs

// Config settings
const cacheSettings = {
  // Consider a fetch stale after 1 minute
  staleTTL: 1000 * 60,
  // Max time to keep a fetch in cache (4 hours default)
  maxAge: 1000 * 60 * 60 * 4,
  cacheKey: "gbFeaturesCache",
  backgroundSync: true,
  maxEntries: 10,
  disableIdleStreams: false,
  idleStreamInterval: 20000,
  disableCache: false
};
const feature_repository_polyfills = getPolyfills();
const feature_repository_helpers = {
  fetchFeaturesCall: ({
    host,
    clientKey,
    headers
  }) => {
    return feature_repository_polyfills.fetch(`${host}/api/features/${clientKey}`, {
      headers
    });
  },
  fetchRemoteEvalCall: ({
    host,
    clientKey,
    payload,
    headers
  }) => {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers
      },
      body: JSON.stringify(payload)
    };
    return feature_repository_polyfills.fetch(`${host}/api/eval/${clientKey}`, options);
  },
  eventSourceCall: ({
    host,
    clientKey,
    headers
  }) => {
    if (headers) {
      return new feature_repository_polyfills.EventSource(`${host}/sub/${clientKey}`, {
        headers
      });
    }
    return new feature_repository_polyfills.EventSource(`${host}/sub/${clientKey}`);
  },
  startIdleListener: () => {
    let idleTimeout;
    const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
    if (!isBrowser) return;
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        window.clearTimeout(idleTimeout);
        onVisible();
      } else if (document.visibilityState === "hidden") {
        idleTimeout = window.setTimeout(onHidden, cacheSettings.idleStreamInterval);
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  },
  stopIdleListener: () => {
    // No-op, replaced by startIdleListener
  }
};
try {
  if (globalThis.localStorage) {
    feature_repository_polyfills.localStorage = globalThis.localStorage;
  }
} catch (e) {
  // Ignore localStorage errors
}

// Global state
const subscribedInstances = new Map();
let cacheInitialized = false;
const cache = new Map();
const activeFetches = new Map();
const streams = new Map();
const supportsSSE = new Set();

// Public functions
function setPolyfills(overrides) {
  Object.assign(feature_repository_polyfills, overrides);
}
function configureCache(overrides) {
  Object.assign(cacheSettings, overrides);
  if (!cacheSettings.backgroundSync) {
    clearAutoRefresh();
  }
}
async function clearCache() {
  cache.clear();
  activeFetches.clear();
  clearAutoRefresh();
  cacheInitialized = false;
  await updatePersistentCache();
}

// Get or fetch features and refresh the SDK instance
async function feature_repository_refreshFeatures({
  instance,
  timeout,
  skipCache,
  allowStale,
  backgroundSync
}) {
  if (!backgroundSync) {
    cacheSettings.backgroundSync = false;
  }
  return fetchFeaturesWithCache({
    instance,
    allowStale,
    timeout,
    skipCache
  });
}

// Subscribe a GrowthBook instance to feature changes
function subscribe(instance) {
  const key = getKey(instance);
  const subs = subscribedInstances.get(key) || new Set();
  subs.add(instance);
  subscribedInstances.set(key, subs);
}
function unsubscribe(instance) {
  subscribedInstances.forEach(s => s.delete(instance));
}
function onHidden() {
  streams.forEach(channel => {
    if (!channel) return;
    channel.state = "idle";
    disableChannel(channel);
  });
}
function onVisible() {
  streams.forEach(channel => {
    if (!channel) return;
    if (channel.state !== "idle") return;
    enableChannel(channel);
  });
}

// Private functions

async function updatePersistentCache() {
  try {
    if (!feature_repository_polyfills.localStorage) return;
    await feature_repository_polyfills.localStorage.setItem(cacheSettings.cacheKey, JSON.stringify(Array.from(cache.entries())));
  } catch (e) {
    // Ignore localStorage errors
  }
}

// SWR wrapper for fetching features. May indirectly or directly start SSE streaming.
async function fetchFeaturesWithCache({
  instance,
  allowStale,
  timeout,
  skipCache
}) {
  const key = getKey(instance);
  const cacheKey = getCacheKey(instance);
  const now = new Date();
  const minStaleAt = new Date(now.getTime() - cacheSettings.maxAge + cacheSettings.staleTTL);
  await initializeCache();
  const existing = !cacheSettings.disableCache && !skipCache ? cache.get(cacheKey) : undefined;
  if (existing && (allowStale || existing.staleAt > now) && existing.staleAt > minStaleAt) {
    // Restore from cache whether SSE is supported
    if (existing.sse) supportsSSE.add(key);

    // Reload features in the background if stale
    if (existing.staleAt < now) {
      fetchFeatures(instance);
    }
    // Otherwise, if we don't need to refresh now, start a background sync
    else {
      startAutoRefresh(instance);
    }
    return {
      data: existing.data,
      success: true,
      source: "cache"
    };
  } else {
    const res = await promiseTimeout(fetchFeatures(instance), timeout);
    return res || {
      data: null,
      success: false,
      source: "timeout",
      error: new Error("Timeout")
    };
  }
}
function getKey(instance) {
  const [apiHost, clientKey] = instance.getApiInfo();
  return `${apiHost}||${clientKey}`;
}
function getCacheKey(instance) {
  const baseKey = getKey(instance);
  if (!("isRemoteEval" in instance) || !instance.isRemoteEval()) return baseKey;
  const attributes = instance.getAttributes();
  const cacheKeyAttributes = instance.getCacheKeyAttributes() || Object.keys(instance.getAttributes());
  const ca = {};
  cacheKeyAttributes.forEach(key => {
    ca[key] = attributes[key];
  });
  const fv = instance.getForcedVariations();
  const url = instance.getUrl();
  return `${baseKey}||${JSON.stringify({
    ca,
    fv,
    url
  })}`;
}

// Populate cache from localStorage (if available)
async function initializeCache() {
  if (cacheInitialized) return;
  cacheInitialized = true;
  try {
    if (feature_repository_polyfills.localStorage) {
      const value = await feature_repository_polyfills.localStorage.getItem(cacheSettings.cacheKey);
      if (!cacheSettings.disableCache && value) {
        const parsed = JSON.parse(value);
        if (parsed && Array.isArray(parsed)) {
          parsed.forEach(([key, data]) => {
            cache.set(key, {
              ...data,
              staleAt: new Date(data.staleAt)
            });
          });
        }
        cleanupCache();
      }
    }
  } catch (e) {
    // Ignore localStorage errors
  }
  if (!cacheSettings.disableIdleStreams) {
    const cleanupFn = feature_repository_helpers.startIdleListener();
    if (cleanupFn) {
      feature_repository_helpers.stopIdleListener = cleanupFn;
    }
  }
}

// Enforce the maxEntries limit
function cleanupCache() {
  const entriesWithTimestamps = Array.from(cache.entries()).map(([key, value]) => ({
    key,
    staleAt: value.staleAt.getTime()
  })).sort((a, b) => a.staleAt - b.staleAt);
  const entriesToRemoveCount = Math.min(Math.max(0, cache.size - cacheSettings.maxEntries), cache.size);
  for (let i = 0; i < entriesToRemoveCount; i++) {
    cache.delete(entriesWithTimestamps[i].key);
  }
}

// Called whenever new features are fetched from the API
function onNewFeatureData(key, cacheKey, data) {
  // If contents haven't changed, ignore the update, extend the stale TTL
  const version = data.dateUpdated || "";
  const staleAt = new Date(Date.now() + cacheSettings.staleTTL);
  const existing = !cacheSettings.disableCache ? cache.get(cacheKey) : undefined;
  if (existing && version && existing.version === version) {
    existing.staleAt = staleAt;
    updatePersistentCache();
    return;
  }
  if (!cacheSettings.disableCache) {
    // Update in-memory cache
    cache.set(cacheKey, {
      data,
      version,
      staleAt,
      sse: supportsSSE.has(key)
    });
    cleanupCache();
  }
  // Update local storage (don't await this, just update asynchronously)
  updatePersistentCache();

  // Update features for all subscribed GrowthBook instances
  const instances = subscribedInstances.get(key);
  instances && instances.forEach(instance => refreshInstance(instance, data));
}
async function refreshInstance(instance, data) {
  await instance.setPayload(data || instance.getPayload());
}

// Fetch the features payload from helper function or from in-mem injected payload
async function fetchFeatures(instance) {
  const {
    apiHost,
    apiRequestHeaders
  } = instance.getApiHosts();
  const clientKey = instance.getClientKey();
  const remoteEval = "isRemoteEval" in instance && instance.isRemoteEval();
  const key = getKey(instance);
  const cacheKey = getCacheKey(instance);
  let promise = activeFetches.get(cacheKey);
  if (!promise) {
    const fetcher = remoteEval ? feature_repository_helpers.fetchRemoteEvalCall({
      host: apiHost,
      clientKey,
      payload: {
        attributes: instance.getAttributes(),
        forcedVariations: instance.getForcedVariations(),
        forcedFeatures: Array.from(instance.getForcedFeatures().entries()),
        url: instance.getUrl()
      },
      headers: apiRequestHeaders
    }) : feature_repository_helpers.fetchFeaturesCall({
      host: apiHost,
      clientKey,
      headers: apiRequestHeaders
    });

    // TODO: auto-retry if status code indicates a temporary error
    promise = fetcher.then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error: ${res.status}`);
      }
      if (res.headers.get("x-sse-support") === "enabled") {
        supportsSSE.add(key);
      }
      return res.json();
    }).then(data => {
      onNewFeatureData(key, cacheKey, data);
      startAutoRefresh(instance);
      activeFetches.delete(cacheKey);
      return {
        data,
        success: true,
        source: "network"
      };
    }).catch(e => {
       false && 0;
      activeFetches.delete(cacheKey);
      return {
        data: null,
        source: "error",
        success: false,
        error: e
      };
    });
    activeFetches.set(cacheKey, promise);
  }
  return promise;
}

// Start SSE streaming, listens to feature payload changes and triggers a refresh or re-fetch
function startAutoRefresh(instance, forceSSE = false) {
  const key = getKey(instance);
  const cacheKey = getCacheKey(instance);
  const {
    streamingHost,
    streamingHostRequestHeaders
  } = instance.getApiHosts();
  const clientKey = instance.getClientKey();
  if (forceSSE) {
    supportsSSE.add(key);
  }
  if (cacheSettings.backgroundSync && supportsSSE.has(key) && feature_repository_polyfills.EventSource) {
    if (streams.has(key)) return;
    const channel = {
      src: null,
      host: streamingHost,
      clientKey,
      headers: streamingHostRequestHeaders,
      cb: event => {
        try {
          if (event.type === "features-updated") {
            const instances = subscribedInstances.get(key);
            instances && instances.forEach(instance => {
              fetchFeatures(instance);
            });
          } else if (event.type === "features") {
            const json = JSON.parse(event.data);
            onNewFeatureData(key, cacheKey, json);
          }
          // Reset error count on success
          channel.errors = 0;
        } catch (e) {
           false && 0;
          onSSEError(channel);
        }
      },
      errors: 0,
      state: "active"
    };
    streams.set(key, channel);
    enableChannel(channel);
  }
}
function onSSEError(channel) {
  if (channel.state === "idle") return;
  channel.errors++;
  if (channel.errors > 3 || channel.src && channel.src.readyState === 2) {
    // exponential backoff after 4 errors, with jitter
    const delay = Math.pow(3, channel.errors - 3) * (1000 + Math.random() * 1000);
    disableChannel(channel);
    setTimeout(() => {
      if (["idle", "active"].includes(channel.state)) return;
      enableChannel(channel);
    }, Math.min(delay, 300000)); // 5 minutes max
  }
}
function disableChannel(channel) {
  if (!channel.src) return;
  channel.src.onopen = null;
  channel.src.onerror = null;
  channel.src.close();
  channel.src = null;
  if (channel.state === "active") {
    channel.state = "disabled";
  }
}
function enableChannel(channel) {
  channel.src = feature_repository_helpers.eventSourceCall({
    host: channel.host,
    clientKey: channel.clientKey,
    headers: channel.headers
  });
  channel.state = "active";
  channel.src.addEventListener("features", channel.cb);
  channel.src.addEventListener("features-updated", channel.cb);
  channel.src.onerror = () => onSSEError(channel);
  channel.src.onopen = () => {
    channel.errors = 0;
  };
}
function destroyChannel(channel, key) {
  disableChannel(channel);
  streams.delete(key);
}
function clearAutoRefresh() {
  // Clear list of which keys are auto-updated
  supportsSSE.clear();

  // Stop listening for any SSE events
  streams.forEach(destroyChannel);

  // Remove all references to GrowthBook instances
  subscribedInstances.clear();

  // Run the idle stream cleanup function
  feature_repository_helpers.stopIdleListener();
}
function startStreaming(instance, options) {
  if (options.streaming) {
    if (!instance.getClientKey()) {
      throw new Error("Must specify clientKey to enable streaming");
    }
    if (options.payload) {
      startAutoRefresh(instance, true);
    }
    subscribe(instance);
  }
}
//# sourceMappingURL=feature-repository.mjs.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/mongrule.mjs
/* eslint-disable @typescript-eslint/no-explicit-any */


const _regexCache = {};

// The top-level condition evaluation function
function evalCondition(obj, condition,
// Must be included for `condition` to correctly evaluate group Operators
savedGroups) {
  savedGroups = savedGroups || {};
  // Condition is an object, keys are either specific operators or object paths
  // values are either arguments for operators or conditions for paths
  for (const [k, v] of Object.entries(condition)) {
    switch (k) {
      case "$or":
        if (!evalOr(obj, v, savedGroups)) return false;
        break;
      case "$nor":
        if (evalOr(obj, v, savedGroups)) return false;
        break;
      case "$and":
        if (!evalAnd(obj, v, savedGroups)) return false;
        break;
      case "$not":
        if (evalCondition(obj, v, savedGroups)) return false;
        break;
      default:
        if (!evalConditionValue(v, getPath(obj, k), savedGroups)) return false;
    }
  }
  return true;
}

// Return value at dot-separated path of an object
function getPath(obj, path) {
  const parts = path.split(".");
  let current = obj;
  for (let i = 0; i < parts.length; i++) {
    if (current && typeof current === "object" && parts[i] in current) {
      current = current[parts[i]];
    } else {
      return null;
    }
  }
  return current;
}

// Transform a regex string into a real RegExp object
function getRegex(regex, insensitive = false) {
  const cacheKey = `${regex}${insensitive ? "/i" : ""}`;
  if (!_regexCache[cacheKey]) {
    _regexCache[cacheKey] = new RegExp(regex.replace(/([^\\])\//g, "$1\\/"), insensitive ? "i" : undefined);
  }
  return _regexCache[cacheKey];
}

// Evaluate a single value against a condition
function evalConditionValue(condition, value, savedGroups, insensitive = false) {
  // Simple equality comparisons
  if (typeof condition === "string") {
    if (insensitive) {
      return String(value).toLowerCase() === condition.toLowerCase();
    }
    return value + "" === condition;
  }
  if (typeof condition === "number") {
    return value * 1 === condition;
  }
  if (typeof condition === "boolean") {
    return value !== null && !!value === condition;
  }
  if (condition === null) {
    return value === null;
  }
  if (Array.isArray(condition) || !isOperatorObject(condition)) {
    return JSON.stringify(value) === JSON.stringify(condition);
  }

  // This is a special operator condition and we should evaluate each one separately
  for (const op in condition) {
    if (!evalOperatorCondition(op, value, condition[op], savedGroups)) {
      return false;
    }
  }
  return true;
}

// If the object has only keys that start with '$'
function isOperatorObject(obj) {
  const keys = Object.keys(obj);
  return keys.length > 0 && keys.filter(k => k[0] === "$").length === keys.length;
}

// Return the data type of a value
function getType(v) {
  if (v === null) return "null";
  if (Array.isArray(v)) return "array";
  const t = typeof v;
  if (["string", "number", "boolean", "object", "undefined"].includes(t)) {
    return t;
  }
  return "unknown";
}

// At least one element of actual must match the expected condition/value
function elemMatch(actual, expected, savedGroups) {
  if (!Array.isArray(actual)) return false;
  const check = isOperatorObject(expected) ? v => evalConditionValue(expected, v, savedGroups) : v => evalCondition(v, expected, savedGroups);
  for (let i = 0; i < actual.length; i++) {
    if (actual[i] && check(actual[i])) {
      return true;
    }
  }
  return false;
}
function isIn(actual, expected, insensitive = false) {
  if (insensitive) {
    const caseFold = val => typeof val === "string" ? val.toLowerCase() : val;
    // Do an intersection if attribute is an array (insensitive)
    if (Array.isArray(actual)) {
      return actual.some(el => expected.some(exp => caseFold(el) === caseFold(exp)));
    }
    return expected.some(exp => caseFold(actual) === caseFold(exp));
  }
  // Do an intersection if attribute is an array
  if (Array.isArray(actual)) {
    return actual.some(el => expected.includes(el));
  }
  return expected.includes(actual);
}
function isInAll(actual, expected, savedGroups, insensitive = false) {
  if (!Array.isArray(actual)) return false;
  for (let i = 0; i < expected.length; i++) {
    let passed = false;
    for (let j = 0; j < actual.length; j++) {
      if (evalConditionValue(expected[i], actual[j], savedGroups, insensitive)) {
        passed = true;
        break;
      }
    }
    if (!passed) return false;
  }
  return true;
}

// Evaluate a single operator condition
function evalOperatorCondition(operator, actual, expected, savedGroups) {
  switch (operator) {
    case "$veq":
      return paddedVersionString(actual) === paddedVersionString(expected);
    case "$vne":
      return paddedVersionString(actual) !== paddedVersionString(expected);
    case "$vgt":
      return paddedVersionString(actual) > paddedVersionString(expected);
    case "$vgte":
      return paddedVersionString(actual) >= paddedVersionString(expected);
    case "$vlt":
      return paddedVersionString(actual) < paddedVersionString(expected);
    case "$vlte":
      return paddedVersionString(actual) <= paddedVersionString(expected);
    case "$eq":
      return actual === expected;
    case "$ne":
      return actual !== expected;
    case "$lt":
      return actual < expected;
    case "$lte":
      return actual <= expected;
    case "$gt":
      return actual > expected;
    case "$gte":
      return actual >= expected;
    case "$exists":
      // Using `!=` and `==` instead of strict checks so it also matches for undefined
      return expected ? actual != null : actual == null;
    case "$in":
      if (!Array.isArray(expected)) return false;
      return isIn(actual, expected);
    case "$ini":
      if (!Array.isArray(expected)) return false;
      return isIn(actual, expected, true);
    case "$inGroup":
      return isIn(actual, savedGroups[expected] || []);
    case "$notInGroup":
      return !isIn(actual, savedGroups[expected] || []);
    case "$nin":
      if (!Array.isArray(expected)) return false;
      return !isIn(actual, expected);
    case "$nini":
      if (!Array.isArray(expected)) return false;
      return !isIn(actual, expected, true);
    case "$not":
      return !evalConditionValue(expected, actual, savedGroups);
    case "$size":
      if (!Array.isArray(actual)) return false;
      return evalConditionValue(expected, actual.length, savedGroups);
    case "$elemMatch":
      return elemMatch(actual, expected, savedGroups);
    case "$all":
      if (!Array.isArray(expected)) return false;
      return isInAll(actual, expected, savedGroups);
    case "$alli":
      if (!Array.isArray(expected)) return false;
      return isInAll(actual, expected, savedGroups, true);
    case "$regex":
      try {
        return getRegex(expected).test(actual);
      } catch (e) {
        return false;
      }
    case "$regexi":
      try {
        return getRegex(expected, true).test(actual);
      } catch (e) {
        return false;
      }
    case "$type":
      return getType(actual) === expected;
    default:
      console.error("Unknown operator: " + operator);
      return false;
  }
}

// Recursive $or rule
function evalOr(obj, conditions, savedGroups) {
  if (!conditions.length) return true;
  for (let i = 0; i < conditions.length; i++) {
    if (evalCondition(obj, conditions[i], savedGroups)) {
      return true;
    }
  }
  return false;
}

// Recursive $and rule
function evalAnd(obj, conditions, savedGroups) {
  for (let i = 0; i < conditions.length; i++) {
    if (!evalCondition(obj, conditions[i], savedGroups)) {
      return false;
    }
  }
  return true;
}
//# sourceMappingURL=mongrule.mjs.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/core.mjs


const EVENT_FEATURE_EVALUATED = "Feature Evaluated";
const EVENT_EXPERIMENT_VIEWED = "Experiment Viewed";
function getForcedFeatureValues(ctx) {
  // Merge user and global values
  const ret = new Map();
  if (ctx.global.forcedFeatureValues) {
    ctx.global.forcedFeatureValues.forEach((v, k) => ret.set(k, v));
  }
  if (ctx.user.forcedFeatureValues) {
    ctx.user.forcedFeatureValues.forEach((v, k) => ret.set(k, v));
  }
  return ret;
}
function getForcedVariations(ctx) {
  // Merge user and global values
  if (ctx.global.forcedVariations && ctx.user.forcedVariations) {
    return {
      ...ctx.global.forcedVariations,
      ...ctx.user.forcedVariations
    };
  } else if (ctx.global.forcedVariations) {
    return ctx.global.forcedVariations;
  } else if (ctx.user.forcedVariations) {
    return ctx.user.forcedVariations;
  } else {
    return {};
  }
}
async function safeCall(fn) {
  try {
    await fn();
  } catch (e) {
    // Do nothing
  }
}
function onExperimentViewed(ctx, experiment, result) {
  // Make sure a tracking callback is only fired once per unique experiment
  if (ctx.user.trackedExperiments) {
    const k = getExperimentDedupeKey(experiment, result);
    if (ctx.user.trackedExperiments.has(k)) {
      return [];
    }
    ctx.user.trackedExperiments.add(k);
  }
  if (ctx.user.enableDevMode && ctx.user.devLogs) {
    ctx.user.devLogs.push({
      experiment,
      result,
      timestamp: Date.now().toString(),
      logType: "experiment"
    });
  }
  const calls = [];
  if (ctx.global.trackingCallback) {
    const cb = ctx.global.trackingCallback;
    calls.push(safeCall(() => cb(experiment, result, ctx.user)));
  }
  if (ctx.user.trackingCallback) {
    const cb = ctx.user.trackingCallback;
    calls.push(safeCall(() => cb(experiment, result)));
  }
  if (ctx.global.eventLogger) {
    const cb = ctx.global.eventLogger;
    calls.push(safeCall(() => cb(EVENT_EXPERIMENT_VIEWED, {
      experimentId: experiment.key,
      variationId: result.key,
      hashAttribute: result.hashAttribute,
      hashValue: result.hashValue
    }, ctx.user)));
  }
  return calls;
}
function onFeatureUsage(ctx, key, ret) {
  // Only track a feature once, unless the assigned value changed
  if (ctx.user.trackedFeatureUsage) {
    const stringifiedValue = JSON.stringify(ret.value);
    if (ctx.user.trackedFeatureUsage[key] === stringifiedValue) return;
    ctx.user.trackedFeatureUsage[key] = stringifiedValue;
    if (ctx.user.enableDevMode && ctx.user.devLogs) {
      ctx.user.devLogs.push({
        featureKey: key,
        result: ret,
        timestamp: Date.now().toString(),
        logType: "feature"
      });
    }
  }
  if (ctx.global.onFeatureUsage) {
    const cb = ctx.global.onFeatureUsage;
    safeCall(() => cb(key, ret, ctx.user));
  }
  if (ctx.user.onFeatureUsage) {
    const cb = ctx.user.onFeatureUsage;
    safeCall(() => cb(key, ret));
  }
  if (ctx.global.eventLogger) {
    const cb = ctx.global.eventLogger;
    safeCall(() => cb(EVENT_FEATURE_EVALUATED, {
      feature: key,
      source: ret.source,
      value: ret.value,
      ruleId: ret.source === "defaultValue" ? "$default" : ret.ruleId || "",
      variationId: ret.experimentResult ? ret.experimentResult.key : ""
    }, ctx.user));
  }
}
function evalFeature(id, ctx) {
  if (ctx.stack.evaluatedFeatures.has(id)) {
     false && 0;
    return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
  }
  ctx.stack.evaluatedFeatures.add(id);
  ctx.stack.id = id;

  // Global override
  const forcedValues = getForcedFeatureValues(ctx);
  if (forcedValues.has(id)) {
     false && 0;
    return getFeatureResult(ctx, id, forcedValues.get(id), "override");
  }

  // Unknown feature id
  if (!ctx.global.features || !ctx.global.features[id]) {
     false && 0;
    return getFeatureResult(ctx, id, null, "unknownFeature");
  }

  // Get the feature
  const feature = ctx.global.features[id];

  // Loop through the rules
  if (feature.rules) {
    const evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
    rules: for (const rule of feature.rules) {
      // If there are prerequisite flag(s), evaluate them
      if (rule.parentConditions) {
        for (const parentCondition of rule.parentConditions) {
          ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
          const parentResult = evalFeature(parentCondition.id, ctx);
          // break out for cyclic prerequisites
          if (parentResult.source === "cyclicPrerequisite") {
            return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
          }
          const evalObj = {
            value: parentResult.value
          };
          const evaled = evalCondition(evalObj, parentCondition.condition || {});
          if (!evaled) {
            // blocking prerequisite eval failed: feature evaluation fails
            if (parentCondition.gate) {
               false && 0;
              return getFeatureResult(ctx, id, null, "prerequisite");
            }
            // non-blocking prerequisite eval failed: break out of parentConditions loop, jump to the next rule
             false && 0;
            continue rules;
          }
        }
      }

      // If there are filters for who is included (e.g. namespaces)
      if (rule.filters && isFilteredOut(rule.filters, ctx)) {
         false && 0;
        continue;
      }

      // Feature value is being forced
      if ("force" in rule) {
        // If it's a conditional rule, skip if the condition doesn't pass
        if (rule.condition && !conditionPasses(rule.condition, ctx)) {
           false && 0;
          continue;
        }

        // If this is a percentage rollout, skip if not included
        if (!isIncludedInRollout(ctx, rule.seed || id, rule.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !rule.disableStickyBucketing ? rule.fallbackAttribute : undefined, rule.range, rule.coverage, rule.hashVersion)) {
           false && 0;
          continue;
        }
         false && 0;

        // If this was a remotely evaluated experiment, fire the tracking callbacks
        if (rule.tracks) {
          rule.tracks.forEach(t => {
            const calls = onExperimentViewed(ctx, t.experiment, t.result);
            if (!calls.length && ctx.global.saveDeferredTrack) {
              ctx.global.saveDeferredTrack({
                experiment: t.experiment,
                result: t.result
              });
            }
          });
        }
        return getFeatureResult(ctx, id, rule.force, "force", rule.id);
      }
      if (!rule.variations) {
         false && 0;
        continue;
      }

      // For experiment rules, run an experiment
      const exp = {
        variations: rule.variations,
        key: rule.key || id
      };
      if ("coverage" in rule) exp.coverage = rule.coverage;
      if (rule.weights) exp.weights = rule.weights;
      if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
      if (rule.fallbackAttribute) exp.fallbackAttribute = rule.fallbackAttribute;
      if (rule.disableStickyBucketing) exp.disableStickyBucketing = rule.disableStickyBucketing;
      if (rule.bucketVersion !== undefined) exp.bucketVersion = rule.bucketVersion;
      if (rule.minBucketVersion !== undefined) exp.minBucketVersion = rule.minBucketVersion;
      if (rule.namespace) exp.namespace = rule.namespace;
      if (rule.meta) exp.meta = rule.meta;
      if (rule.ranges) exp.ranges = rule.ranges;
      if (rule.name) exp.name = rule.name;
      if (rule.phase) exp.phase = rule.phase;
      if (rule.seed) exp.seed = rule.seed;
      if (rule.hashVersion) exp.hashVersion = rule.hashVersion;
      if (rule.filters) exp.filters = rule.filters;
      if (rule.condition) exp.condition = rule.condition;

      // Only return a value if the user is part of the experiment
      const {
        result
      } = runExperiment(exp, id, ctx);
      ctx.global.onExperimentEval && ctx.global.onExperimentEval(exp, result);
      if (result.inExperiment && !result.passthrough) {
        return getFeatureResult(ctx, id, result.value, "experiment", rule.id, exp, result);
      }
    }
  }
   false && 0;

  // Fall back to using the default value
  return getFeatureResult(ctx, id, feature.defaultValue === undefined ? null : feature.defaultValue, "defaultValue");
}
function runExperiment(experiment, featureId, ctx) {
  const key = experiment.key;
  const numVariations = experiment.variations.length;

  // 1. If experiment has less than 2 variations, return immediately
  if (numVariations < 2) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2. If the context is disabled, return immediately
  if (ctx.global.enabled === false || ctx.user.enabled === false) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2.5. Merge in experiment overrides from the context
  experiment = mergeOverrides(experiment, ctx);

  // 2.6 New, more powerful URL targeting
  if (experiment.urlPatterns && !isURLTargeted(ctx.user.url || "", experiment.urlPatterns)) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 3. If a variation is forced from a querystring, return the forced variation
  const qsOverride = getQueryStringOverride(key, ctx.user.url || "", numVariations);
  if (qsOverride !== null) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, qsOverride, false, featureId)
    };
  }

  // 4. If a variation is forced in the context, return the forced variation
  const forcedVariations = getForcedVariations(ctx);
  if (key in forcedVariations) {
    const variation = forcedVariations[key];
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, variation, false, featureId)
    };
  }

  // 5. Exclude if a draft experiment or not active
  if (experiment.status === "draft" || experiment.active === false) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 6. Get the hash attribute and return if empty
  const {
    hashAttribute,
    hashValue
  } = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined);
  if (!hashValue) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  let assigned = -1;
  let foundStickyBucket = false;
  let stickyBucketVersionIsBlocked = false;
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    const {
      variation,
      versionIsBlocked
    } = getStickyBucketVariation({
      ctx,
      expKey: experiment.key,
      expBucketVersion: experiment.bucketVersion,
      expHashAttribute: experiment.hashAttribute,
      expFallbackAttribute: experiment.fallbackAttribute,
      expMinBucketVersion: experiment.minBucketVersion,
      expMeta: experiment.meta
    });
    foundStickyBucket = variation >= 0;
    assigned = variation;
    stickyBucketVersionIsBlocked = !!versionIsBlocked;
  }

  // Some checks are not needed if we already have a sticky bucket
  if (!foundStickyBucket) {
    // 7. Exclude if user is filtered out (used to be called "namespace")
    if (experiment.filters) {
      if (isFilteredOut(experiment.filters, ctx)) {
         false && 0;
        return {
          result: getExperimentResult(ctx, experiment, -1, false, featureId)
        };
      }
    } else if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
       false && 0;
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 7.5. Exclude if experiment.include returns false or throws
    if (experiment.include && !isIncluded(experiment.include)) {
       false && 0;
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8. Exclude if condition is false
    if (experiment.condition && !conditionPasses(experiment.condition, ctx)) {
       false && 0;
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8.05. Exclude if prerequisites are not met
    if (experiment.parentConditions) {
      const evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
      for (const parentCondition of experiment.parentConditions) {
        ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
        const parentResult = evalFeature(parentCondition.id, ctx);
        // break out for cyclic prerequisites
        if (parentResult.source === "cyclicPrerequisite") {
          return {
            result: getExperimentResult(ctx, experiment, -1, false, featureId)
          };
        }
        const evalObj = {
          value: parentResult.value
        };
        if (!evalCondition(evalObj, parentCondition.condition || {})) {
           false && 0;
          return {
            result: getExperimentResult(ctx, experiment, -1, false, featureId)
          };
        }
      }
    }

    // 8.1. Exclude if user is not in a required group
    if (experiment.groups && !hasGroupOverlap(experiment.groups, ctx)) {
       false && 0;
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }
  }

  // 8.2. Old style URL targeting
  if (experiment.url && !urlIsValid(experiment.url, ctx)) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 9. Get the variation from the sticky bucket or get bucket ranges and choose variation
  const n = hash(experiment.seed || key, hashValue, experiment.hashVersion || 1);
  if (n === null) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  if (!foundStickyBucket) {
    const ranges = experiment.ranges || getBucketRanges(numVariations, experiment.coverage === undefined ? 1 : experiment.coverage, experiment.weights);
    assigned = chooseVariation(n, ranges);
  }

  // 9.5 Unenroll if any prior sticky buckets are blocked by version
  if (stickyBucketVersionIsBlocked) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId, undefined, true)
    };
  }

  // 10. Return if not in experiment
  if (assigned < 0) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 11. Experiment has a forced variation
  if ("force" in experiment) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, experiment.force === undefined ? -1 : experiment.force, false, featureId)
    };
  }

  // 12. Exclude if in QA mode
  if (ctx.global.qaMode || ctx.user.qaMode) {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 12.5. Exclude if experiment is stopped
  if (experiment.status === "stopped") {
     false && 0;
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 13. Build the result object
  const result = getExperimentResult(ctx, experiment, assigned, true, featureId, n, foundStickyBucket);

  // 13.5. Persist sticky bucket
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    const {
      changed,
      key: attrKey,
      doc
    } = generateStickyBucketAssignmentDoc(ctx, hashAttribute, util_toString(hashValue), {
      [getStickyBucketExperimentKey(experiment.key, experiment.bucketVersion)]: result.key
    });
    if (changed) {
      // update local docs
      ctx.user.stickyBucketAssignmentDocs = ctx.user.stickyBucketAssignmentDocs || {};
      ctx.user.stickyBucketAssignmentDocs[attrKey] = doc;
      // save doc
      ctx.user.saveStickyBucketAssignmentDoc(doc);
    }
  }

  // 14. Fire the tracking callback(s)
  // Store the promise in case we're awaiting it (ex: browser url redirects)
  const trackingCalls = onExperimentViewed(ctx, experiment, result);
  if (trackingCalls.length === 0 && ctx.global.saveDeferredTrack) {
    ctx.global.saveDeferredTrack({
      experiment,
      result
    });
  }
  const trackingCall = !trackingCalls.length ? undefined : trackingCalls.length === 1 ? trackingCalls[0] : Promise.all(trackingCalls).then(() => {});

  // 14.1 Keep track of completed changeIds
  "changeId" in experiment && experiment.changeId && ctx.global.recordChangeId && ctx.global.recordChangeId(experiment.changeId);

  // 15. Return the result
   false && 0;
  return {
    result,
    trackingCall
  };
}
function getFeatureResult(ctx, key, value, source, ruleId, experiment, result) {
  const ret = {
    value,
    on: !!value,
    off: !value,
    source,
    ruleId: ruleId || ""
  };
  if (experiment) ret.experiment = experiment;
  if (result) ret.experimentResult = result;

  // Track the usage of this feature in real-time
  if (source !== "override") {
    onFeatureUsage(ctx, key, ret);
  }
  return ret;
}
function getAttributes(ctx) {
  return {
    ...ctx.user.attributes,
    ...ctx.user.attributeOverrides
  };
}
function conditionPasses(condition, ctx) {
  return evalCondition(getAttributes(ctx), condition, ctx.global.savedGroups || {});
}
function isFilteredOut(filters, ctx) {
  return filters.some(filter => {
    const {
      hashValue
    } = getHashAttribute(ctx, filter.attribute);
    if (!hashValue) return true;
    const n = hash(filter.seed, hashValue, filter.hashVersion || 2);
    if (n === null) return true;
    return !filter.ranges.some(r => inRange(n, r));
  });
}
function isIncludedInRollout(ctx, seed, hashAttribute, fallbackAttribute, range, coverage, hashVersion) {
  if (!range && coverage === undefined) return true;
  if (!range && coverage === 0) return false;
  const {
    hashValue
  } = getHashAttribute(ctx, hashAttribute, fallbackAttribute);
  if (!hashValue) {
    return false;
  }
  const n = hash(seed, hashValue, hashVersion || 1);
  if (n === null) return false;
  return range ? inRange(n, range) : coverage !== undefined ? n <= coverage : true;
}
function getExperimentResult(ctx, experiment, variationIndex, hashUsed, featureId, bucket, stickyBucketUsed) {
  let inExperiment = true;
  // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
  if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
    variationIndex = 0;
    inExperiment = false;
  }
  const {
    hashAttribute,
    hashValue
  } = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined);
  const meta = experiment.meta ? experiment.meta[variationIndex] : {};
  const res = {
    key: meta.key || "" + variationIndex,
    featureId,
    inExperiment,
    hashUsed,
    variationId: variationIndex,
    value: experiment.variations[variationIndex],
    hashAttribute,
    hashValue,
    stickyBucketUsed: !!stickyBucketUsed
  };
  if (meta.name) res.name = meta.name;
  if (bucket !== undefined) res.bucket = bucket;
  if (meta.passthrough) res.passthrough = meta.passthrough;
  return res;
}
function mergeOverrides(experiment, ctx) {
  const key = experiment.key;
  const o = ctx.global.overrides;
  if (o && o[key]) {
    experiment = Object.assign({}, experiment, o[key]);
    if (typeof experiment.url === "string") {
      experiment.url = getUrlRegExp(
      // eslint-disable-next-line
      experiment.url);
    }
  }
  return experiment;
}
function getHashAttribute(ctx, attr, fallback) {
  let hashAttribute = attr || "id";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let hashValue = "";
  const attributes = getAttributes(ctx);
  if (attributes[hashAttribute]) {
    hashValue = attributes[hashAttribute];
  }

  // if no match, try fallback
  if (!hashValue && fallback) {
    if (attributes[fallback]) {
      hashValue = attributes[fallback];
    }
    if (hashValue) {
      hashAttribute = fallback;
    }
  }
  return {
    hashAttribute,
    hashValue
  };
}
function urlIsValid(urlRegex, ctx) {
  const url = ctx.user.url;
  if (!url) return false;
  const pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
  if (urlRegex.test(url)) return true;
  if (urlRegex.test(pathOnly)) return true;
  return false;
}
function hasGroupOverlap(expGroups, ctx) {
  const groups = ctx.global.groups || {};
  for (let i = 0; i < expGroups.length; i++) {
    if (groups[expGroups[i]]) return true;
  }
  return false;
}
function getStickyBucketVariation({
  ctx,
  expKey,
  expBucketVersion,
  expHashAttribute,
  expFallbackAttribute,
  expMinBucketVersion,
  expMeta
}) {
  expBucketVersion = expBucketVersion || 0;
  expMinBucketVersion = expMinBucketVersion || 0;
  expHashAttribute = expHashAttribute || "id";
  expMeta = expMeta || [];
  const id = getStickyBucketExperimentKey(expKey, expBucketVersion);
  const assignments = getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute);

  // users with any blocked bucket version (0 to minExperimentBucketVersion - 1) are excluded from the test
  if (expMinBucketVersion > 0) {
    for (let i = 0; i < expMinBucketVersion; i++) {
      const blockedKey = getStickyBucketExperimentKey(expKey, i);
      if (assignments[blockedKey] !== undefined) {
        return {
          variation: -1,
          versionIsBlocked: true
        };
      }
    }
  }
  const variationKey = assignments[id];
  if (variationKey === undefined)
    // no assignment found
    return {
      variation: -1
    };
  const variation = expMeta.findIndex(m => m.key === variationKey);
  if (variation < 0)
    // invalid assignment, treat as "no assignment found"
    return {
      variation: -1
    };
  return {
    variation
  };
}
function getStickyBucketExperimentKey(experimentKey, experimentBucketVersion) {
  experimentBucketVersion = experimentBucketVersion || 0;
  return `${experimentKey}__${experimentBucketVersion}`;
}
function getStickyBucketAttributeKey(attributeName, attributeValue) {
  return `${attributeName}||${attributeValue}`;
}
function getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute) {
  if (!ctx.user.stickyBucketAssignmentDocs) return {};
  const {
    hashAttribute,
    hashValue
  } = getHashAttribute(ctx, expHashAttribute);
  const hashKey = getStickyBucketAttributeKey(hashAttribute, util_toString(hashValue));
  const {
    hashAttribute: fallbackAttribute,
    hashValue: fallbackValue
  } = getHashAttribute(ctx, expFallbackAttribute);
  const fallbackKey = fallbackValue ? getStickyBucketAttributeKey(fallbackAttribute, util_toString(fallbackValue)) : null;
  const assignments = {};
  if (fallbackKey && ctx.user.stickyBucketAssignmentDocs[fallbackKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[fallbackKey].assignments || {});
  }
  if (ctx.user.stickyBucketAssignmentDocs[hashKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[hashKey].assignments || {});
  }
  return assignments;
}
function generateStickyBucketAssignmentDoc(ctx, attributeName, attributeValue, assignments) {
  const key = getStickyBucketAttributeKey(attributeName, attributeValue);
  const existingAssignments = ctx.user.stickyBucketAssignmentDocs && ctx.user.stickyBucketAssignmentDocs[key] ? ctx.user.stickyBucketAssignmentDocs[key].assignments || {} : {};
  const newAssignments = {
    ...existingAssignments,
    ...assignments
  };
  const changed = JSON.stringify(existingAssignments) !== JSON.stringify(newAssignments);
  return {
    key,
    doc: {
      attributeName,
      attributeValue,
      assignments: newAssignments
    },
    changed
  };
}
function deriveStickyBucketIdentifierAttributes(ctx, data) {
  const attributes = new Set();
  const features = data && data.features ? data.features : ctx.global.features || {};
  const experiments = data && data.experiments ? data.experiments : ctx.global.experiments || [];
  Object.keys(features).forEach(id => {
    const feature = features[id];
    if (feature.rules) {
      for (const rule of feature.rules) {
        if (rule.variations) {
          attributes.add(rule.hashAttribute || "id");
          if (rule.fallbackAttribute) {
            attributes.add(rule.fallbackAttribute);
          }
        }
      }
    }
  });
  experiments.map(experiment => {
    attributes.add(experiment.hashAttribute || "id");
    if (experiment.fallbackAttribute) {
      attributes.add(experiment.fallbackAttribute);
    }
  });
  return Array.from(attributes);
}
async function getAllStickyBucketAssignmentDocs(ctx, stickyBucketService, data) {
  const attributes = getStickyBucketAttributes(ctx, data);
  return stickyBucketService.getAllAssignments(attributes);
}
function getStickyBucketAttributes(ctx, data) {
  const attributes = {};
  const stickyBucketIdentifierAttributes = deriveStickyBucketIdentifierAttributes(ctx, data);
  stickyBucketIdentifierAttributes.forEach(attr => {
    const {
      hashValue
    } = getHashAttribute(ctx, attr);
    attributes[attr] = util_toString(hashValue);
  });
  return attributes;
}
async function decryptPayload(data, decryptionKey, subtle) {
  data = {
    ...data
  };
  if (data.encryptedFeatures) {
    try {
      data.features = JSON.parse(await decrypt(data.encryptedFeatures, decryptionKey, subtle));
    } catch (e) {
      console.error(e);
    }
    delete data.encryptedFeatures;
  }
  if (data.encryptedExperiments) {
    try {
      data.experiments = JSON.parse(await decrypt(data.encryptedExperiments, decryptionKey, subtle));
    } catch (e) {
      console.error(e);
    }
    delete data.encryptedExperiments;
  }
  if (data.encryptedSavedGroups) {
    try {
      data.savedGroups = JSON.parse(await decrypt(data.encryptedSavedGroups, decryptionKey, subtle));
    } catch (e) {
      console.error(e);
    }
    delete data.encryptedSavedGroups;
  }
  return data;
}
function getApiHosts(options) {
  const defaultHost = options.apiHost || "https://cdn.growthbook.io";
  return {
    apiHost: defaultHost.replace(/\/*$/, ""),
    streamingHost: (options.streamingHost || defaultHost).replace(/\/*$/, ""),
    apiRequestHeaders: options.apiHostRequestHeaders,
    streamingHostRequestHeaders: options.streamingHostRequestHeaders
  };
}
function getExperimentDedupeKey(experiment, result) {
  return result.hashAttribute + result.hashValue + experiment.key + result.variationId;
}
//# sourceMappingURL=core.mjs.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook/dist/esm/GrowthBook.mjs




const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
const SDK_VERSION = loadSDKVersion();
class GrowthBook_GrowthBook {
  // context is technically private, but some tools depend on it so we can't mangle the name

  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  constructor(options) {
    options = options || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._options = this.context = options;
    this._renderer = options.renderer || null;
    this._trackedExperiments = new Set();
    this._completedChangeIds = new Set();
    this._trackedFeatures = {};
    this.debug = !!options.debug;
    this._subscriptions = new Set();
    this.ready = false;
    this._assigned = new Map();
    this._activeAutoExperiments = new Map();
    this._triggeredExpKeys = new Set();
    this._initialized = false;
    this._redirectedUrl = "";
    this._deferredTrackingCalls = new Map();
    this._autoExperimentsAllowed = !options.disableExperimentsOnLoad;
    this._destroyCallbacks = [];
    this.logs = [];
    this.log = this.log.bind(this);
    this._saveDeferredTrack = this._saveDeferredTrack.bind(this);
    this._onExperimentEval = this._onExperimentEval.bind(this);
    this._fireSubscriptions = this._fireSubscriptions.bind(this);
    this._recordChangedId = this._recordChangedId.bind(this);
    if (options.remoteEval) {
      if (options.decryptionKey) {
        throw new Error("Encryption is not available for remoteEval");
      }
      if (!options.clientKey) {
        throw new Error("Missing clientKey");
      }
      let isGbHost = false;
      try {
        isGbHost = !!new URL(options.apiHost || "").hostname.match(/growthbook\.io$/i);
      } catch (e) {
        // ignore invalid URLs
      }
      if (isGbHost) {
        throw new Error("Cannot use remoteEval on GrowthBook Cloud");
      }
    } else {
      if (options.cacheKeyAttributes) {
        throw new Error("cacheKeyAttributes are only used for remoteEval");
      }
    }
    if (options.stickyBucketService) {
      const s = options.stickyBucketService;
      this._saveStickyBucketAssignmentDoc = doc => {
        return s.saveAssignments(doc);
      };
    }
    if (options.plugins) {
      for (const plugin of options.plugins) {
        plugin(this);
      }
    }
    if (options.features) {
      this.ready = true;
    }
    if (isBrowser && options.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
    if (options.experiments) {
      this.ready = true;
      this._updateAllAutoExperiments();
    }

    // Hydrate sticky bucket service
    if (this._options.stickyBucketService && this._options.stickyBucketAssignmentDocs) {
      for (const key in this._options.stickyBucketAssignmentDocs) {
        const doc = this._options.stickyBucketAssignmentDocs[key];
        if (doc) {
          this._options.stickyBucketService.saveAssignments(doc).catch(() => {
            // Ignore hydration errors
          });
        }
      }
    }

    // Legacy - passing in features/experiments into the constructor instead of using init
    if (this.ready) {
      this.refreshStickyBuckets(this.getPayload());
    }
  }
  async setPayload(payload) {
    this._payload = payload;
    const data = await decryptPayload(payload, this._options.decryptionKey);
    this._decryptedPayload = data;
    await this.refreshStickyBuckets(data);
    if (data.features) {
      this._options.features = data.features;
    }
    if (data.savedGroups) {
      this._options.savedGroups = data.savedGroups;
    }
    if (data.experiments) {
      this._options.experiments = data.experiments;
      this._updateAllAutoExperiments();
    }
    this.ready = true;
    this._render();
  }
  initSync(options) {
    this._initialized = true;
    const payload = options.payload;
    if (payload.encryptedExperiments || payload.encryptedFeatures) {
      throw new Error("initSync does not support encrypted payloads");
    }
    if (this._options.stickyBucketService && !this._options.stickyBucketAssignmentDocs) {
      this._options.stickyBucketAssignmentDocs = this.generateStickyBucketAssignmentDocsSync(this._options.stickyBucketService, payload);
    }
    this._payload = payload;
    this._decryptedPayload = payload;
    if (payload.features) {
      this._options.features = payload.features;
    }
    if (payload.experiments) {
      this._options.experiments = payload.experiments;
      this._updateAllAutoExperiments();
    }
    this.ready = true;
    startStreaming(this, options);
    return this;
  }
  async init(options) {
    this._initialized = true;
    options = options || {};
    if (options.cacheSettings) {
      configureCache(options.cacheSettings);
    }
    if (options.payload) {
      await this.setPayload(options.payload);
      startStreaming(this, options);
      return {
        success: true,
        source: "init"
      };
    } else {
      const {
        data,
        ...res
      } = await this._refresh({
        ...options,
        allowStale: true
      });
      startStreaming(this, options);
      await this.setPayload(data || {});
      return res;
    }
  }

  /** @deprecated Use {@link init} */
  async loadFeatures(options) {
    options = options || {};
    await this.init({
      skipCache: options.skipCache,
      timeout: options.timeout,
      streaming: (this._options.backgroundSync ?? true) && (options.autoRefresh || this._options.subscribeToChanges)
    });
  }
  async refreshFeatures(options) {
    const res = await this._refresh({
      ...(options || {}),
      allowStale: false
    });
    if (res.data) {
      await this.setPayload(res.data);
    }
  }
  getApiInfo() {
    return [this.getApiHosts().apiHost, this.getClientKey()];
  }
  getApiHosts() {
    return getApiHosts(this._options);
  }
  getClientKey() {
    return this._options.clientKey || "";
  }
  getPayload() {
    return this._payload || {
      features: this.getFeatures(),
      experiments: this.getExperiments()
    };
  }
  getDecryptedPayload() {
    return this._decryptedPayload || this.getPayload();
  }
  isRemoteEval() {
    return this._options.remoteEval || false;
  }
  getCacheKeyAttributes() {
    return this._options.cacheKeyAttributes;
  }
  async _refresh({
    timeout,
    skipCache,
    allowStale,
    streaming
  }) {
    if (!this._options.clientKey) {
      throw new Error("Missing clientKey");
    }
    // Trigger refresh in feature repository
    return feature_repository_refreshFeatures({
      instance: this,
      timeout,
      skipCache: skipCache || this._options.disableCache,
      allowStale,
      backgroundSync: streaming ?? this._options.backgroundSync ?? true
    });
  }
  _render() {
    if (this._renderer) {
      try {
        this._renderer();
      } catch (e) {
        console.error("Failed to render", e);
      }
    }
  }

  /** @deprecated Use {@link setPayload} */
  setFeatures(features) {
    this._options.features = features;
    this.ready = true;
    this._render();
  }

  /** @deprecated Use {@link setPayload} */
  async setEncryptedFeatures(encryptedString, decryptionKey, subtle) {
    const featuresJSON = await decrypt(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
    this.setFeatures(JSON.parse(featuresJSON));
  }

  /** @deprecated Use {@link setPayload} */
  setExperiments(experiments) {
    this._options.experiments = experiments;
    this.ready = true;
    this._updateAllAutoExperiments();
  }

  /** @deprecated Use {@link setPayload} */
  async setEncryptedExperiments(encryptedString, decryptionKey, subtle) {
    const experimentsJSON = await decrypt(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
    this.setExperiments(JSON.parse(experimentsJSON));
  }
  async setAttributes(attributes) {
    this._options.attributes = attributes;
    if (this._options.stickyBucketService) {
      await this.refreshStickyBuckets();
    }
    if (this._options.remoteEval) {
      await this._refreshForRemoteEval();
      return;
    }
    this._render();
    this._updateAllAutoExperiments();
  }
  async updateAttributes(attributes) {
    return this.setAttributes({
      ...this._options.attributes,
      ...attributes
    });
  }
  async setAttributeOverrides(overrides) {
    this._options.attributeOverrides = overrides;
    if (this._options.stickyBucketService) {
      await this.refreshStickyBuckets();
    }
    if (this._options.remoteEval) {
      await this._refreshForRemoteEval();
      return;
    }
    this._render();
    this._updateAllAutoExperiments();
  }
  async setForcedVariations(vars) {
    this._options.forcedVariations = vars || {};
    if (this._options.remoteEval) {
      await this._refreshForRemoteEval();
      return;
    }
    this._render();
    this._updateAllAutoExperiments();
  }

  // eslint-disable-next-line
  setForcedFeatures(map) {
    this._options.forcedFeatureValues = map;
    this._render();
  }
  async setURL(url) {
    if (url === this._options.url) return;
    this._options.url = url;
    this._redirectedUrl = "";
    if (this._options.remoteEval) {
      await this._refreshForRemoteEval();
      this._updateAllAutoExperiments(true);
      return;
    }
    this._updateAllAutoExperiments(true);
  }
  getAttributes() {
    return {
      ...this._options.attributes,
      ...this._options.attributeOverrides
    };
  }
  getForcedVariations() {
    return this._options.forcedVariations || {};
  }
  getForcedFeatures() {
    // eslint-disable-next-line
    return this._options.forcedFeatureValues || new Map();
  }
  getStickyBucketAssignmentDocs() {
    return this._options.stickyBucketAssignmentDocs || {};
  }
  getUrl() {
    return this._options.url || "";
  }
  getFeatures() {
    return this._options.features || {};
  }
  getExperiments() {
    return this._options.experiments || [];
  }
  getCompletedChangeIds() {
    return Array.from(this._completedChangeIds);
  }
  subscribe(cb) {
    this._subscriptions.add(cb);
    return () => {
      this._subscriptions.delete(cb);
    };
  }
  async _refreshForRemoteEval() {
    if (!this._options.remoteEval) return;
    if (!this._initialized) return;
    const res = await this._refresh({
      allowStale: false
    });
    if (res.data) {
      await this.setPayload(res.data);
    }
  }
  getAllResults() {
    return new Map(this._assigned);
  }
  onDestroy(cb) {
    this._destroyCallbacks.push(cb);
  }
  isDestroyed() {
    return !!this._destroyed;
  }
  destroy(options) {
    options = options || {};
    this._destroyed = true;

    // Custom callbacks
    // Do this first in case it needs access to the below data that is cleared
    this._destroyCallbacks.forEach(cb => {
      try {
        cb();
      } catch (e) {
        console.error(e);
      }
    });

    // Release references to save memory
    this._subscriptions.clear();
    this._assigned.clear();
    this._trackedExperiments.clear();
    this._completedChangeIds.clear();
    this._deferredTrackingCalls.clear();
    this._trackedFeatures = {};
    this._destroyCallbacks = [];
    this._payload = undefined;
    this._saveStickyBucketAssignmentDoc = undefined;
    unsubscribe(this);
    if (options.destroyAllStreams) {
      clearAutoRefresh();
    }
    this.logs = [];
    if (isBrowser && window._growthbook === this) {
      delete window._growthbook;
    }

    // Undo any active auto experiments
    this._activeAutoExperiments.forEach(exp => {
      exp.undo();
    });
    this._activeAutoExperiments.clear();
    this._triggeredExpKeys.clear();
  }
  setRenderer(renderer) {
    this._renderer = renderer;
  }
  forceVariation(key, variation) {
    this._options.forcedVariations = this._options.forcedVariations || {};
    this._options.forcedVariations[key] = variation;
    if (this._options.remoteEval) {
      this._refreshForRemoteEval();
      return;
    }
    this._updateAllAutoExperiments();
    this._render();
  }
  run(experiment) {
    const {
      result
    } = runExperiment(experiment, null, this._getEvalContext());
    this._onExperimentEval(experiment, result);
    return result;
  }
  triggerExperiment(key) {
    this._triggeredExpKeys.add(key);
    if (!this._options.experiments) return null;
    const experiments = this._options.experiments.filter(exp => exp.key === key);
    return experiments.map(exp => {
      return this._runAutoExperiment(exp);
    }).filter(res => res !== null);
  }
  triggerAutoExperiments() {
    this._autoExperimentsAllowed = true;
    this._updateAllAutoExperiments(true);
  }
  _getEvalContext() {
    return {
      user: this._getUserContext(),
      global: this._getGlobalContext(),
      stack: {
        evaluatedFeatures: new Set()
      }
    };
  }
  _getUserContext() {
    return {
      attributes: this._options.user ? {
        ...this._options.user,
        ...this._options.attributes
      } : this._options.attributes,
      enableDevMode: this._options.enableDevMode,
      blockedChangeIds: this._options.blockedChangeIds,
      stickyBucketAssignmentDocs: this._options.stickyBucketAssignmentDocs,
      url: this._getContextUrl(),
      forcedVariations: this._options.forcedVariations,
      forcedFeatureValues: this._options.forcedFeatureValues,
      attributeOverrides: this._options.attributeOverrides,
      saveStickyBucketAssignmentDoc: this._saveStickyBucketAssignmentDoc,
      trackingCallback: this._options.trackingCallback,
      onFeatureUsage: this._options.onFeatureUsage,
      devLogs: this.logs,
      trackedExperiments: this._trackedExperiments,
      trackedFeatureUsage: this._trackedFeatures
    };
  }
  _getGlobalContext() {
    return {
      features: this._options.features,
      experiments: this._options.experiments,
      log: this.log,
      enabled: this._options.enabled,
      qaMode: this._options.qaMode,
      savedGroups: this._options.savedGroups,
      groups: this._options.groups,
      overrides: this._options.overrides,
      onExperimentEval: this._onExperimentEval,
      recordChangeId: this._recordChangedId,
      saveDeferredTrack: this._saveDeferredTrack,
      eventLogger: this._options.eventLogger
    };
  }
  _runAutoExperiment(experiment, forceRerun) {
    const existing = this._activeAutoExperiments.get(experiment);

    // If this is a manual experiment and it's not already running, skip
    if (experiment.manual && !this._triggeredExpKeys.has(experiment.key) && !existing) return null;

    // Check if this particular experiment is blocked by options settings
    // For example, if all visualEditor experiments are disabled
    const isBlocked = this._isAutoExperimentBlockedByContext(experiment);
    if (isBlocked) {
       false && 0;
    }
    let result;
    let trackingCall;
    // Run the experiment (if blocked exclude)
    if (isBlocked) {
      result = getExperimentResult(this._getEvalContext(), experiment, -1, false, "");
    } else {
      ({
        result,
        trackingCall
      } = runExperiment(experiment, null, this._getEvalContext()));
      this._onExperimentEval(experiment, result);
    }

    // A hash to quickly tell if the assigned value changed
    const valueHash = JSON.stringify(result.value);

    // If the changes are already active, no need to re-apply them
    if (!forceRerun && result.inExperiment && existing && existing.valueHash === valueHash) {
      return result;
    }

    // Undo any existing changes
    if (existing) this._undoActiveAutoExperiment(experiment);

    // Apply new changes
    if (result.inExperiment) {
      const changeType = getAutoExperimentChangeType(experiment);
      if (changeType === "redirect" && result.value.urlRedirect && experiment.urlPatterns) {
        const url = experiment.persistQueryString ? mergeQueryStrings(this._getContextUrl(), result.value.urlRedirect) : result.value.urlRedirect;
        if (isURLTargeted(url, experiment.urlPatterns)) {
          this.log("Skipping redirect because original URL matches redirect URL", {
            id: experiment.key
          });
          return result;
        }
        this._redirectedUrl = url;
        const {
          navigate,
          delay
        } = this._getNavigateFunction();
        if (navigate) {
          if (isBrowser) {
            // Wait for the possibly-async tracking callback, bound by min and max delays
            Promise.all([...(trackingCall ? [promiseTimeout(trackingCall, this._options.maxNavigateDelay ?? 1000)] : []), new Promise(resolve => window.setTimeout(resolve, this._options.navigateDelay ?? delay))]).then(() => {
              try {
                navigate(url);
              } catch (e) {
                console.error(e);
              }
            });
          } else {
            try {
              navigate(url);
            } catch (e) {
              console.error(e);
            }
          }
        }
      } else if (changeType === "visual") {
        const undo = this._options.applyDomChangesCallback ? this._options.applyDomChangesCallback(result.value) : this._applyDOMChanges(result.value);
        if (undo) {
          this._activeAutoExperiments.set(experiment, {
            undo,
            valueHash
          });
        }
      }
    }
    return result;
  }
  _undoActiveAutoExperiment(exp) {
    const data = this._activeAutoExperiments.get(exp);
    if (data) {
      data.undo();
      this._activeAutoExperiments.delete(exp);
    }
  }
  _updateAllAutoExperiments(forceRerun) {
    if (!this._autoExperimentsAllowed) return;
    const experiments = this._options.experiments || [];

    // Stop any experiments that are no longer defined
    const keys = new Set(experiments);
    this._activeAutoExperiments.forEach((v, k) => {
      if (!keys.has(k)) {
        v.undo();
        this._activeAutoExperiments.delete(k);
      }
    });

    // Re-run all new/updated experiments
    for (const exp of experiments) {
      const result = this._runAutoExperiment(exp, forceRerun);

      // Once you're in a redirect experiment, break out of the loop and don't run any further experiments
      if (result && result.inExperiment && getAutoExperimentChangeType(exp) === "redirect") {
        break;
      }
    }
  }
  _onExperimentEval(experiment, result) {
    const prev = this._assigned.get(experiment.key);
    this._assigned.set(experiment.key, {
      experiment,
      result
    });
    if (this._subscriptions.size > 0) {
      this._fireSubscriptions(experiment, result, prev);
    }
  }
  _fireSubscriptions(experiment, result,
  // eslint-disable-next-line
  prev) {
    // If assigned variation has changed, fire subscriptions
    // TODO: what if the experiment definition has changed?
    if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
      this._subscriptions.forEach(cb => {
        try {
          cb(experiment, result);
        } catch (e) {
          console.error(e);
        }
      });
    }
  }
  _recordChangedId(id) {
    this._completedChangeIds.add(id);
  }
  isOn(key) {
    return this.evalFeature(key).on;
  }
  isOff(key) {
    return this.evalFeature(key).off;
  }
  getFeatureValue(key, defaultValue) {
    const value = this.evalFeature(key).value;
    return value === null ? defaultValue : value;
  }

  /**
   * @deprecated Use {@link evalFeature}
   * @param id
   */

  feature(id) {
    return this.evalFeature(id);
  }
  evalFeature(id) {
    return evalFeature(id, this._getEvalContext());
  }
  log(msg, ctx) {
    if (!this.debug) return;
    if (this._options.log) this._options.log(msg, ctx);else console.log(msg, ctx);
  }
  getDeferredTrackingCalls() {
    return Array.from(this._deferredTrackingCalls.values());
  }
  setDeferredTrackingCalls(calls) {
    this._deferredTrackingCalls = new Map(calls.filter(c => c && c.experiment && c.result).map(c => {
      return [getExperimentDedupeKey(c.experiment, c.result), c];
    }));
  }
  async fireDeferredTrackingCalls() {
    if (!this._options.trackingCallback) return;
    const promises = [];
    this._deferredTrackingCalls.forEach(call => {
      if (!call || !call.experiment || !call.result) {
        console.error("Invalid deferred tracking call", {
          call: call
        });
      } else {
        promises.push(this._options.trackingCallback(call.experiment, call.result));
      }
    });
    this._deferredTrackingCalls.clear();
    await Promise.all(promises);
  }
  setTrackingCallback(callback) {
    this._options.trackingCallback = callback;
    this.fireDeferredTrackingCalls();
  }
  setFeatureUsageCallback(callback) {
    this._options.onFeatureUsage = callback;
  }
  setEventLogger(logger) {
    this._options.eventLogger = logger;
  }
  async logEvent(eventName, properties) {
    if (this._destroyed) {
      console.error("Cannot log event to destroyed GrowthBook instance");
      return;
    }
    if (this._options.enableDevMode) {
      this.logs.push({
        eventName,
        properties,
        timestamp: Date.now().toString(),
        logType: "event"
      });
    }
    if (this._options.eventLogger) {
      try {
        await this._options.eventLogger(eventName, properties || {}, this._getUserContext());
      } catch (e) {
        console.error(e);
      }
    } else {
      console.error("No event logger configured");
    }
  }
  _saveDeferredTrack(data) {
    this._deferredTrackingCalls.set(getExperimentDedupeKey(data.experiment, data.result), data);
  }
  _getContextUrl() {
    return this._options.url || (isBrowser ? window.location.href : "");
  }
  _isAutoExperimentBlockedByContext(experiment) {
    const changeType = getAutoExperimentChangeType(experiment);
    if (changeType === "visual") {
      if (this._options.disableVisualExperiments) return true;
      if (this._options.disableJsInjection) {
        if (experiment.variations.some(v => v.js)) {
          return true;
        }
      }
    } else if (changeType === "redirect") {
      if (this._options.disableUrlRedirectExperiments) return true;

      // Validate URLs
      try {
        const current = new URL(this._getContextUrl());
        for (const v of experiment.variations) {
          if (!v || !v.urlRedirect) continue;
          const url = new URL(v.urlRedirect);

          // If we're blocking cross origin redirects, block if the protocol or host is different
          if (this._options.disableCrossOriginUrlRedirectExperiments) {
            if (url.protocol !== current.protocol) return true;
            if (url.host !== current.host) return true;
          }
        }
      } catch (e) {
        // Problem parsing one of the URLs
        this.log("Error parsing current or redirect URL", {
          id: experiment.key,
          error: e
        });
        return true;
      }
    } else {
      // Block any unknown changeTypes
      return true;
    }
    if (experiment.changeId && (this._options.blockedChangeIds || []).includes(experiment.changeId)) {
      return true;
    }
    return false;
  }
  getRedirectUrl() {
    return this._redirectedUrl;
  }
  _getNavigateFunction() {
    if (this._options.navigate) {
      return {
        navigate: this._options.navigate,
        delay: 0
      };
    } else if (isBrowser) {
      return {
        navigate: url => {
          window.location.replace(url);
        },
        delay: 100
      };
    }
    return {
      navigate: null,
      delay: 0
    };
  }
  _applyDOMChanges(changes) {
    if (!isBrowser) return;
    const undo = [];
    if (changes.css) {
      const s = document.createElement("style");
      s.innerHTML = changes.css;
      document.head.appendChild(s);
      undo.push(() => s.remove());
    }
    if (changes.js) {
      const script = document.createElement("script");
      script.innerHTML = changes.js;
      if (this._options.jsInjectionNonce) {
        script.nonce = this._options.jsInjectionNonce;
      }
      document.head.appendChild(script);
      undo.push(() => script.remove());
    }
    if (changes.domMutations) {
      changes.domMutations.forEach(mutation => {
        undo.push(dom_mutator_esm.declarative(mutation).revert);
      });
    }
    return () => {
      undo.forEach(fn => fn());
    };
  }
  async refreshStickyBuckets(data) {
    if (this._options.stickyBucketService) {
      const ctx = this._getEvalContext();
      const docs = await getAllStickyBucketAssignmentDocs(ctx, this._options.stickyBucketService, data);
      this._options.stickyBucketAssignmentDocs = docs;
    }
  }
  generateStickyBucketAssignmentDocsSync(stickyBucketService, payload) {
    if (!("getAllAssignmentsSync" in stickyBucketService)) {
      console.error("generating StickyBucketAssignmentDocs docs requires StickyBucketServiceSync");
      return;
    }
    const ctx = this._getEvalContext();
    const attributes = getStickyBucketAttributes(ctx, payload);
    return stickyBucketService.getAllAssignmentsSync(attributes);
  }
  inDevMode() {
    return !!this._options.enableDevMode;
  }
}
async function prefetchPayload(options) {
  // Create a temporary instance, just to fetch the payload
  const instance = new GrowthBook_GrowthBook(options);
  await refreshFeatures({
    instance,
    skipCache: options.skipCache,
    allowStale: false,
    backgroundSync: options.streaming
  });
  instance.destroy();
}
//# sourceMappingURL=GrowthBook.mjs.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js




function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

/** @deprecated */

const GrowthBookContext = /*#__PURE__*/react.createContext({});

/** @deprecated */
async function getGrowthBookSSRData(context) {
  // Server-side GrowthBook instance
  const gb = new GrowthBook({
    ...context
  });

  // Load feature flags from network if needed
  if (context.clientKey) {
    await gb.init();
  }
  const data = {
    attributes: gb.getAttributes(),
    features: gb.getFeatures()
  };
  gb.destroy();
  return data;
}

/** @deprecated */
function useGrowthBookSSR(data) {
  const gb = useGrowthBook();

  // Only do this once to avoid infinite loops
  const isFirst = React.useRef(true);
  if (gb && isFirst.current) {
    gb.setFeatures(data.features);
    gb.setAttributes(data.attributes);
    isFirst.current = false;
  }
}
function useExperiment(exp) {
  const {
    growthbook
  } = React.useContext(GrowthBookContext);
  return growthbook.run(exp);
}
function useFeature(id) {
  const growthbook = useGrowthBook();
  return growthbook.evalFeature(id);
}
function useFeatureIsOn(id) {
  const growthbook = useGrowthBook();
  return growthbook.isOn(id);
}
function useFeatureValue(id, fallback) {
  const growthbook = useGrowthBook();
  return growthbook.getFeatureValue(id, fallback);
}
function useGrowthBook() {
  const {
    growthbook
  } = React.useContext(GrowthBookContext);
  if (!growthbook) {
    throw new Error("Missing or invalid GrowthBookProvider");
  }
  return growthbook;
}
function FeaturesReady({
  children,
  timeout,
  fallback
}) {
  const gb = useGrowthBook();
  const [hitTimeout, setHitTimeout] = React.useState(false);
  const ready = gb ? gb.ready : false;
  React.useEffect(() => {
    if (timeout && !ready) {
      const timer = setTimeout(() => {
        gb && gb.log("FeaturesReady timed out waiting for features to load", {
          timeout
        });
        setHitTimeout(true);
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [timeout, ready, gb]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ready || hitTimeout ? children : fallback || null);
}
function IfFeatureEnabled({
  children,
  feature
}) {
  return useFeature(feature).on ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}
function FeatureString(props) {
  const value = useFeature(props.feature).value;
  if (value !== null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.default);
}
const withRunExperiment = Component => {
  const withRunExperimentWrapper = props => /*#__PURE__*/react.createElement(GrowthBookContext.Consumer, null, ({
    growthbook
  }) => {
    return /*#__PURE__*/react.createElement(Component, _extends({}, props, {
      runExperiment: exp => growthbook.run(exp)
    }));
  });
  return withRunExperimentWrapper;
};
withRunExperiment.displayName = "WithRunExperiment";
const GrowthBookProvider = ({
  children,
  growthbook
}) => {
  // Tell growthbook how to re-render our app (for dev mode integration)

  const [_, setRenderCount] = react.useState(0);
  react.useEffect(() => {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(() => {
      setRenderCount(v => v + 1);
    });
    return () => {
      growthbook.setRenderer(() => {
        // do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/react.createElement(GrowthBookContext.Provider, {
    value: {
      growthbook
    }
  }, children);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./components/Loader.tsx




const Loader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Header_module_default()).loader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Spinner, {
            animation: "border",
            variant: "primary",
            className: (Header_module_default()).spinner
        })
    });
};
/* harmony default export */ var components_Loader = (Loader);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__(76516);
// EXTERNAL MODULE: ./styles/globals.scss
var globals = __webpack_require__(74831);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 18 modules
var Modal = __webpack_require__(13540);
// EXTERNAL MODULE: ./components/EnquiryModal/EnquiryModal.module.scss
var EnquiryModal_module = __webpack_require__(4079);
var EnquiryModal_module_default = /*#__PURE__*/__webpack_require__.n(EnquiryModal_module);
// EXTERNAL MODULE: ./components/EnquiryModal/LeadGenForms.tsx + 2 modules
var LeadGenForms = __webpack_require__(59833);
;// CONCATENATED MODULE: ./components/EnquiryModal/index.tsx






const UNIVERSITY_REGEX = /^\/universities\/([^/]+)\/([^/]+)$/;
const CONTACT_US_REGEX = /^\/contact-us\/([^/]+)$/;
const EnquiryModal = ({ show , onClose , currentPageUrl , title  })=>{
    const { 0: height , 1: setHeight  } = (0,react.useState)(400);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (router.asPath && (UNIVERSITY_REGEX.test(router.asPath) || CONTACT_US_REGEX.test(router.asPath))) {
            const element = document.querySelector(".modal-content");
            if (element) {
                element?.classList.add("modal-content-university");
            }
        }
    }, [
        router.asPath
    ]);
    const handleSetHeight = (0,react.useCallback)((height)=>{
        setHeight(height);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                onHide: onClose,
                centered: true,
                size: "lg",
                backdrop: false,
                className: `${(EnquiryModal_module_default()).modal}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        className: (EnquiryModal_module_default()).modalHeader,
                        children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                        className: (EnquiryModal_module_default()).modalBody,
                        style: {
                            height
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGenForms/* default */.Z, {
                            url: currentPageUrl,
                            mode: "popup",
                            setHeight: handleSetHeight,
                            onClose: onClose
                        })
                    })
                ]
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (EnquiryModal_module_default()).modalOverlay
            })
        ]
    });
};
/* harmony default export */ var components_EnquiryModal = (EnquiryModal);

// EXTERNAL MODULE: ./context/OnboardingContext.tsx
var OnboardingContext = __webpack_require__(22186);
;// CONCATENATED MODULE: ./context/EnquireModalContext.tsx




let mounted = false;
// ---------- Context ----------
const EnquireModalContext = /*#__PURE__*/ (0,react.createContext)(undefined);
// ---------- Hook ----------
const useEnquireModal = ()=>{
    const context = useContext(EnquireModalContext);
    if (!context) {
        throw new Error("useEnquireModal must be used within EnquireModalWrapper");
    }
    return context;
};
// ---------- Provider Component ----------
const EnquireModalWrapper = ({ children , b2cWizardConfig  })=>{
    const { openWizard  } = (0,OnboardingContext/* useOnboarding */.kc)();
    const { 0: isOpen , 1: setIsOpen  } = (0,react.useState)(false);
    const { 0: currentUrl , 1: setCurrentUrl  } = (0,react.useState)("");
    const { 0: urlSlug , 1: setUrlSlug  } = (0,react.useState)("");
    const { 0: formTitles , 1: setFormTitles  } = (0,react.useState)([]);
    const closePopup = (0,react.useCallback)(()=>{
        setCurrentUrl("");
        setIsOpen(false);
    }, []);
    const openPopup = (0,react.useCallback)((url)=>{
        setUrlSlug(url);
        setCurrentUrl("https://crm-staging.coursefinder.ai" + "/" + url);
        setIsOpen(true);
    }, []);
    (0,react.useEffect)(()=>{
        const handler = (e)=>{
            const target = e.target.closest("[class]");
            if (!target) return;
            const match = Array.from(target.classList).find((cls)=>cls.startsWith("kc-enquire-form-") || cls === "kc-enquire-form");
            if (match) {
                // Check if current page is B2C-enabled via CMS config
                const currentPath = window.location.pathname;
                const enabledPages = Array.isArray(b2cWizardConfig?.enabledPages) ? b2cWizardConfig.enabledPages : [];
                const matchedPage = enabledPages.find((page)=>currentPath === page.pagePath || currentPath.startsWith(page.pagePath));
                if (matchedPage) {
                    openWizard({
                        enableB2cNearestOffice: matchedPage.enableNearestOffice ?? true,
                        enableB2cCoaching: matchedPage.enableCoaching ?? true,
                        mode: "modal"
                    });
                    return;
                }
                // Default: open Frappe/JotForm
                const formId = match.slice("kc-enquire-form-".length);
                if (formId) {
                    openPopup(formId);
                }
            }
        };
        document.addEventListener("click", handler);
        return ()=>{
            document.removeEventListener("click", handler);
        };
    }, [
        setIsOpen,
        openWizard,
        b2cWizardConfig
    ]);
    const fetchFormTitles = async ()=>{
        try {
            const response = await fetch(`${"https://cms-staging.studies-overseas.com"}/frappe-titles`);
            if (!response.ok) {
                throw new Error("Failed to fetch form titles");
            }
            const data = await response.json();
            mounted = true;
            setFormTitles(data?.frappeTitleElement || []);
        } catch (error) {
            console.error("Error fetching form titles:", error);
        }
    };
    (0,react.useEffect)(()=>{
        if (mounted) {
            return;
        }
        fetchFormTitles();
    }, []);
    const contextValue = (0,react.useMemo)(()=>({
            openPopup
        }), [
        openPopup
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EnquireModalContext.Provider, {
        value: contextValue,
        children: [
            children,
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EnquiryModal, {
                title: formTitles.find((item)=>item.slug === urlSlug)?.title || formTitles.find((item)=>item.slug === "default")?.title || "Enquiry Form",
                show: isOpen,
                onClose: closePopup,
                currentPageUrl: currentUrl
            })
        ]
    });
};
/* harmony default export */ var context_EnquireModalContext = (EnquireModalWrapper);

// EXTERNAL MODULE: ./context/WizardOptionsContext.tsx + 1 modules
var WizardOptionsContext = __webpack_require__(25174);
// EXTERNAL MODULE: ./constants/onboardingFallbacks.ts
var onboardingFallbacks = __webpack_require__(91863);
// EXTERNAL MODULE: ./utils/b2c/programLevelConstants.ts
var programLevelConstants = __webpack_require__(45984);
// EXTERNAL MODULE: ./components/B2C/OnboardingWizard/OnboardingWizard.tsx + 10 modules
var OnboardingWizard = __webpack_require__(50312);
;// CONCATENATED MODULE: ./components/B2C/OnboardingWizard/WizardModal.tsx





const WizardModal = ()=>{
    const { isOpen , mode , closeWizard  } = (0,OnboardingContext/* useOnboarding */.kc)();
    if (mode !== "modal") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: isOpen,
        onHide: closeWizard,
        centered: true,
        size: "xl",
        dialogClassName: "b2c-wizard-modal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
            style: {
                padding: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard/* default */.Z, {
                onClose: closeWizard
            })
        })
    });
};
/* harmony default export */ var OnboardingWizard_WizardModal = (WizardModal);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./utils/consoleOverride.ts
/**
 * Console override utility to suppress console statements in production
 */ /**
 * No-op function that does nothing
 */ const noop = (...args)=>{};
/**
 * Original console methods (stored before override)
 */ let originalConsole = null;
/**
 * Override console methods to prevent output in production
 * @param forceOverride - If true, overrides even in development
 */ const overrideConsole = (forceOverride = false)=>{
    // Check if we're in production or if force override is enabled
    const isProduction = "production" === "production";
    if (!isProduction && !forceOverride) {
        return; // Don't override in development unless forced
    }
    // Store original console methods if not already stored
    if (!originalConsole) {
        originalConsole = {
            log: console.log,
            warn: console.warn,
            error: console.error,
            info: console.info,
            debug: console.debug,
            trace: console.trace,
            group: console.group,
            groupEnd: console.groupEnd,
            groupCollapsed: console.groupCollapsed,
            time: console.time,
            timeEnd: console.timeEnd,
            timeLog: console.timeLog,
            count: console.count,
            countReset: console.countReset,
            clear: console.clear,
            dir: console.dir,
            dirxml: console.dirxml,
            table: console.table,
            assert: console.assert
        };
    }
    // Override all console methods with no-op
    console.log = noop;
    console.warn = noop;
    console.error = noop;
    console.info = noop;
    console.debug = noop;
    console.trace = noop;
    console.group = noop;
    console.groupEnd = noop;
    console.groupCollapsed = noop;
    console.time = noop;
    console.timeEnd = noop;
    console.timeLog = noop;
    console.count = noop;
    console.countReset = noop;
    console.clear = noop;
    console.dir = noop;
    console.dirxml = noop;
    console.table = noop;
    console.assert = noop;
};
/**
 * Restore original console methods
 */ const restoreConsole = ()=>{
    if (!originalConsole) {
        return; // Nothing to restore
    }
    // Restore all console methods
    console.log = originalConsole.log;
    console.warn = originalConsole.warn;
    console.error = originalConsole.error;
    console.info = originalConsole.info;
    console.debug = originalConsole.debug;
    console.trace = originalConsole.trace;
    console.group = originalConsole.group;
    console.groupEnd = originalConsole.groupEnd;
    console.groupCollapsed = originalConsole.groupCollapsed;
    console.time = originalConsole.time;
    console.timeEnd = originalConsole.timeEnd;
    console.timeLog = originalConsole.timeLog;
    console.count = originalConsole.count;
    console.countReset = originalConsole.countReset;
    console.clear = originalConsole.clear;
    console.dir = originalConsole.dir;
    console.dirxml = originalConsole.dirxml;
    console.table = originalConsole.table;
    console.assert = originalConsole.assert;
    // Clear the stored original console
    originalConsole = null;
};
/**
 * Check if console is currently overridden
 */ const isConsoleOverridden = ()=>{
    return console.log === noop;
};
/**
 * Conditional console override - only override specific methods
 * @param methods - Array of console methods to override
 * @param forceOverride - If true, overrides even in development
 */ const overrideSpecificConsoleMethods = (methods = [
    "log",
    "warn",
    "info",
    "debug"
], forceOverride = false)=>{
    const isProduction = "production" === "production";
    if (!isProduction && !forceOverride) {
        return;
    }
    // Store original console methods if not already stored
    if (!originalConsole) {
        originalConsole = {
            log: console.log,
            warn: console.warn,
            error: console.error,
            info: console.info,
            debug: console.debug,
            trace: console.trace,
            group: console.group,
            groupEnd: console.groupEnd,
            groupCollapsed: console.groupCollapsed,
            time: console.time,
            timeEnd: console.timeEnd,
            timeLog: console.timeLog,
            count: console.count,
            countReset: console.countReset,
            clear: console.clear,
            dir: console.dir,
            dirxml: console.dirxml,
            table: console.table,
            assert: console.assert
        };
    }
    // Override only specified methods
    methods.forEach((method)=>{
        if (method in console) {
            console[method] = noop;
        }
    });
};
/**
 * Initialize console override based on environment
 * This function can be called early in the application lifecycle
 */ const initConsoleOverride = ()=>{
    // Auto-override in production
    if (true) {
        overrideConsole();
    } else {}
};

;// CONCATENATED MODULE: ./pages/_app.tsx

















// import { useUILoadMetrics } from "../hooks/useUILoadMetrics";

const InteraktVisibilityControl = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5626).then(__webpack_require__.bind(__webpack_require__, 15626)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15626)
            ]
    },
    ssr: false
});
const ExternalLinks = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4166).then(__webpack_require__.bind(__webpack_require__, 34166)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34166)
            ]
    },
    ssr: false
});
let clientLayoutCache = null;
function readLayoutFromNextData() {
    if (false) {}
    const raw = window.__NEXT_DATA__?.props?.pageProps;
    if (!raw?.footerData || !raw?.headerData) return null;
    return {
        footerData: raw.footerData,
        headerData: raw.headerData,
        stickyFooterPages: raw.stickyFooterPages,
        wizardOptions: raw.wizardOptions ?? null,
        b2cWizardConfig: raw.b2cWizardConfig
    };
}
function MyApp({ Component , pageProps  }) {
    const { 0: loading , 1: setLoading  } = (0,react.useState)(false);
    const routeLoadsRef = (0,react.useRef)(0);
    const growthBook = (0,react.useMemo)(()=>new GrowthBook_GrowthBook({
            apiHost: "https://growthbook-backend.coursefinder.ai",
            clientKey: "sdk-tJubCTfKrrwHylun",
            enableDevMode: "production" !== "production",
            subscribeToChanges: true
        }), []);
    (0,react.useEffect)(()=>{
        growthBook.init({
            streaming: true
        });
    }, [
        growthBook
    ]);
    (0,react.useEffect)(()=>{
        if (true) {
            initConsoleOverride();
        }
    }, []);
    (0,react.useEffect)(()=>{
        const start = ()=>{
            routeLoadsRef.current += 1;
            setLoading(true);
        };
        const end = ()=>{
            routeLoadsRef.current = Math.max(0, routeLoadsRef.current - 1);
            if (routeLoadsRef.current === 0) {
                setLoading(false);
            }
        };
        next_router.Router.events.on("routeChangeStart", start);
        next_router.Router.events.on("routeChangeComplete", end);
        next_router.Router.events.on("routeChangeError", end);
        return ()=>{
            next_router.Router.events.off("routeChangeStart", start);
            next_router.Router.events.off("routeChangeComplete", end);
            next_router.Router.events.off("routeChangeError", end);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (false) {}
        const p = pageProps;
        if (p.footerData && p.headerData) {
            clientLayoutCache = {
                footerData: p.footerData,
                headerData: p.headerData,
                stickyFooterPages: p.stickyFooterPages,
                wizardOptions: p.wizardOptions ?? null,
                b2cWizardConfig: p.b2cWizardConfig
            };
        }
    }, [
        pageProps
    ]);
    (0,react.useEffect)(()=>{
        if (!loading || "object" === "undefined") return;
        const id = window.setTimeout(()=>{
            routeLoadsRef.current = 0;
            setLoading(false);
        }, 12000);
        return ()=>window.clearTimeout(id);
    }, [
        loading
    ]);
    (0,react.useEffect)(()=>{
        function addLink(rel, href) {
            const link = document.createElement("link");
            link.rel = rel;
            link.href = href;
            document.head.appendChild(link);
        }
        addLink("preconnect", "https://cms-staging.studies-overseas.com" ?? 0);
        addLink("dns-prefetch", "https://cms-staging.studies-overseas.com" ?? 0);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SSRProvider, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "openai-pixel-script",
                strategy: "afterInteractive",
                children: `!function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");oaiq("init",{pixelId:"9ykBv3Cd8hHLPyM5CQ3V2i"});`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "poptin-single-page-app",
                strategy: "afterInteractive",
                children: `var poptin_single_page_app = true;`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://cdn.popt.in/pixel.js?id=7376c7a3164b8",
                id: "pixel-script-poptin",
                strategy: "lazyOnload"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "whatsapp-integration-script",
                strategy: "afterInteractive",
                children: `(function(w,d,s,c,r,a,m){
          w['KiwiObject']=r;
          w[r]=w[r] || function () {
            (w[r].q=w[r].q||[]).push(arguments)};
          w[r].l=1*new Date();
            a=d.createElement(s);
            m=d.getElementsByTagName(s)[0];
          a.async=1;
          a.src=c;
          m.parentNode.insertBefore(a,m)
        })(window,document,'script',"https://app.interakt.ai/kiwi-sdk/kiwi-sdk-17-prod-min.js?v="+ new Date().getTime(),'kiwi');
            window.addEventListener("load",function () {
            kiwi.hidePoweredBy();
            kiwi.init('', 'IHldDVmNFrlknyH5oXyvAlrt3IEN0xcY', {});
        });`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InteraktVisibilityControl, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GrowthBookProvider, {
                growthbook: growthBook,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WizardOptionsContext/* WizardOptionsProvider */.Q, {
                    value: pageProps.wizardOptions || {
                        countries: onboardingFallbacks/* FALLBACK_COUNTRIES */.AE,
                        degreeLevels: programLevelConstants/* PROGRAM_LEVEL_OPTIONS_UNIFIED */.TF,
                        studyAreas: onboardingFallbacks/* FALLBACK_STUDY_AREAS */.Vr,
                        cities: onboardingFallbacks/* FALLBACK_CITIES */.WP,
                        nearestOffices: [],
                        coachingOptions: []
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnboardingContext/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(context_EnquireModalContext, {
                                b2cWizardConfig: pageProps.b2cWizardConfig,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Layout, {
                                    ...pageProps,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                        ...pageProps
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingWizard_WizardModal, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLinks, {})
        ]
    });
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 78409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getOnboardingOrFormCtaProps; }
/* harmony export */ });
/* unused harmony export APPLY_ONBOARDING_PATH */
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32866);

const APPLY_ONBOARDING_PATH = "/onboarding";
function getOnboardingOrFormCtaProps(router, { btnLink , formId , toOnboardingEnabled =false , formKeyFromEnv ="university-pages-open-enquiry-form" , sourceUrl =""  }) {
    // 1. An explicit link always wins: open it in a new tab.
    if (btnLink) {
        const onClick = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            window.open(btnLink, "_blank");
        };
        return {
            formClassName: "",
            onClick,
            mode: "link"
        };
    }
    // 2. A form id wins over onboarding: the Frappe/JotForm class handles the
    //    click itself, so the React onClick is a no-op.
    if (formId) {
        const onClick1 = ()=>{
            return;
        };
        return {
            formClassName: (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .isFrappeOrJotFormClass */ .gd)(formId),
            onClick: onClick1,
            mode: "form"
        };
    }
    // 3. No link and no form id: go to onboarding when enabled, otherwise fall
    //    back to the common form.
    if (toOnboardingEnabled) {
        const onClick2 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const path = window.location.pathname.replace(/^\//, "");
            window.location.href = APPLY_ONBOARDING_PATH + `?source_url=${sourceUrl ? sourceUrl : path}`;
        };
        return {
            formClassName: "",
            onClick: onClick2,
            mode: "onboarding"
        };
    }
    const onClick3 = ()=>{
        return;
    };
    return {
        formClassName: (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .isFrappeOrJotFormClass */ .gd)(formKeyFromEnv),
        onClick: onClick3,
        mode: "form"
    };
}


/***/ }),

/***/ 90017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ CF_APP_URL; },
/* harmony export */   "K7": function() { return /* binding */ FRAPPE_API_KEY; },
/* harmony export */   "MY": function() { return /* binding */ BOOK_COUNSELLING_URL; },
/* harmony export */   "Mj": function() { return /* binding */ COOKIE_NAME_B2C_USER_TYPE; },
/* harmony export */   "Qd": function() { return /* binding */ COUNTRY_CODES; },
/* harmony export */   "Ql": function() { return /* binding */ STORAGE_KEY_B2C_PREFS; },
/* harmony export */   "UM": function() { return /* binding */ PRIMARY_SOURCE_B2C_LOGIN; },
/* harmony export */   "Yv": function() { return /* binding */ STORAGE_KEY_B2C_PENDING_EMAIL; },
/* harmony export */   "aP": function() { return /* binding */ SORT_OPTIONS; },
/* harmony export */   "eh": function() { return /* binding */ SPONSORED_TOOLTIP; },
/* harmony export */   "fz": function() { return /* binding */ COUNTRY_USA_CODE; },
/* harmony export */   "g3": function() { return /* binding */ DEFAULT_CLOSED_REMARK; },
/* harmony export */   "iN": function() { return /* binding */ STORAGE_KEY_B2C_COACHING_VISIBLE; },
/* harmony export */   "jQ": function() { return /* binding */ STORAGE_KEY_B2C_PRIMARY_SOURCE; },
/* harmony export */   "kO": function() { return /* binding */ FRAPPE_URL; },
/* harmony export */   "ov": function() { return /* binding */ PRIMARY_SOURCE_B2C_WIDGET; },
/* harmony export */   "tL": function() { return /* binding */ STORAGE_KEY_B2C_SOURCE_URL; },
/* harmony export */   "vV": function() { return /* binding */ isValidEmail; },
/* harmony export */   "wS": function() { return /* binding */ FRAPPE_API_SECRET; },
/* harmony export */   "x0": function() { return /* binding */ CLOSED_REASONS; },
/* harmony export */   "xH": function() { return /* binding */ STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE; }
/* harmony export */ });
/* unused harmony exports EMAIL_REGEX, STORAGE_KEY_USER_TYPE, STORAGE_KEY_IS_KC_STUDENT, HOME_HERO_ONBOARDING_ENABLED, INTAKE_OPTIONS */
// Email validation
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function isValidEmail(email) {
    return EMAIL_REGEX.test(email);
}
// Storage keys
const STORAGE_KEY_B2C_PREFS = "b2c_prefs";
const STORAGE_KEY_B2C_PENDING_EMAIL = "b2c_pending_email";
const STORAGE_KEY_USER_TYPE = "userType";
const STORAGE_KEY_IS_KC_STUDENT = "isKCStudent";
const STORAGE_KEY_B2C_SOURCE_URL = "b2c_pending_source_url";
const STORAGE_KEY_B2C_PRIMARY_SOURCE = "b2c_pending_primary_source";
const STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE = "b2c_pending_fifth_step_visible";
const STORAGE_KEY_B2C_COACHING_VISIBLE = "b2c_pending_coaching_visible"; // CFM-1514
// primary_source tags forwarded to Frappe at lead creation
const PRIMARY_SOURCE_B2C_WIDGET = "B2C Widget";
const PRIMARY_SOURCE_B2C_LOGIN = "B2C Login";
// Cookie names
const COOKIE_NAME_B2C_USER_TYPE = "b2cUserType";
// CF app URL — used when building cross-app redirect URLs
const CF_APP_URL = "https://coursefinder-test5.vercel.app";
// Free counselling booking page — opened from "Book Online Counselling" buttons across
// home header + B2C search results page. Keep in sync if marketing renames the URL.
const BOOK_COUNSELLING_URL = "https://app.studies-overseas.com/book-free-study-abroad-counselling";
// Forces the home page "Start Your Journey" CTA to route to /onboarding,
// regardless of the CMS `heroSectionBtn.toOnboardingEnabled` field.
// Flip to false (or wire CMS back in) when product owns the toggle in Strapi.
const HOME_HERO_ONBOARDING_ENABLED = true;
// Frappe CRM credentials
const FRAPPE_URL = "https://crm-staging.coursefinder.ai";
const FRAPPE_API_KEY = "6e2c30451959644";
const FRAPPE_API_SECRET = "919aa9776203dc0";
// CFM-1579: CF master country id for the USA. Mirrors COUNTRY_USA_CODE in coursefinder-react.
const COUNTRY_USA_CODE = 1;
// CFM-1685: placeholder copy for the sponsored card's info tooltip, pending final wording from
// product. coursefinder-react holds its own copy in utils/b2cConstants.tsx (separate repo, no
// shared package) — update both when the real wording lands.
const SPONSORED_TOOLTIP = "This university is featured as a sponsored placement.";
// CFM-1685: Featured leads the list and is therefore the default, mirroring search-program.
// It only reorders results — there is no featured badge anywhere.
//
// No tuition / application fee sorts here, deliberately. Fees belong to a course, not a
// university — a university has a range — and this card shows one program out of many.
// search-program disables them on its Universities tab ("To sort, please switch to the Programs
// tab"); this site has no Programs tab, so they are left out entirely, matching the CF student
// platform. Don't re-add them for parity.
const SORT_OPTIONS = [
    {
        label: "Featured",
        value: "Featured"
    },
    {
        label: "Ranking",
        value: "Ranking"
    }, 
];
// Country name → ISO 3166-1 alpha-2 code (used for flag icons)
const COUNTRY_CODES = {
    "United States of America": "us",
    "Australia": "au",
    "Canada": "ca",
    "United Kingdom": "gb",
    "New Zealand": "nz",
    "Singapore": "sg",
    "United Arab Emirates": "ae",
    "Ireland": "ie",
    "Germany": "de",
    "France": "fr",
    "Sweden": "se",
    "Netherlands": "nl",
    "Austria": "at",
    "Denmark": "dk",
    "Finland": "fi",
    "Italy": "it",
    "Hungary": "hu",
    "Switzerland": "ch",
    "Spain": "es",
    "Lithuania": "lt",
    "Latvia": "lv",
    "Cyprus": "cy",
    "Poland": "pl",
    "Czech Republic": "cz",
    "Malaysia": "my",
    "Mauritius": "mu",
    "South Africa": "za",
    "Hong Kong": "hk",
    "China": "cn",
    "Bulgaria": "bg",
    "Vietnam": "vn",
    "Malta": "mt",
    "Japan": "jp",
    "Belgium": "be",
    "Russia": "ru",
    "South Korea": "kr",
    "India": "in",
    "Indonesia": "id",
    "Georgia": "ge",
    "Zimbabwe": "zw",
    "Turkey": "tr"
};
// Static intake period options — update annually or replace with API when available
const INTAKE_OPTIONS = [
    {
        label: "May 2026",
        value: "May 2026"
    },
    {
        label: "September 2026",
        value: "September 2026"
    },
    {
        label: "2026 Intakes",
        value: "2026 Intakes"
    },
    {
        label: "2027 Intakes",
        value: "2027 Intakes"
    }, 
];
const CLOSED_REASONS = {
    1: "Deadline Passed",
    2: "Closed by KC",
    3: "Seats Full"
};
const DEFAULT_CLOSED_REMARK = "Either the Application deadline for this course has passed or we have stopped accepting Applications for this intake hence you cannot shortlist or apply for the same.";


/***/ }),

/***/ 39156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ clearB2cPrefs; },
/* harmony export */   "VG": function() { return /* binding */ arePrefsComplete; },
/* harmony export */   "Vl": function() { return /* binding */ hasVisibleWizardPrefs; },
/* harmony export */   "WS": function() { return /* binding */ readB2cPrefs; },
/* harmony export */   "_O": function() { return /* binding */ writeB2cPrefs; },
/* harmony export */   "cd": function() { return /* binding */ buildApiPreferences; },
/* harmony export */   "fW": function() { return /* binding */ getMissingPrefFields; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90017);
/* harmony import */ var _programLevelConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45984);


function readB2cPrefs() {
    if (false) {}
    try {
        const raw = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_PREFS */ .Ql);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        console.error("[prefs] Failed to parse stored B2C preferences:", error);
        return null;
    }
}
function writeB2cPrefs(prefs) {
    if (false) {}
    const current = readB2cPrefs() || {};
    localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_PREFS */ .Ql, JSON.stringify({
        ...current,
        ...prefs
    }));
}
function clearB2cPrefs() {
    if (false) {}
    localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_PREFS */ .Ql);
}
const hasNonEmptyEntries = (arr)=>Array.isArray(arr) && arr.length > 0 && arr.every((entry)=>!!entry?.trim());
const REQUIRED_PREF_FIELDS = [
    {
        label: "Countries",
        check: (prefs)=>hasNonEmptyEntries(prefs.countries)
    },
    {
        label: "Study Level",
        check: (prefs)=>!!prefs.degreeLevel?.trim()
    },
    {
        label: "Study Areas",
        check: (prefs)=>hasNonEmptyEntries(prefs.studyAreas)
    },
    {
        label: "City",
        check: (prefs)=>!!prefs.city?.trim()
    },
    {
        label: "Nearest Office",
        check: (prefs)=>prefs.nearestOfficeRequired === false || !!prefs.nearestOffice?.trim()
    },
    {
        label: "Partner",
        check: (prefs)=>!!prefs.partnerUuid?.trim()
    }, 
];
function arePrefsComplete(prefs) {
    if (!prefs) return false;
    return REQUIRED_PREF_FIELDS.every(({ check  })=>check(prefs));
}
function hasVisibleWizardPrefs(prefs) {
    if (!prefs) return false;
    return Boolean(prefs.countries && prefs.countries.length || prefs.degreeLevel && prefs.degreeLevel.trim() || prefs.studyAreas && prefs.studyAreas.length);
}
function getMissingPrefFields(prefs) {
    if (!prefs) return REQUIRED_PREF_FIELDS.map(({ label  })=>label);
    return REQUIRED_PREF_FIELDS.filter(({ check  })=>!check(prefs)).map(({ label  })=>label);
}
function buildApiPreferences(prefs) {
    return {
        countries: (prefs.countries || []).map((name, index)=>({
                id: prefs.countryCfIds?.[index] ?? 0,
                name
            })),
        // Expand unified bucket → one {id, name} per CF master id.
        // Legacy fallback: reverse-resolve a stale degreeLevelCfId to its bucket.
        studyLevels: (()=>{
            let bucketLabel = prefs.degreeLevel && _programLevelConstants__WEBPACK_IMPORTED_MODULE_1__/* .PROGRAM_LEVEL_TO_CF_IDS */ .DU[prefs.degreeLevel] ? prefs.degreeLevel : undefined;
            if (!bucketLabel && prefs.degreeLevelCfId != null && _programLevelConstants__WEBPACK_IMPORTED_MODULE_1__/* .CF_ID_TO_PROGRAM_LEVEL */ .OL[prefs.degreeLevelCfId]) {
                bucketLabel = _programLevelConstants__WEBPACK_IMPORTED_MODULE_1__/* .CF_ID_TO_PROGRAM_LEVEL */ .OL[prefs.degreeLevelCfId];
            }
            if (!bucketLabel) return [];
            return (_programLevelConstants__WEBPACK_IMPORTED_MODULE_1__/* .PROGRAM_LEVEL_TO_CF_IDS */ .DU[bucketLabel] || []).map((id)=>({
                    id,
                    name: bucketLabel
                }));
        })(),
        studyAreas: (prefs.studyAreas || []).map((name, index)=>({
                id: prefs.studyAreaCfIds?.[index] ?? 0,
                name
            }))
    };
}


/***/ }),

/***/ 45984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": function() { return /* binding */ PROGRAM_LEVEL_TO_CF_IDS; },
/* harmony export */   "OL": function() { return /* binding */ CF_ID_TO_PROGRAM_LEVEL; },
/* harmony export */   "TF": function() { return /* binding */ PROGRAM_LEVEL_OPTIONS_UNIFIED; }
/* harmony export */ });
const PROGRAM_LEVEL_OPTIONS_UNIFIED = [
    {
        label: "Bachelors",
        imageUrl: "/icons/degree/school.svg"
    },
    {
        label: "Masters",
        imageUrl: "/icons/degree/workspace_premium.svg"
    },
    {
        label: "UG/ UG Diploma",
        imageUrl: "/icons/degree/workspace_premium.svg"
    },
    {
        label: "PG/ PG Diploma",
        imageUrl: "/icons/degree/account_balance.svg"
    },
    {
        label: "PhD",
        imageUrl: "/icons/degree/cognition_2.svg"
    },
    {
        label: "Diploma/ Certificate Programs",
        imageUrl: "/icons/degree/description.svg"
    },
    {
        label: "Foundation/ Pathway Programs",
        imageUrl: "/icons/degree/alt_route_ug.svg"
    },
    {
        label: "Others",
        imageUrl: "/icons/degree/social_distance.svg"
    }, 
];
// CF Study Level IDs → names (source: CF `StudyLevels` table, IsActive = 1):
//   1  = Undergraduate
//   2  = Postgraduate
//   3  = PhD
//   4  = UG Diploma /Certificate /Associate Degree
//   5  = PG Diploma /Certificate
//   8  = High School (11th-12th)
//   9  = Short-term/Summer Programs
//   10 = Grades Below 10th
//   11 = UG+PG (Accelerated) Degree
//   12 = Twinning Programs (UG)
//   13 = Twinning Programs (PG)
//   19 = English Language program (ESL, IEP, ELP)
//   20 = Pathway Programs (UG) (removed)
//   21 = Pathway Programs (PG)(removed)
//   22 = Semester Study Abroad
const PROGRAM_LEVEL_TO_CF_IDS = {
    // Simple labels: Bachelors → Undergraduate family, Masters → Postgraduate family.
    Bachelors: [
        1,
        11,
        12
    ],
    Masters: [
        2,
        13
    ],
    "UG/ UG Diploma": [
        1,
        4,
        11,
        12
    ],
    "PG/ PG Diploma": [
        2,
        5,
        13
    ],
    PhD: [
        3
    ],
    "Diploma/ Certificate Programs": [
        4,
        5
    ],
    "Foundation/ Pathway Programs": [
        19,
        20,
        21
    ],
    Others: [
        8,
        9,
        10,
        22
    ]
};
// Tie-break order for ids that belong to multiple buckets (4, 5, 20, 21 overlap).
const REVERSE_MAP_PRIORITY = [
    "PhD",
    "UG/ UG Diploma",
    "PG/ PG Diploma",
    "Foundation/ Pathway Programs",
    "Diploma/ Certificate Programs",
    "Others",
    // New simple labels kept last so existing CF-ID → bucket resolution is unchanged.
    "Bachelors",
    "Masters", 
];
// Derived from PROGRAM_LEVEL_TO_CF_IDS + REVERSE_MAP_PRIORITY. Edit those, not this.
const CF_ID_TO_PROGRAM_LEVEL = (()=>{
    const reverse = {};
    for (const label of REVERSE_MAP_PRIORITY){
        for (const id of PROGRAM_LEVEL_TO_CF_IDS[label] || []){
            if (!(id in reverse)) reverse[id] = label;
        }
    }
    return reverse;
})();


/***/ }),

/***/ 3265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jW": function() { return /* binding */ persistSourceContext; },
/* harmony export */   "pi": function() { return /* binding */ readSourceContext; }
/* harmony export */ });
/* unused harmony export clearSourceContext */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90017);

const persistSourceContext = (ctx)=>{
    if (false) {}
    try {
        if (ctx.sourceUrl) localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_SOURCE_URL */ .tL, ctx.sourceUrl);
        if (ctx.primarySource) localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_PRIMARY_SOURCE */ .jQ, ctx.primarySource);
        if (ctx.fifthStepVisible !== undefined) {
            localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE */ .xH, ctx.fifthStepVisible ? "1" : "0");
        }
        if (ctx.coachingVisible !== undefined) {
            localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_COACHING_VISIBLE */ .iN, ctx.coachingVisible ? "1" : "0");
        }
    } catch (err) {
        console.warn("[sourceTracking] Failed to write to localStorage:", err?.message || err);
    }
};
const readSourceContext = ()=>{
    if (false) {}
    try {
        return {
            sourceUrl: localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_SOURCE_URL */ .tL) || "",
            primarySource: localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_PRIMARY_SOURCE */ .jQ) || "",
            fifthStepVisible: localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE */ .xH) !== "0",
            coachingVisible: localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEY_B2C_COACHING_VISIBLE */ .iN) !== "0"
        };
    } catch (err) {
        console.warn("[sourceTracking] Failed to read from localStorage:", err?.message || err);
        return {
            sourceUrl: "",
            primarySource: "",
            fifthStepVisible: true,
            coachingVisible: true
        };
    }
};
const clearSourceContext = ()=>{
    if (false) {}
    try {
        localStorage.removeItem(STORAGE_KEY_B2C_SOURCE_URL);
        localStorage.removeItem(STORAGE_KEY_B2C_PRIMARY_SOURCE);
        localStorage.removeItem(STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE);
        localStorage.removeItem(STORAGE_KEY_B2C_COACHING_VISIBLE); // CFM-1514
    } catch (err) {
        console.warn("[sourceTracking] Failed to clear localStorage:", err?.message || err);
    }
};


/***/ }),

/***/ 54189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fc": function() { return /* binding */ SearchButtonIcon; },
/* harmony export */   "LZ": function() { return /* binding */ ArrowRightIcon; },
/* harmony export */   "P": function() { return /* binding */ RegisterArrowIcon; },
/* harmony export */   "Qu": function() { return /* binding */ CalendarIcon; },
/* harmony export */   "T1": function() { return /* binding */ HighDemandIcon; },
/* harmony export */   "T3": function() { return /* binding */ ClockIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "UK": function() { return /* binding */ KcLogo; },
/* harmony export */   "Uk": function() { return /* binding */ CountryFlagIcon; },
/* harmony export */   "Vx": function() { return /* binding */ AppFeeIcon; },
/* harmony export */   "W1": function() { return /* binding */ SearchIcon; },
/* harmony export */   "XC": function() { return /* binding */ ChevronRightIcon; },
/* harmony export */   "Y5": function() { return /* binding */ InstitutionIcon; },
/* harmony export */   "at": function() { return /* binding */ KcLogoSmall; },
/* harmony export */   "bV": function() { return /* binding */ MailIcon; },
/* harmony export */   "bs": function() { return /* binding */ GraduationCapIcon; },
/* harmony export */   "k5": function() { return /* binding */ TuitionIcon; },
/* harmony export */   "mO": function() { return /* binding */ EditPencilIcon; },
/* harmony export */   "pf": function() { return /* binding */ BackArrowIcon; },
/* harmony export */   "rs": function() { return /* binding */ TopBadgeIcon; },
/* harmony export */   "sz": function() { return /* binding */ InfoIcon; }
/* harmony export */ });
/* unused harmony export StarIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const KcLogo = ({ className  })=>// eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        src: "/images/b2c/kc-logo-tm.svg",
        alt: "KC Overseas Education",
        width: 206,
        style: {
            height: "auto",
            display: "block"
        }
    });
const MailIcon = ({ className  })=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.5 5.833A1.667 1.667 0 014.167 4.167h11.666A1.667 1.667 0 0117.5 5.833v8.334a1.667 1.667 0 01-1.667 1.666H4.167A1.667 1.667 0 012.5 14.167V5.833z",
                stroke: "#8F9297",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.5 5.833l7.5 5.417 7.5-5.417",
                stroke: "#8F9297",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const ArrowRightIcon = ({ className  })=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.167 10h11.666M10.833 5l5 5-5 5",
            stroke: "#fff",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const StarIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
            fill: "#fff"
        })
    });
const BackArrowIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.75 18.002L9.25 18.002",
                stroke: "#3B3B3B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.999 26.75L9.24902 18L17.999 9.25",
                stroke: "#3B3B3B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const CloseIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M27 9L9 27",
                stroke: "#3B3B3B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 9L27 27",
                stroke: "#3B3B3B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const KcLogoSmall = ({ className  })=>// eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        src: "/images/b2c/kc-logo-tm.svg",
        alt: "KC Overseas Education",
        width: 171,
        style: {
            height: "auto",
            display: "block"
        }
    });
const SearchIcon = ({ className  })=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z",
                stroke: "#226CF5",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.5 17.5L13.875 13.875",
                stroke: "#226CF5",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const SearchButtonIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.167 15.833a6.667 6.667 0 100-13.333 6.667 6.667 0 000 13.333z",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.5 17.5l-3.625-3.625",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const CalendarIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_15594_31768",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_15594_31768)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.42321 17.9167C4.00223 17.9167 3.64591 17.7708 3.35425 17.4792C3.06258 17.1875 2.91675 16.8312 2.91675 16.4102V5.25647C2.91675 4.8355 3.06258 4.47918 3.35425 4.18751C3.64591 3.89585 4.00223 3.75001 4.42321 3.75001H5.57696V1.9873H6.85904V3.75001H13.1732V1.9873H14.4232V3.75001H15.577C15.9979 3.75001 16.3542 3.89585 16.6459 4.18751C16.9376 4.47918 17.0834 4.8355 17.0834 5.25647V16.4102C17.0834 16.8312 16.9376 17.1875 16.6459 17.4792C16.3542 17.7708 15.9979 17.9167 15.577 17.9167H4.42321ZM4.42321 16.6667H15.577C15.6411 16.6667 15.6999 16.6399 15.7532 16.5865C15.8067 16.5331 15.8334 16.4744 15.8334 16.4102V8.5898H4.16675V16.4102C4.16675 16.4744 4.19348 16.5331 4.24696 16.5865C4.30029 16.6399 4.35904 16.6667 4.42321 16.6667ZM4.16675 7.3398H15.8334V5.25647C15.8334 5.1923 15.8067 5.13355 15.7532 5.08022C15.6999 5.02675 15.6411 5.00001 15.577 5.00001H4.42321C4.35904 5.00001 4.30029 5.02675 4.24696 5.08022C4.19348 5.13355 4.16675 5.1923 4.16675 5.25647V7.3398ZM10.0001 11.7308C9.79605 11.7308 9.62217 11.659 9.47842 11.5152C9.3348 11.3716 9.263 11.1977 9.263 10.9936C9.263 10.7895 9.3348 10.6156 9.47842 10.4719C9.62217 10.3283 9.79605 10.2565 10.0001 10.2565C10.2041 10.2565 10.378 10.3283 10.5217 10.4719C10.6654 10.6156 10.7372 10.7895 10.7372 10.9936C10.7372 11.1977 10.6654 11.3716 10.5217 11.5152C10.378 11.659 10.2041 11.7308 10.0001 11.7308ZM6.14508 11.5152C6.00147 11.3716 5.92966 11.1977 5.92966 10.9936C5.92966 10.7895 6.00147 10.6156 6.14508 10.4719C6.28883 10.3283 6.46272 10.2565 6.66675 10.2565C6.87078 10.2565 7.04467 10.3283 7.18842 10.4719C7.33203 10.6156 7.40383 10.7895 7.40383 10.9936C7.40383 11.1977 7.33203 11.3716 7.18842 11.5152C7.04467 11.659 6.87078 11.7308 6.66675 11.7308C6.46272 11.7308 6.28883 11.659 6.14508 11.5152ZM13.3334 11.7308C13.1294 11.7308 12.9555 11.659 12.8117 11.5152C12.6681 11.3716 12.5963 11.1977 12.5963 10.9936C12.5963 10.7895 12.6681 10.6156 12.8117 10.4719C12.9555 10.3283 13.1294 10.2565 13.3334 10.2565C13.5374 10.2565 13.7113 10.3283 13.8551 10.4719C13.9987 10.6156 14.0705 10.7895 14.0705 10.9936C14.0705 11.1977 13.9987 11.3716 13.8551 11.5152C13.7113 11.659 13.5374 11.7308 13.3334 11.7308ZM10.0001 15C9.79605 15 9.62217 14.9281 9.47842 14.7844C9.3348 14.6408 9.263 14.467 9.263 14.2629C9.263 14.0588 9.3348 13.8849 9.47842 13.7413C9.62217 13.5975 9.79605 13.5256 10.0001 13.5256C10.2041 13.5256 10.378 13.5975 10.5217 13.7413C10.6654 13.8849 10.7372 14.0588 10.7372 14.2629C10.7372 14.467 10.6654 14.6408 10.5217 14.7844C10.378 14.9281 10.2041 15 10.0001 15ZM6.14508 14.7844C6.00147 14.6408 5.92966 14.467 5.92966 14.2629C5.92966 14.0588 6.00147 13.8849 6.14508 13.7413C6.28883 13.5975 6.46272 13.5256 6.66675 13.5256C6.87078 13.5256 7.04467 13.5975 7.18842 13.7413C7.33203 13.8849 7.40383 14.0588 7.40383 14.2629C7.40383 14.467 7.33203 14.6408 7.18842 14.7844C7.04467 14.9281 6.87078 15 6.66675 15C6.46272 15 6.28883 14.9281 6.14508 14.7844ZM13.3334 15C13.1294 15 12.9555 14.9281 12.8117 14.7844C12.6681 14.6408 12.5963 14.467 12.5963 14.2629C12.5963 14.0588 12.6681 13.8849 12.8117 13.7413C12.9555 13.5975 13.1294 13.5256 13.3334 13.5256C13.5374 13.5256 13.7113 13.5975 13.8551 13.7413C13.9987 13.8849 14.0705 14.0588 14.0705 14.2629C14.0705 14.467 13.9987 14.6408 13.8551 14.7844C13.7113 14.9281 13.5374 15 13.3334 15Z",
                    fill: "#226CF5"
                })
            })
        ]
    });
const AppFeeIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_15594_31773",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_15594_31773)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.68262 10C1.68262 10.9765 1.93338 11.8651 2.43491 12.6658C2.93658 13.4667 3.60192 14.0674 4.43095 14.4679C4.58276 14.5524 4.69706 14.672 4.77387 14.8269C4.85081 14.9819 4.85831 15.1394 4.79637 15.2996C4.73442 15.4685 4.62199 15.5868 4.45908 15.6546C4.29616 15.7225 4.13887 15.7169 3.9872 15.6377C2.8504 15.0928 1.9738 14.3068 1.35741 13.2796C0.740881 12.2524 0.432617 11.1592 0.432617 10C0.432617 8.84931 0.734423 7.7625 1.33803 6.73958C1.94165 5.71667 2.80755 4.93278 3.93574 4.38792C4.08755 4.30875 4.24706 4.30097 4.41428 4.36458C4.58137 4.42819 4.70019 4.54437 4.77074 4.71312C4.8413 4.86479 4.84026 5.01812 4.76762 5.17312C4.69498 5.32799 4.58276 5.44764 4.43095 5.53208C3.60192 5.93264 2.93658 6.53333 2.43491 7.33417C1.93338 8.13486 1.68262 9.02347 1.68262 10ZM11.6826 16.25C9.94762 16.25 8.4722 15.6421 7.25637 14.4262C6.04053 13.2104 5.43262 11.735 5.43262 10C5.43262 8.265 6.04053 6.78958 7.25637 5.57375C8.4722 4.35792 9.94762 3.75 11.6826 3.75C12.4176 3.75 13.1137 3.86701 13.7707 4.10104C14.4278 4.33493 15.025 4.66611 15.5624 5.09458C15.7002 5.20139 15.7718 5.33785 15.7772 5.50396C15.7825 5.67007 15.7205 5.81778 15.5912 5.94708C15.4705 6.06778 15.3236 6.13111 15.1505 6.13708C14.9775 6.14292 14.8178 6.09243 14.6714 5.98563C14.2494 5.66937 13.7879 5.42604 13.2868 5.25563C12.7857 5.08521 12.251 5 11.6826 5C10.2937 5 9.11317 5.48611 8.14095 6.45833C7.16873 7.43056 6.68262 8.61111 6.68262 10C6.68262 11.3889 7.16873 12.5694 8.14095 13.5417C9.11317 14.5139 10.2937 15 11.6826 15C12.251 15 12.7857 14.9148 13.2868 14.7444C13.7879 14.574 14.2494 14.3306 14.6714 14.0144C14.8178 13.9076 14.9775 13.8571 15.1505 13.8629C15.3236 13.8689 15.4705 13.9322 15.5912 14.0529C15.7205 14.1822 15.7825 14.3299 15.7772 14.496C15.7718 14.6622 15.7002 14.7986 15.5624 14.9054C15.025 15.3339 14.4278 15.6651 13.7707 15.899C13.1137 16.133 12.4176 16.25 11.6826 16.25ZM17.1857 10.625H11.5224C11.345 10.625 11.1965 10.5651 11.0768 10.4454C10.9572 10.3258 10.8974 10.1774 10.8974 10C10.8974 9.82264 10.9572 9.67417 11.0768 9.55458C11.1965 9.43486 11.345 9.375 11.5224 9.375H17.1857L16.0832 8.2725C15.9678 8.15708 15.9088 8.01201 15.9062 7.83729C15.9035 7.66271 15.9625 7.515 16.0832 7.39417C16.2039 7.27347 16.3503 7.21312 16.5224 7.21312C16.6944 7.21312 16.8407 7.27347 16.9614 7.39417L19.0399 9.47271C19.1906 9.6234 19.266 9.79917 19.266 10C19.266 10.2008 19.1906 10.3766 19.0399 10.5273L16.9614 12.6058C16.8461 12.7211 16.7011 12.7801 16.5264 12.7829C16.3516 12.7856 16.2039 12.7265 16.0832 12.6058C15.9625 12.485 15.9022 12.3386 15.9022 12.1667C15.9022 11.9947 15.9625 11.8483 16.0832 11.7275L17.1857 10.625Z",
                    fill: "#226CF5"
                })
            })
        ]
    });
const TuitionIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_15594_31778",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_15594_31778)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M3.58971 15.4163C3.16874 15.4163 2.81242 15.2705 2.52075 14.9788C2.22909 14.6872 2.08325 14.3309 2.08325 13.9099V6.08947C2.08325 5.66849 2.22909 5.31217 2.52075 5.02051C2.81242 4.72884 3.16874 4.58301 3.58971 4.58301H16.4101C16.8311 4.58301 17.1874 4.72884 17.4791 5.02051C17.7708 5.31217 17.9166 5.66849 17.9166 6.08947V13.9099C17.9166 14.3309 17.7708 14.6872 17.4791 14.9788C17.1874 15.2705 16.8311 15.4163 16.4101 15.4163H3.58971ZM3.58971 14.1663H16.4101C16.4743 14.1663 16.533 14.1396 16.5864 14.0861C16.6398 14.0328 16.6666 13.974 16.6666 13.9099V6.08947C16.6666 6.0253 16.6398 5.96655 16.5864 5.91322C16.533 5.85974 16.4743 5.83301 16.4101 5.83301H3.58971C3.52554 5.83301 3.46679 5.85974 3.41346 5.91322C3.35999 5.96655 3.33325 6.0253 3.33325 6.08947V13.9099C3.33325 13.974 3.35999 14.0328 3.41346 14.0861C3.46679 14.1396 3.52554 14.1663 3.58971 14.1663ZM14.7114 12.2111H13.1249C12.9817 12.2111 12.8631 12.2581 12.7691 12.3522C12.6751 12.4462 12.628 12.5648 12.628 12.708C12.628 12.8512 12.6751 12.9698 12.7691 13.0638C12.8631 13.1579 12.9817 13.2049 13.1249 13.2049H14.9518C15.1665 13.2049 15.3458 13.133 15.4895 12.9893C15.6333 12.8455 15.7051 12.6663 15.7051 12.4515V10.6247C15.7051 10.4815 15.6581 10.3629 15.5641 10.2688C15.4701 10.1748 15.3514 10.1278 15.2083 10.1278C15.0651 10.1278 14.9464 10.1748 14.8524 10.2688C14.7584 10.3629 14.7114 10.4815 14.7114 10.6247V12.2111ZM9.99992 12.2432C10.6195 12.2432 11.1483 12.0242 11.5864 11.5861C12.0244 11.1481 12.2435 10.6193 12.2435 9.99967C12.2435 9.38009 12.0244 8.85127 11.5864 8.41322C11.1483 7.97516 10.6195 7.75613 9.99992 7.75613C9.38034 7.75613 8.85152 7.97516 8.41346 8.41322C7.9754 8.85127 7.75638 9.38009 7.75638 9.99967C7.75638 10.6193 7.9754 11.1481 8.41346 11.5861C8.85152 12.0242 9.38034 12.2432 9.99992 12.2432ZM5.28846 7.78822H6.87492C7.01811 7.78822 7.13672 7.7412 7.23075 7.64717C7.32478 7.55315 7.37179 7.43454 7.37179 7.29134C7.37179 7.14815 7.32478 7.02954 7.23075 6.93551C7.13672 6.84148 7.01811 6.79447 6.87492 6.79447H5.04804C4.83332 6.79447 4.65409 6.86634 4.51034 7.01009C4.36659 7.15384 4.29471 7.33308 4.29471 7.5478V9.37467C4.29471 9.51787 4.34172 9.63648 4.43575 9.73051C4.52978 9.82453 4.64839 9.87155 4.79159 9.87155C4.93478 9.87155 5.05339 9.82453 5.14742 9.73051C5.24145 9.63648 5.28846 9.51787 5.28846 9.37467V7.78822Z",
                    fill: "#226CF5"
                })
            })
        ]
    });
const ClockIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_15594_31783",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_15594_31783)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.99992 17.9163C8.90478 17.9163 7.87561 17.7086 6.91242 17.293C5.94922 16.8775 5.11138 16.3135 4.39888 15.6011C3.68638 14.8888 3.12235 14.0511 2.70679 13.088C2.2911 12.125 2.08325 11.096 2.08325 10.0011C2.08325 8.90613 2.29103 7.8769 2.70659 6.91342C3.12214 5.94995 3.6861 5.1119 4.39846 4.39926C5.11082 3.68662 5.94853 3.12238 6.91159 2.70655C7.87464 2.29085 8.9036 2.08301 9.99846 2.08301C11.0935 2.08301 12.1227 2.29085 13.0862 2.70655C14.0496 3.1221 14.8877 3.68613 15.6003 4.39863C16.313 5.11113 16.8772 5.94898 17.293 6.91217C17.7087 7.87537 17.9166 8.90454 17.9166 9.99967C17.9166 10.3747 17.893 10.7427 17.846 11.1038C17.799 11.465 17.7242 11.8191 17.6216 12.1663C17.4699 12.0083 17.299 11.8729 17.1089 11.7601C16.9187 11.6475 16.711 11.5686 16.4855 11.5236C16.5486 11.2779 16.5945 11.0288 16.6233 10.7761C16.6521 10.5235 16.6666 10.2647 16.6666 9.99967C16.6666 8.13856 16.0208 6.56217 14.7291 5.27051C13.4374 3.97884 11.861 3.33301 9.99992 3.33301C8.13881 3.33301 6.56242 3.97884 5.27075 5.27051C3.97909 6.56217 3.33325 8.13856 3.33325 9.99967C3.33325 11.8608 3.97909 13.4372 5.27075 14.7288C6.56242 16.0205 8.13881 16.6663 9.99992 16.6663C10.7296 16.6663 11.424 16.5565 12.083 16.337C12.7421 16.1174 13.3479 15.81 13.9005 15.4147C14.0298 15.5868 14.1813 15.7417 14.3549 15.8795C14.5285 16.0172 14.7168 16.1268 14.9197 16.208C14.2435 16.7454 13.4899 17.1644 12.6591 17.4651C11.8283 17.7659 10.9419 17.9163 9.99992 17.9163ZM15.3301 14.5499C15.1687 14.3888 15.088 14.1916 15.088 13.9584C15.088 13.7252 15.1685 13.528 15.3295 13.3668C15.4906 13.2054 15.6878 13.1247 15.921 13.1247C16.1542 13.1247 16.3514 13.2052 16.5126 13.3661C16.674 13.5272 16.7547 13.7244 16.7547 13.9576C16.7547 14.1908 16.6742 14.388 16.5133 14.5493C16.3521 14.7106 16.155 14.7913 15.9218 14.7913C15.6886 14.7913 15.4914 14.7109 15.3301 14.5499ZM12.8941 13.7722L9.37492 10.2528V5.83301H10.6249V9.74655L13.7724 12.8938L12.8941 13.7722Z",
                    fill: "#226CF5"
                })
            })
        ]
    });
const TopBadgeIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_badge",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_badge)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.00008 9.85166L9.74758 11.1747C9.86803 11.2593 9.98958 11.2621 10.1122 11.183C10.2349 11.104 10.2727 10.9931 10.2257 10.8503L9.56425 8.66183L11.2711 7.44799C11.3964 7.35466 11.4345 7.23833 11.3852 7.09899C11.3361 6.95977 11.2383 6.89016 11.0917 6.89016H9.00258L8.29108 4.59133C8.24008 4.44866 8.14314 4.37733 8.00025 4.37733C7.85736 4.37733 7.7603 4.44866 7.70908 4.59133L6.99758 6.89016H4.90841C4.76186 6.89016 4.66403 6.95977 4.61491 7.09899C4.56569 7.23833 4.60375 7.35466 4.72908 7.44799L6.43591 8.66183L5.77442 10.8503C5.72741 10.9931 5.76525 11.104 5.88791 11.183C6.01058 11.2621 6.13214 11.2593 6.25258 11.1747L8.00008 9.85166ZM8.00125 14.3337C7.12525 14.3337 6.30186 14.1674 5.53108 13.835C4.7603 13.5025 4.08986 13.0514 3.51975 12.4815C2.94964 11.9116 2.49825 11.2414 2.16558 10.471C1.83303 9.70055 1.66675 8.87738 1.66675 8.00149C1.66675 7.12549 1.83297 6.3021 2.16541 5.53133C2.49786 4.76055 2.94903 4.0901 3.51891 3.51999C4.0888 2.94988 4.75897 2.49849 5.52941 2.16583C6.29986 1.83327 7.12303 1.66699 7.99891 1.66699C8.87492 1.66699 9.6983 1.83321 10.4691 2.16566C11.2399 2.4981 11.9103 2.94927 12.4804 3.51916C13.0505 4.08905 13.5019 4.75921 13.8346 5.52966C14.1671 6.3001 14.3334 7.12327 14.3334 7.99916C14.3334 8.87516 14.1672 9.69855 13.8347 10.4693C13.5023 11.2401 13.0511 11.9105 12.4812 12.4807C11.9114 13.0508 11.2412 13.5022 10.4707 13.8348C9.7003 14.1674 8.87714 14.3337 8.00125 14.3337Z",
                    fill: "white"
                })
            })
        ]
    });
const HighDemandIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_demand",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_demand)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.64746 7.7946C6.00379 7.7946 5.45402 7.5666 4.99813 7.1106C4.54213 6.65471 4.31413 6.10493 4.31413 5.46126C4.31413 4.81771 4.54213 4.26793 4.99813 3.81193C5.45402 3.35593 6.00379 3.12793 6.64746 3.12793C7.29102 3.12793 7.84079 3.35593 8.29679 3.81193C8.75268 4.26793 8.98063 4.81771 8.98063 5.46126C8.98063 6.10493 8.75268 6.65471 8.29679 7.1106C7.84079 7.5666 7.29102 7.7946 6.64746 7.7946ZM2.66029 12.8716C2.37907 12.8716 2.13996 12.7731 1.94296 12.5761C1.74596 12.379 1.64746 12.1399 1.64746 11.8588V11.3894C1.64746 11.0357 1.73657 10.7265 1.91479 10.4619C2.09291 10.1974 2.32941 9.99032 2.62429 9.84076C3.19096 9.55187 3.78924 9.31815 4.41913 9.1396C5.04913 8.96093 5.7919 8.8716 6.64746 8.8716H7.05379C7.18202 8.8716 7.30768 8.88054 7.43079 8.89843C7.63157 8.91643 7.76318 9.02032 7.82563 9.2101C7.88796 9.39976 7.84779 9.56599 7.70513 9.70876L7.30629 10.1074C7.03452 10.3792 6.87535 10.6982 6.82879 11.0644C6.78224 11.4308 6.86107 11.7656 7.06529 12.0689C7.18152 12.2459 7.19885 12.4239 7.11729 12.6029C7.03563 12.782 6.89652 12.8716 6.69996 12.8716H2.66029ZM10.2833 11.9639L13.2986 8.94843C13.391 8.85621 13.507 8.80899 13.6468 8.80676C13.7865 8.80465 13.9046 8.85187 14.0013 8.94843C14.0979 9.0451 14.1461 9.16221 14.1461 9.29976C14.1461 9.43732 14.0979 9.55443 14.0013 9.6511L10.7051 12.9473C10.5846 13.0677 10.444 13.1279 10.2833 13.1279C10.1226 13.1279 9.98202 13.0677 9.86146 12.9473L8.56529 11.6511C8.47307 11.5588 8.42585 11.4427 8.42363 11.3029C8.42152 11.1633 8.46874 11.0451 8.56529 10.9484C8.66196 10.8519 8.77907 10.8036 8.91663 10.8036C9.05418 10.8036 9.17129 10.8519 9.26796 10.9484L10.2833 11.9639Z",
                    fill: "white"
                })
            })
        ]
    });
const ChevronRightIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.5 15L12.5 10L7.5 5",
            stroke: "#226CF5",
            strokeWidth: "1.33",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const RegisterArrowIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.167 10h11.666M10 4.167L15.833 10 10 15.833",
            stroke: "white",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const CountryFlagIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3.33334 14V2.66667M3.33334 9.33333H10.6667L9.33334 6.66667L10.6667 4H3.33334",
            stroke: "#226CF5",
            strokeWidth: "1.33",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const GraduationCapIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.5 7.5L10 3.75L17.5 7.5L10 11.25L2.5 7.5Z",
                stroke: "#226CF5",
                strokeWidth: "1.33",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.83334 9.16667V13.3333C5.83334 13.3333 7.5 15 10 15C12.5 15 14.1667 13.3333 14.1667 13.3333V9.16667",
                stroke: "#226CF5",
                strokeWidth: "1.33",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.5 7.5V11.6667",
                stroke: "#226CF5",
                strokeWidth: "1.33",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const InstitutionIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2 14H14M3.33334 14V7.33333M5.33334 14V7.33333M10.6667 14V7.33333M12.6667 14V7.33333M1.33334 7.33333H14.6667L8 2L1.33334 7.33333Z",
            stroke: "#226CF5",
            strokeWidth: "1.33",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const EditPencilIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.16669 3.33334H3.33335C2.89133 3.33334 2.4674 3.50894 2.15484 3.8215C1.84228 4.13406 1.66669 4.55798 1.66669 5.00001V16.6667C1.66669 17.1087 1.84228 17.5326 2.15484 17.8452C2.4674 18.1577 2.89133 18.3333 3.33335 18.3333H15C15.4421 18.3333 15.866 18.1577 16.1785 17.8452C16.4911 17.5326 16.6667 17.1087 16.6667 16.6667V10.8333",
                stroke: "#226CF5",
                strokeWidth: "1.67",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.4167 2.08334C15.7483 1.7517 16.1979 1.56539 16.6667 1.56539C17.1356 1.56539 17.5852 1.7517 17.9167 2.08334C18.2484 2.41498 18.4347 2.86461 18.4347 3.33334C18.4347 3.80207 18.2484 4.2517 17.9167 4.58334L10 12.5L6.66669 13.3333L7.50002 10L15.4167 2.08334Z",
                stroke: "#226CF5",
                strokeWidth: "1.67",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
// CFM-1685: info affordance on the sponsored card's label. currentColor so it inherits the
// label's brand colour rather than hardcoding it like the older icons above.
const InfoIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 12 12",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "6",
                cy: "6",
                r: "5.25",
                stroke: "currentColor",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6 5.25v3",
                stroke: "currentColor",
                strokeWidth: "1",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "6",
                cy: "3.6",
                r: "0.6",
                fill: "currentColor"
            })
        ]
    });


/***/ }),

/***/ 59830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IG": function() { return /* binding */ SHOW_CONTACT_WHITELIST; },
/* harmony export */   "Qy": function() { return /* binding */ EVENT_ITEMS; },
/* harmony export */   "R4": function() { return /* binding */ defaultSchema; },
/* harmony export */   "SS": function() { return /* binding */ unicountries; },
/* harmony export */   "Tq": function() { return /* binding */ COUNTRY_DETAIL_SECONDARY_NAV_ITEMS; },
/* harmony export */   "UR": function() { return /* binding */ BRANCH_OFFICES; },
/* harmony export */   "X5": function() { return /* binding */ excludeChatScriptPaths; },
/* harmony export */   "Y$": function() { return /* binding */ sliderSpeed; },
/* harmony export */   "Y4": function() { return /* binding */ commonJotformScript; },
/* harmony export */   "dt": function() { return /* binding */ HIDE_EXTERNAL_LINKS_PATHS; },
/* harmony export */   "gW": function() { return /* binding */ navColors; },
/* harmony export */   "hW": function() { return /* binding */ countries; },
/* harmony export */   "iV": function() { return /* binding */ formatOrder; },
/* harmony export */   "pc": function() { return /* binding */ HIDE_STUDENT_LOGIN; },
/* harmony export */   "r$": function() { return /* binding */ HIDE_WHATSAPP_BUTTON_PATHS; },
/* harmony export */   "rq": function() { return /* binding */ COACHING_CATEGORY_ENUM; },
/* harmony export */   "sA": function() { return /* binding */ INTEREST_TEXT; },
/* harmony export */   "uS": function() { return /* binding */ eventTypes; },
/* harmony export */   "zl": function() { return /* binding */ HEAD_OFFICE; }
/* harmony export */ });
/* unused harmony exports OFFICES_LENGTH, courseCategories, coachingCategories, successStoriesCategories, CACHE_REVALIDATE, CACHE_REVALIDATE_24H, TELEPHONE_NUMBERS */
const OFFICES_LENGTH = 6;
// keep home page value at last index
const navColors = [
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/country/"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/contact-us/"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/coaching/"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/aboutus"
    },
    {
        navColor: "#226CF5",
        navMenuColor: "#ffffff",
        pathName: "/contact-us"
    },
    {
        navColor: "#FBBFB6",
        navMenuColor: "#0E1B2C",
        pathName: "/student-services/steps-to-study-abroad"
    },
    {
        navColor: "#B8AAEE",
        navMenuColor: "#0E1B2C",
        pathName: "/partners/institutions-universities"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/study-destinations"
    },
    {
        navColor: "#96BCFF",
        navMenuColor: "#0E1B2C",
        pathName: "/entrepreneur/franchise-proposal"
    },
    {
        navColor: "#226CF5",
        navMenuColor: "#ffffff",
        pathName: "/partners/study-abroad-association"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/partners/"
    },
    {
        navColor: "#0046c9",
        navMenuColor: "#ffffff",
        pathName: "/online-counselling/"
    },
    {
        navColor: "#0046c9",
        navMenuColor: "#ffffff",
        pathName: "/online-counselling"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/test-preparation"
    },
    {
        navColor: "#313145",
        navMenuColor: "#ffffff",
        pathName: "/universities"
    },
    {
        navColor: "#20115b",
        navMenuColor: "#ffffff",
        pathName: "/events"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/student-services/education-loan-for-overseas-education"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/internships"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/blogs"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/news"
    },
    {
        navColor: "#1e1553e3",
        navMenuColor: "#ffffff",
        pathName: "/careers"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/student-services/study-abroad-scholarships/"
    },
    {
        navColor: "#226cf5",
        navMenuColor: "#ffffff",
        pathName: "/student-services/study-abroad-scholarships"
    },
    {
        navColor: "#313145",
        navMenuColor: "#ffffff",
        pathName: "/partners/webinar-by-university-delegates"
    },
    {
        navColor: "#313145",
        navMenuColor: "#ffffff",
        pathName: "/partners/webinar-by-kc-admission-experts"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/student-services/study-abroad-scholarships"
    },
    {
        navColor: "#226CF5",
        navMenuColor: "#ffffff",
        pathName: "/terms-and-condition"
    },
    {
        navColor: "#226CF5",
        navMenuColor: "#ffffff",
        pathName: "/privacy-policy"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/corporate-social-responsibility"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/kc-overseas-mihan-nagpur"
    },
    {
        navColor: "#6C48F0",
        navMenuColor: "#ffffff",
        pathName: "/allied-services"
    },
    {
        navColor: "#226CF5",
        navMenuColor: "#ffffff",
        pathName: "/payment-and-refund-policy"
    },
    {
        navColor: "#226CF5",
        navMenuColor: "#ffffff",
        pathName: "/"
    }, 
];
const courseCategories = [
    {
        label: "Business Administration & Management",
        value: "business_administration_management"
    },
    {
        label: "Health Care + Pharma",
        value: "healthcare_pharma"
    },
    {
        label: "Engineering",
        value: "engineering"
    },
    {
        label: "Data Science + Analytics",
        value: "data_science_analytics"
    },
    {
        label: "Accounts & Finance",
        value: "accounts_finance"
    },
    {
        label: "AI + Robotics",
        value: "ai_robotics"
    },
    {
        label: "Computer Science & IT",
        value: "computer_science_it"
    },
    {
        label: "Others",
        value: "others"
    }, 
];
const coachingCategories = [
    {
        label: "IELTS",
        value: "IELTS"
    },
    {
        label: "TOEFL",
        value: "TOEFL"
    },
    {
        label: "PTE",
        value: "PTE"
    },
    {
        label: "GRE",
        value: "GRE"
    },
    {
        label: "GMAT",
        value: "GMAT"
    },
    {
        label: "SAT",
        value: "SAT"
    },
    {
        label: "PSAT",
        value: "PSAT"
    },
    {
        label: "Duolingo",
        value: "Duolingo"
    },
    {
        label: "ACT",
        value: "ACT"
    },
    {
        label: "German Language",
        value: "Germanlanguage"
    },
    {
        label: "French Language",
        value: "Frenchlanguage"
    },
    {
        label: "Japanese Language",
        value: "Japaneselanguage"
    }
];
const successStoriesCategories = [
    {
        label: "Student",
        value: "student"
    },
    {
        label: "Parent",
        value: "parent"
    },
    {
        label: "University",
        value: "university"
    },
    {
        label: "Franchisee",
        value: "franchisee"
    },
    {
        label: "Partner Associate",
        value: "partner_associate"
    },
    {
        label: "Employee",
        value: "employee"
    }, 
];
const eventTypes = [
    {
        label: "Virtual Admissions Day",
        value: "virtual_admissions_day"
    },
    {
        label: "Virtual Admissions Week",
        value: "virtual_admissions_week"
    },
    {
        label: "Admissions Day",
        value: "admissions_day"
    },
    {
        label: "Virtual Edu Expo",
        value: "virtual_edu_expo"
    },
    {
        label: "Overseas Education Fair",
        value: "overseas_education_fair"
    },
    {
        label: "Applications Week",
        value: "applications_week"
    },
    {
        label: "Institutions",
        value: "institutions"
    },
    {
        label: "Allied Services",
        value: "allied_services"
    },
    {
        label: "Coaching",
        value: "coaching"
    },
    {
        label: "Loan Fair",
        value: "loan_fair"
    },
    {
        label: "Webinar",
        value: "webinar"
    }
];
const countries = [
    {
        slug: "usa",
        label: "USA",
        value: "USA"
    },
    {
        slug: "uk",
        label: "United Kingdom",
        value: "UnitedKingdom"
    },
    {
        slug: "canada",
        label: "Canada",
        value: "Canada"
    },
    {
        slug: "ireland",
        label: "Ireland",
        value: "Ireland"
    },
    {
        slug: "australia",
        label: "Australia",
        value: "Australia"
    },
    {
        slug: "new-zealand",
        label: "New Zealand",
        value: "NewZealand"
    },
    {
        slug: "germany",
        label: "Germany",
        value: "Germany"
    },
    {
        slug: "sweden",
        label: "Sweden",
        value: "Sweden"
    },
    {
        slug: "netherlands",
        label: "Netherlands",
        value: "Netherlands"
    },
    {
        slug: "france",
        label: "France",
        value: "France"
    },
    {
        slug: "finland",
        label: "Finland",
        value: "Finland"
    },
    {
        slug: "dubai",
        label: "Dubai",
        value: "Dubai"
    },
    {
        slug: "singapore",
        label: "Singapore",
        value: "Singapore"
    },
    {
        slug: "malta",
        label: "Malta",
        value: "Malta"
    },
    {
        slug: "hungary",
        label: "Hungary",
        value: "Hungary"
    },
    {
        slug: "spain",
        label: "Spain",
        value: "Spain"
    },
    {
        slug: "poland",
        label: "Poland",
        value: "Poland"
    },
    {
        slug: "malaysia",
        label: "Malaysia",
        value: "Malaysia"
    },
    {
        slug: "denmark",
        label: "Denmark",
        value: "Denmark"
    },
    {
        slug: "italy",
        label: "Italy",
        value: "Italy"
    },
    {
        slug: "switzerland",
        label: "Switzerland",
        value: "Switzerland"
    },
    {
        slug: "lithuania",
        label: "Lithuania",
        value: "Lithuania"
    },
    {
        slug: "cyprus",
        label: "Cyprus",
        value: "Cyprus"
    },
    {
        slug: "china",
        label: "China",
        value: "China"
    },
    {
        slug: "vietnam",
        label: "Vietnam",
        value: "Vietnam"
    },
    {
        slug: "japan",
        label: "Japan",
        value: "Japan"
    },
    {
        slug: "mauritius",
        label: "Mauritius",
        value: "Mauritius"
    },
    {
        slug: "austria",
        label: "Austria",
        value: "Austria"
    },
    {
        slug: "belgium",
        label: "Belgium",
        value: "Belgium"
    },
    {
        slug: "russia",
        label: "Russia",
        value: "Russia"
    },
    {
        slug: "south-korea",
        label: "South Korea",
        value: "SouthKorea"
    },
    {
        slug: "india",
        label: "India",
        value: "India"
    },
    {
        slug: "georgia",
        label: "Georgia",
        value: "Georgia"
    },
    {
        slug: "monaco",
        label: "Monaco",
        value: "Monaco"
    },
    {
        slug: "croatia",
        label: "Croatia",
        value: "Croatia"
    },
    {
        slug: "indonesia",
        label: "Indonesia",
        value: "Indonesia"
    },
    {
        slug: "sri-lanka",
        label: "Sri Lanka",
        value: "SriLanka"
    },
    {
        slug: "saudi-arabia",
        label: "Saudi Arabia",
        value: "SaudiArabia"
    },
    {
        slug: "ajman",
        label: "Ajman",
        value: "Ajman"
    },
    {
        slug: "kazakhstan",
        label: "Kazakhstan",
        value: "Kazakhstan"
    },
    {
        slug: "thailand",
        label: "Thailand",
        value: "Thailand"
    },
    {
        slug: "greece",
        label: "Greece",
        value: "Greece"
    },
    {
        slug: "umm-al-quwain",
        label: "Umm Al Quwain",
        value: "UmmAlQuwain"
    },
    {
        slug: "luxembourg",
        label: "Luxembourg",
        value: "Luxembourg"
    },
    {
        slug: "latvia",
        label: "Latvia",
        value: "Latvia"
    }
];
const unicountries = [
    {
        countrySlug: "usa",
        label: "USA",
        value: "USA"
    },
    {
        countrySlug: "uk",
        label: "UK",
        value: "UnitedKingdom"
    },
    {
        countrySlug: "canada",
        label: "Canada",
        value: "Canada"
    },
    {
        countrySlug: "ireland",
        label: "Ireland",
        value: "Ireland"
    },
    {
        countrySlug: "australia",
        label: "Australia",
        value: "Australia"
    },
    {
        countrySlug: "new-zealand",
        label: "New Zealand",
        value: "NewZealand"
    },
    {
        countrySlug: "germany",
        label: "Germany",
        value: "Germany"
    },
    {
        countrySlug: "sweden",
        label: "Sweden",
        value: "Sweden"
    },
    {
        countrySlug: "netherlands",
        label: "Netherlands",
        value: "Netherlands"
    },
    {
        countrySlug: "france",
        label: "France",
        value: "France"
    },
    {
        countrySlug: "finland",
        label: "Finland",
        value: "Finland"
    },
    {
        countrySlug: "dubai",
        label: "Dubai",
        value: "Dubai"
    },
    {
        countrySlug: "singapore",
        label: "Singapore",
        value: "Singapore"
    },
    {
        countrySlug: "malta",
        label: "Malta",
        value: "Malta"
    },
    {
        countrySlug: "hungary",
        label: "Hungary",
        value: "Hungary"
    },
    {
        countrySlug: "spain",
        label: "Spain",
        value: "Spain"
    },
    {
        countrySlug: "poland",
        label: "Poland",
        value: "Poland"
    },
    {
        countrySlug: "malaysia",
        label: "Malaysia",
        value: "Malaysia"
    },
    {
        countrySlug: "denmark",
        label: "Denmark",
        value: "Denmark"
    },
    {
        countrySlug: "italy",
        label: "Italy",
        value: "Italy"
    },
    {
        countrySlug: "switzerland",
        label: "Switzerland",
        value: "Switzerland"
    },
    {
        countrySlug: "lithuania",
        label: "Lithuania",
        value: "Lithuania"
    },
    {
        countrySlug: "cyprus",
        label: "Cyprus",
        value: "Cyprus"
    },
    {
        countrySlug: "china",
        label: "China",
        value: "China"
    },
    {
        countrySlug: "vietnam",
        label: "Vietnam",
        value: "Vietnam"
    },
    {
        countrySlug: "japan",
        label: "Japan",
        value: "Japan"
    },
    {
        countrySlug: "mauritius",
        label: "Mauritius",
        value: "Mauritius"
    },
    {
        countrySlug: "austria",
        label: "Austria",
        value: "Austria"
    },
    {
        countrySlug: "belgium",
        label: "Belgium",
        value: "Belgium"
    },
    {
        countrySlug: "russia",
        label: "Russia",
        value: "Russia"
    },
    {
        countrySlug: "south-korea",
        label: "South Korea",
        value: "SouthKorea"
    },
    {
        countrySlug: "india",
        label: "India",
        value: "India"
    },
    {
        countrySlug: "georgia",
        label: "Georgia",
        value: "Georgia"
    },
    {
        countrySlug: "monaco",
        label: "Monaco",
        value: "Monaco"
    },
    {
        countrySlug: "croatia",
        label: "Croatia",
        value: "Croatia"
    },
    {
        countrySlug: "indonesia",
        label: "Indonesia",
        value: "Indonesia"
    },
    {
        countrySlug: "sri-lanka",
        label: "Sri Lanka",
        value: "SriLanka"
    },
    {
        countrySlug: "abu-dhabi",
        label: "Abu Dhabi",
        value: "AbuDhabi"
    },
    {
        countrySlug: "sharjah",
        label: "Sharjah",
        value: "Sharjah"
    },
    {
        countrySlug: "ras-al-khaimah",
        label: "Ras Al Khaimah",
        value: "RasAlKhaimah"
    },
    {
        countrySlug: "saudi-arabia",
        label: "Saudi Arabia",
        value: "SaudiArabia"
    },
    {
        countrySlug: "ajman",
        label: "Ajman",
        value: "Ajman"
    },
    {
        countrySlug: "kazakhstan",
        label: "Kazakhstan",
        value: "Kazakhstan"
    },
    {
        countrySlug: "thailand",
        label: "Thailand",
        value: "Thailand"
    },
    {
        countrySlug: "greece",
        label: "Greece",
        value: "Greece"
    },
    {
        countrySlug: "umm-al-quwain",
        label: "Umm Al Quwain",
        value: "UmmAlQuwain"
    },
    {
        countrySlug: "luxembourg",
        label: "Luxembourg",
        value: "Luxembourg"
    },
    {
        countrySlug: "latvia",
        label: "Latvia",
        value: "Latvia"
    },
    {
        countrySlug: "turkey",
        label: "Turkey",
        value: "Turkey"
    },
    {
        countrySlug: "bahrain",
        label: "Bahrain",
        value: "Bahrain"
    },
    {
        countrySlug: "slovenia",
        label: "Slovenia",
        value: "Slovenia"
    },
    {
        countrySlug: "czech-republic",
        label: "Czech Republic",
        value: "CzechRepublic"
    },
    {
        countrySlug: "philippines",
        label: "Philippines",
        value: "Philippines"
    }, 
];
const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "KC Overseas Education",
    url: "https://www.studies-overseas.com/",
    logo: "https://www.studies-overseas.com/kc_schema_logo.png",
    contactPoint: {
        "@type": "ContactPoint",
        telephone: "712 - 2222061",
        contactType: "customer service",
        availableLanguage: "en"
    },
    sameAs: [
        "https://www.facebook.com/KCOverseasEdu/",
        "https://twitter.com/KCOverseasEdu",
        "https://www.instagram.com/KCOverseasEdu/",
        "https://www.youtube.com/c/kcoverseasedu/",
        "https://www.linkedin.com/company/kcoverseasedu/",
        "https://www.snapchat.com/add/kcoverseasedu",
        "https://www.studiesabroadfranchisee.com/",
        "https://www.elanloans.com/", 
    ]
};
const commonJotformScript = [
    {
        jotformscript: `new JotformFeedback({
      formId: '${"241383394530456"}',
      base: 'https://form.jotform.com/',
      windowTitle: 'Enquiry Form',
      background: '#FFA500',
      fontColor: '#FFFFFF',
      type: '0',
      height: 550,
      width: 570,
      openOnLoad: false
      });`
    }, 
];
const excludeChatScriptPaths = [
    "overseas-education-fair",
    "/partners/study-abroad-recruiter",
    "franchisee",
    "recruiter",
    "test-prep",
    "landing-page",
    "admissions-day",
    "applications-week",
    "webinar",
    "institution",
    "company",
    "virtual-admissions-day",
    "virtual-admissions-week",
    "branch",
    "online-counselling",
    "study-abroad-online-counselling",
    "thank-you"
];
const INTEREST_TEXT = "I'm Interested in";
const formatOrder = "MMM dd, yyyy";
const sliderSpeed = {
    desktopAutoplaySpeed: 4000,
    desktopSpeed: 1000,
    mobileAutoplaySpeed: 2000,
    mobileSpeed: 500
};
const CACHE_REVALIDATE = 21600;
const CACHE_REVALIDATE_24H = 86400;
const HIDE_WHATSAPP_BUTTON_PATHS = [
    "/admissions-day",
    "/applications-week",
    "/overseas-education-fair",
    "/webinar",
    "/virtual-admissions-week",
    "/virtual-admissions-day",
    "/branch",
    "/institution",
    "/company",
    "/study-abroad-online-counselling",
    "/partners",
    "/kc-overseas-mihan-nagpur",
    "/franchisee",
    "/partners/institutions-universities",
    "/partners/study-abroad-association",
    "/entrepreneur/franchise-proposal",
    "/landing-page",
    "/test-prep",
    "/online-counselling",
    "/recruiter",
    "/check-email"
];
const HIDE_EXTERNAL_LINKS_PATHS = [
    "/check-email"
];
const SHOW_CONTACT_WHITELIST = [
    "/contact-us/study-abroad-consultants-in-nagpur",
    "/contact-us/study-abroad-consultants-in-nagpur-sadar",
    "/contact-us/study-abroad-consultants-in-amravati",
    "/contact-us/study-abroad-consultants-in-sambhajinagar"
];
const COUNTRY_DETAIL_SECONDARY_NAV_ITEMS = [
    {
        id: "why",
        title: "Overview",
        href: "",
        icon: ""
    },
    {
        id: "universities",
        title: "Universities",
        href: "",
        icon: ""
    },
    {
        id: "courses",
        title: "Courses",
        href: "",
        icon: ""
    },
    {
        id: "cost",
        title: "Cost",
        href: "",
        icon: ""
    },
    {
        id: "scholarships",
        title: "Scholarships",
        href: "",
        icon: ""
    },
    {
        id: "intakes",
        title: "Intakes",
        href: "",
        icon: ""
    },
    {
        id: "eligibility",
        title: "Eligibility",
        href: "",
        icon: ""
    },
    {
        id: "exams",
        title: "Exams",
        href: "",
        icon: ""
    },
    {
        id: "application",
        title: "Application",
        href: "",
        icon: ""
    },
    {
        id: "visa",
        title: "Visas",
        href: "",
        icon: ""
    },
    {
        id: "career",
        title: "Career",
        href: "",
        icon: ""
    },
    {
        id: "cities",
        title: "Cities",
        href: "",
        icon: ""
    },
    {
        id: "quick-reels",
        title: "Quick Reels",
        href: "",
        icon: ""
    },
    {
        id: "top-admits",
        title: "Top Admits",
        href: "",
        icon: ""
    },
    {
        id: "why-choose-kc",
        title: "Why Choose KC",
        href: "",
        icon: ""
    },
    {
        id: "blogs",
        title: "Blogs",
        href: "",
        icon: ""
    },
    {
        id: "faqs",
        title: "FAQs",
        href: "",
        icon: ""
    },
    {
        id: "related-links",
        title: "Related Links",
        href: "",
        icon: ""
    }, 
];
const EVENT_ITEMS = [
    {
        id: "in-person-events",
        thumbnailUrl: "https://assets.studies-overseas.com/Group_224_73e3f53b56.png",
        thumbnailAlt: "University representatives attending an in-person B2B networking event",
        category: "— IN-PERSON EVENTS",
        title: "Partner Meets",
        paragraphs: [
            "As part of our continued commitment to enhancing student recruitment outcomes for our valued University Partners, KC Overseas regularly organizes exclusive B2B Study Abroad consultant partner networking events across key cities in India and select international locations.",
            "These events offer an excellent platform for University Representatives to engage directly with KC's leading Regional Study Abroad Partners, highlight the unique strengths and program offerings of their institution, and develop strategic collaborations aimed at driving quality student enrolments.",
            "The events are hosted with sponsorship support from participating universities.",
            "Universities interested in joining this initiative are encouraged to connect with:", 
        ],
        contact: {
            name: "Mr. Sachin Bangale",
            email: "sbangale@kcoverseas.com",
            phone: "+91 83088 16813"
        }
    },
    {
        id: "virtual-events",
        thumbnailUrl: "https://assets.studies-overseas.com/Group_219_317669a054.png",
        thumbnailAlt: "University representative conducting an online B2B networking webinar",
        category: "— VIRTUAL EVENTS",
        title: "Webinars",
        paragraphs: [
            "KC Overseas regularly organizes exclusive online Webinars for partners — a dynamic platform for University Representatives to highlight the unique strengths and program offerings of their institution to KC's leading Study Abroad Partners across India and abroad.",
            "There is no participation fee for the participating universities.",
            "Universities interested in conducting the webinars are encouraged to connect with:", 
        ],
        contact: {
            name: "Ms. Tejaswi Nair",
            email: "tnair@kcoverseas.com",
            phone: "+91 74200 22093"
        }
    }, 
];
const TELEPHONE_NUMBERS = {
    headOffice: "+91 712 - 2222061/2222062"
};
const HIDE_STUDENT_LOGIN = [
    "/partners/study-abroad-association",
    "/entrepreneur/franchise-proposal",
    "/partners/institutions-universities"
];
const HEAD_OFFICE = {
    badge: "Head Office",
    name: "KC MIHAN, Nagpur",
    address: "Plot No. 9C, MIHAN SEZ, Sector 17, MIHAN, Khapri, Nagpur, Maharashtra, India - 441108",
    callLines: [
        "+91 - 9890217999"
    ],
    email: "zubin@kcoverseas.com",
    hours: "Monday to Saturday : 10:00 AM to 6:30 PM, Sunday : Closed",
    mapHref: "https://maps.app.goo.gl/Cxz1Qptz5JsgXJwV6",
    image: "/images/contcatus/mihan-head-office.png",
    mapImage: "/images/contcatus/mihan-head-office.png"
};
const BRANCH_OFFICES = [
    {
        id: "it-park",
        mapImage: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.7840525840857!2d79.0462168149342!3d21.121173885948433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x699518a8f68a1afa!2sKC%20Overseas%20Education%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1645081741260!5m2!1sen!2sin",
        name: "KC IT Park, Nagpur",
        address: "'Krishna', Plot No.10/2, I.T. Park, Opp. V.N.I.T, Behind Infotech Tower, Parsodi, Nagpur, Maharashtra, India - 440022",
        callLines: [
            "+91 - 8669602483",
            "+91 - 712 - 2222061/2222062"
        ],
        email: "ningale@kcoverseas.com",
        hours: "Monday to Saturday : 10:00 AM to 6:30 PM, Sunday : Closed",
        mapHref: "https://maps.app.goo.gl/SSRC9B739RfDYKw4A"
    },
    {
        id: "sadar",
        mapImage: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.902150772015!2d79.07886331493482!3d21.15629198592944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x457479a0d9ee32a3!2sKC%20Overseas%20Education%20Sadar%20Nagpur!5e0!3m2!1sen!2sin!4v1645081714389!5m2!1sen!2sin",
        name: "KC Sadar, Nagpur",
        address: "2nd Floor, Block No. 112, Shriram Tower, Kingsway, Sadar, Nagpur, Maharashtra, India - 440001",
        callLines: [
            "+91 - 8669670625/",
            "+91 - 8669665180"
        ],
        email: "vmokadam@kcoverseas.com",
        hours: "Monday to Saturday : 10:00 AM to 6:30 PM, Sunday : Closed",
        mapHref: "https://maps.app.goo.gl/GLPZWWhwh1xZzF319"
    }, 
];
const COACHING_CATEGORY_ENUM = {
    "French Language": "Frenchlanguage",
    "Japanese Language": "Japaneselanguage",
    "German Language": "Germanlanguage",
    "dMAT": "dMat",
    "English Language": "EnglishLanguage"
};


/***/ }),

/***/ 32866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gE": function() { return /* binding */ convertYouTubeToEmbed; },
  "LE": function() { return /* binding */ getBlogName; },
  "Lq": function() { return /* binding */ getColor; },
  "C0": function() { return /* binding */ getCountryFromSlug; },
  "w9": function() { return /* binding */ getMobileImageUrl; },
  "TX": function() { return /* binding */ getSlugFromCountry; },
  "Ye": function() { return /* binding */ getSlugFromCountryUni; },
  "gX": function() { return /* binding */ getSlugFromCountryUniDetail; },
  "Ei": function() { return /* binding */ getYouTubeVideoId; },
  "gd": function() { return /* binding */ isFrappeOrJotFormClass; },
  "o4": function() { return /* binding */ parseHeroHTML; }
});

// UNUSED EXPORTS: dynamicJotformScript, extractIntroParagraphs, getCountryValueFromSlug, getUpdatedValue, isFrappeOrJotForm, regionTabs

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.js
var html_react_parser = __webpack_require__(30488);
;// CONCATENATED MODULE: ./node_modules/html-react-parser/index.mjs


var domToReact = html_react_parser.domToReact;
var htmlToDOM = html_react_parser.htmlToDOM;
var attributesToProps = html_react_parser.attributesToProps;
var Element = html_react_parser.Element;

/* harmony default export */ var node_modules_html_react_parser = (html_react_parser);

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./utils/helpers.ts



const regionTabs = (/* unused pure expression or super */ null && ([
    "North",
    "South",
    "West",
    "East",
    "Central"
]));
const getColor = (pathname)=>constants/* navColors.filter */.gW.filter((nav)=>{
        return nav.pathName === pathname || pathname.includes(nav.pathName);
    });
const getBlogName = (blogType, list)=>{
    return list.filter((type)=>type.value === blogType)[0]?.label;
};
const getCountryFromSlug = (countrySlug, list)=>{
    return list.filter((type)=>type.countrySlug === countrySlug)[0]?.label;
};
const getCountryValueFromSlug = (countrySlug, list)=>{
    return list.filter((type)=>type.countrySlug === countrySlug)[0]?.value;
};
const getSlugFromCountryUni = (country, list)=>{
    return list.filter((type)=>type.label === country)[0]?.countrySlug;
};
const getSlugFromCountryUniDetail = (country, list)=>{
    return list.filter((type)=>type.label.replace(/\s+/g, "") === country)[0]?.countrySlug;
};
const getSlugFromCountry = (country, list)=>{
    return list.filter((type)=>type.label === country)[0]?.slug;
};
const getUpdatedValue = (value)=>value?.toString().replace(/-/g, "_");
const dynamicJotformScript = (jotformId, openOnLoad)=>{
    return `new JotformFeedback({
    formId: '${jotformId}',
    base: 'https://form.jotform.com/',
    windowTitle: 'Enquiry Form',
    background: '#FFA500',
    fontColor: '#FFFFFF',
    type: '0',
    height: 550,
    width: 570,
    openOnLoad: ${openOnLoad}
  })`;
};
const isFrappeOrJotForm = (str)=>{
    if (!str) {
        return ".kc-enquire-form";
    }
    const isJotForm = /^\d+$/.test(str);
    if (isJotForm) {
        return ".lightbox-" + str;
    }
    return ".kc-enquire-form-" + str;
};
const isFrappeOrJotFormClass = (str)=>{
    if (!str) {
        return "kc-enquire-form";
    }
    const isJotForm = /^\d+$/.test(str + "");
    if (isJotForm) {
        return "lightbox-" + str;
    }
    return "kc-enquire-form-" + str;
};
function extractIntroParagraphs(html, count = 2) {
    let intro = "";
    let description = html;
    // Normalize whitespace at the beginning
    let trimmed = html.trimStart();
    // If the very first tag isn’t <p>, return as-is
    if (!trimmed.toLowerCase().startsWith("<p")) {
        return {
            intro: "",
            description: html
        };
    }
    // Regex anchored at the start — matches first <p>...</p>
    const firstParagraphRegex = /^<p[\s\S]*?<\/p>/i;
    for(let i = 0; i < count; i++){
        const match = trimmed.match(firstParagraphRegex);
        if (!match) break;
        intro += match[0];
        trimmed = trimmed.replace(firstParagraphRegex, "").trimStart();
    }
    description = trimmed;
    return {
        intro,
        description
    };
}
const parseStyle = (styleString)=>Object.fromEntries(styleString.split(";").filter(Boolean).map((s)=>{
        const [key, value] = s.split(":");
        return [
            key.trim().replace(/-([a-z])/g, (_, c)=>c.toUpperCase()),
            value.trim()
        ];
    }));
/**
 * Parse hero HTML safely for SSR.
 * Extracts first `count` <p> elements and returns React nodes.
 */ function parseHeroHTML(html, count = 2) {
    let paragraphCount = 0;
    const options = {
        replace: (domNode)=>{
            if (domNode.type === "tag" && domNode.name === "p") {
                paragraphCount++;
                if (paragraphCount > count) return null; // skip paragraphs after first N
                const { attribs , children  } = domNode;
                return react.createElement("p", {
                    className: attribs?.class,
                    style: attribs?.style ? parseStyle(attribs.style) : undefined
                }, domToReact(children, options));
            }
            // Anchors must keep href/target/rel so links (and TOC hash links) work
            if (domNode.type === "tag" && domNode.name === "a") {
                const { attribs: attribs1 , children: children1  } = domNode;
                return react.createElement("a", {
                    href: attribs1?.href,
                    target: attribs1?.target,
                    rel: attribs1?.rel,
                    title: attribs1?.title,
                    id: attribs1?.id,
                    className: attribs1?.class,
                    style: attribs1?.style ? parseStyle(attribs1.style) : undefined
                }, domToReact(children1, options));
            }
            // Optionally allow nested inline tags
            if (domNode.type === "tag" && [
                "strong",
                "em",
                "span"
            ].includes(domNode.name)) {
                const { attribs: attribs2 , children: children2  } = domNode;
                return react.createElement(domNode.name, {
                    className: attribs2?.class,
                    style: attribs2?.style ? parseStyle(attribs2.style) : undefined
                }, domToReact(children2, options));
            }
        }
    };
    return node_modules_html_react_parser(html, options);
}
const getMobileImageUrl = (imageUrl)=>{
    if (!imageUrl) {
        return undefined;
    }
    const mobileImageUrl = imageUrl?.replace("assets.studies-overseas.com", "assets.studies-overseas.com/mobile");
    return mobileImageUrl || imageUrl;
};
// web-540 - convert YouTube URLs to embed format
const convertYouTubeToEmbed = (url)=>{
    if (!url) return null;
    // If already an embed URL, return as is
    if (url.includes("youtube.com/embed/")) {
        return url;
    }
    let videoId = "";
    let queryParams = "";
    try {
        // Handle youtu.be format: https://youtu.be/VIDEO_ID?si=...
        if (url.includes("youtu.be/")) {
            const match = url.match(/youtu\.be\/([^?&]+)(\?.*)?/);
            if (match) {
                videoId = match[1];
                // Extract query parameters from youtu.be URL
                const urlParts = url.split("?");
                if (urlParts.length > 1) {
                    queryParams = "?" + urlParts[1];
                }
            }
        } else if (url.includes("youtube.com/watch")) {
            // Ensure URL has protocol for URL constructor
            const fullUrl = url.startsWith("http") ? url : `https://${url}`;
            const urlObj = new URL(fullUrl);
            videoId = urlObj.searchParams.get("v") || "";
            // Extract other query parameters (like si=) except 'v'
            urlObj.searchParams.delete("v");
            if (urlObj.searchParams.toString()) {
                queryParams = "?" + urlObj.searchParams.toString();
            }
        } else if (url.includes("youtube.com/shorts/")) {
            const match1 = url.match(/youtube\.com\/shorts\/([^?&/]+)/);
            if (match1) {
                videoId = match1[1];
            }
            const queryIndex = url.indexOf("?");
            if (queryIndex !== -1) {
                queryParams = url.slice(queryIndex);
            }
        } else if (url.includes("youtube.com/")) {
            const match2 = url.match(/youtube\.com\/([^?&/]+)/);
            if (match2 && !match2[1].includes("watch") && !match2[1].includes("embed") && !match2[1].includes("shorts") && !match2[1].includes("channel") && !match2[1].includes("user")) {
                videoId = match2[1];
            }
        }
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}${queryParams}`;
        }
    } catch (error) {
        console.error("Error converting YouTube URL:", error);
    }
    // If we can't parse it, return original URL (might already be embed or invalid)
    return url;
};
/** YouTube video id for thumbnail URLs (`img.youtube.com/vi/{id}/...`), derived via the same rules as {@link convertYouTubeToEmbed}. */ const getYouTubeVideoId = (url)=>{
    if (!url) return null;
    const embed = convertYouTubeToEmbed(url);
    if (!embed) return null;
    const m = embed.match(/youtube\.com\/embed\/([^?&/]+)/);
    return m ? m[1] : null;
};


/***/ }),

/***/ 4079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"EnquiryModal_modal__WKej5","modalContent":"EnquiryModal_modalContent__W6KRU","modalHeader":"EnquiryModal_modalHeader__AeLIc","modalBody":"EnquiryModal_modalBody__BxNjp","modalTitle":"EnquiryModal_modalTitle__mkfdz","btn-close":"EnquiryModal_btn-close__V0QUh","iframe":"EnquiryModal_iframe__rC80X","modalOverlay":"EnquiryModal_modalOverlay__K6Ip8","spinner":"EnquiryModal_spinner__jcHgI","spin":"EnquiryModal_spin__hXgc1","loaderBackground":"EnquiryModal_loaderBackground___ptx2"};

/***/ }),

/***/ 52836:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footerMain":"Footer_footerMain__5yv_j","footersvgimg":"Footer_footersvgimg__lx0hj","footerImg":"Footer_footerImg__kSYtf"};

/***/ }),

/***/ 57746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FooterMain_hide-scrollbar__AXkZq","lineBottom":"FooterMain_lineBottom__t8bwZ","footerLinks":"FooterMain_footerLinks__Hs6du","linkHeader":"FooterMain_linkHeader__rcI2j","footerKClogo":"FooterMain_footerKClogo__E2ywU","kclogo":"FooterMain_kclogo__J5WLG","aboutkc":"FooterMain_aboutkc__xKv8A","icefBadge":"FooterMain_icefBadge__qq5YB","ipad":"FooterMain_ipad__FH3U8","ipadHiring":"FooterMain_ipadHiring__3_A_n","weHireBtn":"FooterMain_weHireBtn__pIWsu"};

/***/ }),

/***/ 3514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FooterUtilityBar_hide-scrollbar__cZckW","lineBottom":"FooterUtilityBar_lineBottom__p1gZJ","publicLinks":"FooterUtilityBar_publicLinks__nJz2j","terms":"FooterUtilityBar_terms__EzGyI","socialMediaLink":"FooterUtilityBar_socialMediaLink__SmqwE"};

/***/ }),

/***/ 13435:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lineBottom":"Recognition_lineBottom__sj1xJ","recognitions":"Recognition_recognitions__pYoxw","RegLogo":"Recognition_RegLogo__JPdxn"};

/***/ }),

/***/ 45150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"SiteMap_hide-scrollbar__oB3XF","lineBottom":"SiteMap_lineBottom__5kTdl","siteMapItem":"SiteMap_siteMapItem__TYD1d","siteMapTitle":"SiteMap_siteMapTitle__xmQhF","siteMapList":"SiteMap_siteMapList__ocQUL","siteMapSeparator":"SiteMap_siteMapSeparator__8o8jB"};

/***/ }),

/***/ 72014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"SubscribeNow_hide-scrollbar__C66UL","about":"SubscribeNow_about__Ofu1T","footerImg":"SubscribeNow_footerImg___XGGt","subscribeForm":"SubscribeNow_subscribeForm__5cuW7"};

/***/ }),

/***/ 31878:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LazyMedia_spinner__WtNjI","spin":"LazyMedia_spin__Qdqzq"};

/***/ }),

/***/ 71763:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Shimmer_shimmer__lm2Yt","shimmer-slide":"Shimmer_shimmer-slide__3To9a"};

/***/ }),

/***/ 27842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Accordion_hide-scrollbar__D3DS1","accordion":"Accordion_accordion__xzIJe","accordion-item":"Accordion_accordion-item__QTpN8","accordion-header":"Accordion_accordion-header__jrwCj","accordion-title":"Accordion_accordion-title__SbLKx","accordion-body":"Accordion_accordion-body__prGxs","accordion-body--open":"Accordion_accordion-body--open__zr_hZ","accordion-content":"Accordion_accordion-content__hKChU","accordion--base":"Accordion_accordion--base__EeoqE","accordion-toggle":"Accordion_accordion-toggle__ypXcC","accordion-icon":"Accordion_accordion-icon__Rrbu_","accordion-icon--open":"Accordion_accordion-icon--open__gaGg9","accordion--card":"Accordion_accordion--card__36pgG","accordion-item--active":"Accordion_accordion-item--active__LCKIf"};

/***/ }),

/***/ 69354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"OnboardingWizard_pageWrapper__mvEsW","wizardHeader":"OnboardingWizard_wizardHeader__9vPbb","backButton":"OnboardingWizard_backButton__lAyDM","headerLogo":"OnboardingWizard_headerLogo__lck6_","closeButton":"OnboardingWizard_closeButton__2V4jr","stepTitle":"OnboardingWizard_stepTitle__0rnuu","stepIndicator":"OnboardingWizard_stepIndicator__dAeLK","wizardCard":"OnboardingWizard_wizardCard__I5APp","stepHeader":"OnboardingWizard_stepHeader__ZT0Ay","wizardBody":"OnboardingWizard_wizardBody__AEZ8z","stepOverlay":"OnboardingWizard_stepOverlay__mGQ0T","stepContent":"OnboardingWizard_stepContent__j6A9m","stepFadeIn":"OnboardingWizard_stepFadeIn__2n7cq","counsellorLoading":"OnboardingWizard_counsellorLoading__QA3qI","counsellorLoadingInner":"OnboardingWizard_counsellorLoadingInner__N_D4z","counsellorLoadingText":"OnboardingWizard_counsellorLoadingText__fNUqh","counsellorSpinner":"OnboardingWizard_counsellorSpinner__A0DbZ","spin":"OnboardingWizard_spin__gbpSY","mobileStepInfo":"OnboardingWizard_mobileStepInfo__U3_VZ","mobileStepTitle":"OnboardingWizard_mobileStepTitle__K4A2k","mobileStepIndicator":"OnboardingWizard_mobileStepIndicator__KDpXV"};

/***/ }),

/***/ 29789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"optionGrid":"OptionGrid_optionGrid__AQFp_","optionItem":"OptionGrid_optionItem__cOpdx","optionGridTall":"OptionGrid_optionGridTall__wH7lX","selected":"OptionGrid_selected__zikLr","degreeGrid":"OptionGrid_degreeGrid___79VA","optionLabel":"OptionGrid_optionLabel__nnyvS","noResults":"OptionGrid_noResults__BoFhb"};

/***/ }),

/***/ 88259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressFill":"ProgressBar_progressFill__TOHJn"};

/***/ }),

/***/ 12522:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"SearchInput_searchWrapper__A9C1e","sticky":"SearchInput_sticky__hznsA","searchIcon":"SearchInput_searchIcon__1M4qS","searchInput":"SearchInput_searchInput__FfT73"};

/***/ }),

/***/ 58386:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stepContent":"StepLayout_stepContent__4B_S7","topCities":"StepLayout_topCities__sViy2","topCitiesHeading":"StepLayout_topCitiesHeading__EUszF","topCitiesHelper":"StepLayout_topCitiesHelper__KdrML","topCitiesHelperStrong":"StepLayout_topCitiesHelperStrong__Ca7JQ"};

/***/ }),

/***/ 71726:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Header_main__D8kTM","navbar":"Header_navbar__Vtaem","kcLogo":"Header_kcLogo__r8eXe","forprtners":"Header_forprtners__I70Zj","megaMenu":"Header_megaMenu__NeKAD","cfActive":"Header_cfActive__Iy9Gh","onlineConActive":"Header_onlineConActive__9Mhzs","mobileCf":"Header_mobileCf__eidhX","mainMenu":"Header_mainMenu__HkffV","activeDiv":"Header_activeDiv__R8O8J","companyspan":"Header_companyspan__Zl4An","externalLinks":"Header_externalLinks__Y5BqL","btnMargin":"Header_btnMargin__GRlru","loginBtn":"Header_loginBtn__K0l_5","onlineCounselling":"Header_onlineCounselling__NJGFj","bookOnlineLink":"Header_bookOnlineLink__7HLV0","mobileMenu":"Header_mobileMenu__c0Poa","mobileOnlineCounselling":"Header_mobileOnlineCounselling__B2ATg","subMenu":"Header_subMenu__XGVtv","rowCenter":"Header_rowCenter__r_959","carrerlinkdiv":"Header_carrerlinkdiv__z_5vk","linksurl":"Header_linksurl__avm6G","ipad":"Header_ipad__cQBTt","hiring":"Header_hiring__EVcem","mobilGalaxy":"Header_mobilGalaxy__2ZYcf","flag":"Header_flag__OkKr8","studyDesti":"Header_studyDesti__5dSE_","flaginner":"Header_flaginner__Y3KKr","sublinksurl":"Header_sublinksurl__Lq3xt","mobileCompMenu":"Header_mobileCompMenu__NTppw","ipadmenu":"Header_ipadmenu__1oxIg","searchUniversity":"Header_searchUniversity__ha3o_","loader":"Header_loader__jOJ9C","spinner":"Header_spinner__iNQNa","termsClass":"Header_termsClass__PyG2D"};

/***/ }),

/***/ 80812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"StickyFooter_stickyFooter__GbQPU"};

/***/ }),

/***/ 76516:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 74831:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 35005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70861);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  as,
  bsPrefix,
  variant,
  size,
  active,
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = (0,_restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__/* .useButtonProps */ .FT)({
    tagName: as,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...buttonProps,
    ...props,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && props.disabled && 'disabled')
  });
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 31555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCol */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;

    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }

    const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{ ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 10682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  fluid: false
};
const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 53439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "XW": function() { return /* binding */ hasChildOfType; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */

function map(children, func) {
  let index = 0;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */


function forEach(children, func) {
  let index = 0;
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(children, child => {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) func(child, index++);
  });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */


function hasChildOfType(children, type) {
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).some(child => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && child.type === type);
}



/***/ }),

/***/ 41068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23594);
/* harmony import */ var _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93825);
/* harmony import */ var _triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34509);
/* harmony import */ var _TransitionWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9337);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
const fadeStyles = {
  [react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERING */ .d0]: 'show',
  [react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERED */ .cn]: 'show'
};
const Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  className,
  children,
  transitionClasses = {},
  ...props
}, ref) => {
  const handleEnter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((node, isAppearing) => {
    (0,_triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(node);
    props.onEnter == null ? void 0 : props.onEnter(node, isAppearing);
  }, [props]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TransitionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    ref: ref,
    addEndListener: _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    ...props,
    onEnter: handleEnter,
    childRef: children.ref,
    children: (status, innerProps) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, { ...innerProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
    })
  });
});
Fade.defaultProps = defaultProps;
Fade.displayName = 'Fade';
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 97346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Form; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Feedback.js




const propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: (prop_types_default()).string,

  /** Display feedback as a tooltip. */
  tooltip: (prop_types_default()).bool,
  as: (prop_types_default()).elementType
};
const Feedback = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  as: Component = 'div',
  className,
  type = 'valid',
  tooltip = false,
  ...props
}, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
  ref: ref,
  className: classnames_default()(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
}));
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
/* harmony default export */ var esm_Feedback = (Feedback);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormContext.js
 // TODO

const FormContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var esm_FormContext = (FormContext);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheckInput.js






const FormCheckInput = /*#__PURE__*/react.forwardRef(({
  id,
  bsPrefix,
  className,
  type = 'checkbox',
  isValid = false,
  isInvalid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-check-input');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ref: ref,
    type: type,
    id: id || controlId,
    className: classnames_default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  });
});
FormCheckInput.displayName = 'FormCheckInput';
/* harmony default export */ var esm_FormCheckInput = (FormCheckInput);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheckLabel.js






const FormCheckLabel = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  htmlFor,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-check-label');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("label", { ...props,
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classnames_default()(className, bsPrefix)
  });
});
FormCheckLabel.displayName = 'FormCheckLabel';
/* harmony default export */ var esm_FormCheckLabel = (FormCheckLabel);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ElementChildren.js
var ElementChildren = __webpack_require__(53439);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormCheck.js












const FormCheck = /*#__PURE__*/react.forwardRef(({
  id,
  bsPrefix,
  bsSwitchPrefix,
  inline = false,
  disabled = false,
  isValid = false,
  isInvalid = false,
  feedbackTooltip = false,
  feedback,
  feedbackType,
  className,
  style,
  title = '',
  type = 'checkbox',
  label,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as = 'input',
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-check');
  bsSwitchPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsSwitchPrefix, 'form-switch');
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  const innerFormContext = (0,react.useMemo)(() => ({
    controlId: id || controlId
  }), [controlId, id]);
  const hasLabel = !children && label != null && label !== false || (0,ElementChildren/* hasChildOfType */.XW)(children, esm_FormCheckLabel);

  const input = /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormCheckInput, { ...props,
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: as
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormContext.Provider, {
    value: innerFormContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: style,
      className: classnames_default()(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, type === 'switch' && bsSwitchPrefix),
      children: children || /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [input, hasLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormCheckLabel, {
          title: title,
          children: label
        }), feedback && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Feedback, {
          type: feedbackType,
          tooltip: feedbackTooltip,
          children: feedback
        })]
      })
    })
  });
});
FormCheck.displayName = 'FormCheck';
/* harmony default export */ var esm_FormCheck = (Object.assign(FormCheck, {
  Input: esm_FormCheckInput,
  Label: esm_FormCheckLabel
}));
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormControl.js








const FormControl = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  type,
  size,
  htmlSize,
  id,
  className,
  isValid = false,
  isInvalid = false,
  plaintext,
  readOnly,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-control');
  let classes;

  if (plaintext) {
    classes = {
      [`${bsPrefix}-plaintext`]: true
    };
  } else {
    classes = {
      [bsPrefix]: true,
      [`${bsPrefix}-${size}`]: size
    };
  }

   false ? 0 : void 0;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classnames_default()(className, classes, isValid && `is-valid`, isInvalid && `is-invalid`, type === 'color' && `${bsPrefix}-color`)
  });
});
FormControl.displayName = 'FormControl';
/* harmony default export */ var esm_FormControl = (Object.assign(FormControl, {
  Feedback: esm_Feedback
}));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormFloating.js

/* harmony default export */ var FormFloating = ((0,createWithBsPrefix/* default */.Z)('form-floating'));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormGroup.js




const FormGroup = /*#__PURE__*/react.forwardRef(({
  controlId,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const context = (0,react.useMemo)(() => ({
    controlId
  }), [controlId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormContext.Provider, {
    value: context,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
      ref: ref
    })
  });
});
FormGroup.displayName = 'FormGroup';
/* harmony default export */ var esm_FormGroup = (FormGroup);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormLabel.js








const defaultProps = {
  column: false,
  visuallyHidden: false
};
const FormLabel = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'label',
  bsPrefix,
  column,
  visuallyHidden,
  className,
  htmlFor,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-label');
  let columnClass = 'col-form-label';
  if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
  const classes = classnames_default()(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
   false ? 0 : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
    ref: ref,
    as: "label",
    className: classes,
    htmlFor: htmlFor,
    ...props
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0,jsx_runtime.jsx)(Component, {
      ref: ref,
      className: classes,
      htmlFor: htmlFor,
      ...props
    })
  );
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = defaultProps;
/* harmony default export */ var esm_FormLabel = (FormLabel);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormRange.js






const FormRange = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  id,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-range');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("input", { ...props,
    type: "range",
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    id: id || controlId
  });
});
FormRange.displayName = 'FormRange';
/* harmony default export */ var esm_FormRange = (FormRange);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormSelect.js






const FormSelect = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  size,
  htmlSize,
  className,
  isValid = false,
  isInvalid = false,
  id,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-select');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("select", { ...props,
    size: htmlSize,
    ref: ref,
    className: classnames_default()(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
    id: id || controlId
  });
});
FormSelect.displayName = 'FormSelect';
/* harmony default export */ var esm_FormSelect = (FormSelect);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FormText.js




const FormText = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  as: Component = 'small',
  muted,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-text');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ref: ref,
    className: classnames_default()(className, bsPrefix, muted && 'text-muted')
  });
});
FormText.displayName = 'FormText';
/* harmony default export */ var esm_FormText = (FormText);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Switch.js



const Switch = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormCheck, { ...props,
  ref: ref,
  type: "switch"
}));
Switch.displayName = 'Switch';
/* harmony default export */ var esm_Switch = (Object.assign(Switch, {
  Input: esm_FormCheck.Input,
  Label: esm_FormCheck.Label
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/FloatingLabel.js






const FloatingLabel = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  children,
  controlId,
  label,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-floating');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(esm_FormGroup, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    controlId: controlId,
    ...props,
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: controlId,
      children: label
    })]
  });
});
FloatingLabel.displayName = 'FloatingLabel';
/* harmony default export */ var esm_FloatingLabel = (FloatingLabel);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Form.js














const Form_propTypes = {
  /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */
  _ref: (prop_types_default()).any,

  /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */
  validated: (prop_types_default()).bool,
  as: (prop_types_default()).elementType
};
const Form = /*#__PURE__*/react.forwardRef(({
  className,
  validated,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'form',
  ...props
}, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
  ref: ref,
  className: classnames_default()(className, validated && 'was-validated')
}));
Form.displayName = 'Form';
Form.propTypes = Form_propTypes;
/* harmony default export */ var esm_Form = (Object.assign(Form, {
  Group: esm_FormGroup,
  Control: esm_FormControl,
  Floating: FormFloating,
  Check: esm_FormCheck,
  Switch: esm_Switch,
  Label: esm_FormLabel,
  Text: esm_FormText,
  Range: esm_FormRange,
  Select: esm_FormSelect,
  FloatingLabel: esm_FloatingLabel
}));

/***/ }),

/***/ 13540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ react_bootstrap_esm_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/addEventListener.js
var addEventListener = __webpack_require__(9351);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
var canUseDOM = __webpack_require__(23004);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(67216);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/removeEventListener.js
var removeEventListener = __webpack_require__(30099);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM/* default */.Z) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(32092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(78146);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(35654);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useUpdatedRef.js

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */

function useUpdatedRef(value) {
  var valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js


/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */

function useWillUnmount(fn) {
  var onUnmount = useUpdatedRef(fn);
  (0,react.useEffect)(function () {
    return function () {
      return onUnmount.current();
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/transitionEnd.js + 1 modules
var transitionEnd = __webpack_require__(94305);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/activeElement.js

/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0,ownerDocument/* default */.Z)();
  }

  // Support: IE 9 only
  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
  try {
    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
    // document.activeElement from an <iframe>

    if (!active || !active.nodeName) return null;
    return active;
  } catch (e) {
    /* ie throws if no active element */
    return doc.body;
  }
}
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(90424);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(72950);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(88833);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/DataKey.js
var DataKey = __webpack_require__(52747);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/getScrollbarWidth.js
/**
 * Get the width of the vertical window scrollbar if it's visible
 */
function getBodyScrollbarWidth(ownerDocument = document) {
  const window = ownerDocument.defaultView;
  return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/ModalManager.js



const OPEN_DATA_ATTRIBUTE = (0,DataKey/* dataAttr */.PB)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */

class ModalManager {
  constructor({
    ownerDocument,
    handleContainerOverflow = true,
    isRTL = false
  } = {}) {
    this.handleContainerOverflow = handleContainerOverflow;
    this.isRTL = isRTL;
    this.modals = [];
    this.ownerDocument = ownerDocument;
  }

  getScrollbarWidth() {
    return getBodyScrollbarWidth(this.ownerDocument);
  }

  getElement() {
    return (this.ownerDocument || document).body;
  }

  setModalAttributes(_modal) {// For overriding
  }

  removeModalAttributes(_modal) {// For overriding
  }

  setContainerStyle(containerState) {
    const style = {
      overflow: 'hidden'
    }; // we are only interested in the actual `style` here
    // because we will override it

    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const container = this.getElement();
    containerState.style = {
      overflow: container.style.overflow,
      [paddingProp]: container.style[paddingProp]
    };

    if (containerState.scrollBarWidth) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style[paddingProp] = `${parseInt((0,css/* default */.Z)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
    }

    container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
    (0,css/* default */.Z)(container, style);
  }

  reset() {
    [...this.modals].forEach(m => this.remove(m));
  }

  removeContainerStyle(containerState) {
    const container = this.getElement();
    container.removeAttribute(OPEN_DATA_ATTRIBUTE);
    Object.assign(container.style, containerState.style);
  }

  add(modal) {
    let modalIdx = this.modals.indexOf(modal);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = this.modals.length;
    this.modals.push(modal);
    this.setModalAttributes(modal);

    if (modalIdx !== 0) {
      return modalIdx;
    }

    this.state = {
      scrollBarWidth: this.getScrollbarWidth(),
      style: {}
    };

    if (this.handleContainerOverflow) {
      this.setContainerStyle(this.state);
    }

    return modalIdx;
  }

  remove(modal) {
    const modalIdx = this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
    // clean up the container

    if (!this.modals.length && this.handleContainerOverflow) {
      this.removeContainerStyle(this.state);
    }

    this.removeModalAttributes(modal);
  }

  isTopModal(modal) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
  }

}

/* harmony default export */ var esm_ModalManager = (ModalManager);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/useWaitForDOMRef.js
var useWaitForDOMRef = __webpack_require__(54194);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/useWindow.js
var useWindow = __webpack_require__(12963);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Modal.js
const _excluded = ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "backdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */

















let manager;

function getManager(window) {
  if (!manager) manager = new esm_ModalManager({
    ownerDocument: window == null ? void 0 : window.document
  });
  return manager;
}

function useModalManager(provided) {
  const window = (0,useWindow/* default */.Z)();
  const modalManager = provided || getManager(window);
  const modal = (0,react.useRef)({
    dialog: null,
    backdrop: null
  });
  return Object.assign(modal.current, {
    add: () => modalManager.add(modal.current),
    remove: () => modalManager.remove(modal.current),
    isTopModal: () => modalManager.isTopModal(modal.current),
    setDialogRef: (0,react.useCallback)(ref => {
      modal.current.dialog = ref;
    }, []),
    setBackdropRef: (0,react.useCallback)(ref => {
      modal.current.backdrop = ref;
    }, [])
  });
}

const Modal = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    show = false,
    role = 'dialog',
    className,
    style,
    children,
    backdrop = true,
    keyboard = true,
    onBackdropClick,
    onEscapeKeyDown,
    transition,
    backdropTransition,
    autoFocus = true,
    enforceFocus = true,
    restoreFocus = true,
    restoreFocusOptions,
    renderDialog,
    renderBackdrop = props => /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, props)),
    manager: providedManager,
    container: containerRef,
    onShow,
    onHide = () => {},
    onExit,
    onExited,
    onExiting,
    onEnter,
    onEntering,
    onEntered
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const container = (0,useWaitForDOMRef/* default */.Z)(containerRef);
  const modal = useModalManager(providedManager);
  const isMounted = (0,useMounted/* default */.Z)();
  const prevShow = (0,usePrevious/* default */.Z)(show);
  const [exited, setExited] = (0,react.useState)(!show);
  const lastFocusRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, () => modal, [modal]);

  if (canUseDOM/* default */.Z && !prevShow && show) {
    lastFocusRef.current = activeElement();
  }

  if (!transition && !show && !exited) {
    setExited(true);
  } else if (show && exited) {
    setExited(false);
  }

  const handleShow = (0,useEventCallback/* default */.Z)(() => {
    modal.add();
    removeKeydownListenerRef.current = (0,listen/* default */.Z)(document, 'keydown', handleDocumentKeyDown);
    removeFocusListenerRef.current = (0,listen/* default */.Z)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
    // and so steals focus from it
    () => setTimeout(handleEnforceFocus), true);

    if (onShow) {
      onShow();
    } // autofocus after onShow to not trigger a focus event for previous
    // modals before this one is shown.


    if (autoFocus) {
      const currentActiveElement = activeElement(document);

      if (modal.dialog && currentActiveElement && !(0,contains/* default */.Z)(modal.dialog, currentActiveElement)) {
        lastFocusRef.current = currentActiveElement;
        modal.dialog.focus();
      }
    }
  });
  const handleHide = (0,useEventCallback/* default */.Z)(() => {
    modal.remove();
    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();

    if (restoreFocus) {
      var _lastFocusRef$current;

      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
      lastFocusRef.current = null;
    }
  }); // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
  // Show logic when:
  //  - show is `true` _and_ `container` has resolved

  (0,react.useEffect)(() => {
    if (!show || !container) return;
    handleShow();
  }, [show, container,
  /* should never change: */
  handleShow]); // Hide cleanup logic when:
  //  - `exited` switches to true
  //  - component unmounts;

  (0,react.useEffect)(() => {
    if (!exited) return;
    handleHide();
  }, [exited, handleHide]);
  useWillUnmount(() => {
    handleHide();
  }); // --------------------------------

  const handleEnforceFocus = (0,useEventCallback/* default */.Z)(() => {
    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
      return;
    }

    const currentActiveElement = activeElement();

    if (modal.dialog && currentActiveElement && !(0,contains/* default */.Z)(modal.dialog, currentActiveElement)) {
      modal.dialog.focus();
    }
  });
  const handleBackdropClick = (0,useEventCallback/* default */.Z)(e => {
    if (e.target !== e.currentTarget) {
      return;
    }

    onBackdropClick == null ? void 0 : onBackdropClick(e);

    if (backdrop === true) {
      onHide();
    }
  });
  const handleDocumentKeyDown = (0,useEventCallback/* default */.Z)(e => {
    if (keyboard && e.keyCode === 27 && modal.isTopModal()) {
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);

      if (!e.defaultPrevented) {
        onHide();
      }
    }
  });
  const removeFocusListenerRef = (0,react.useRef)();
  const removeKeydownListenerRef = (0,react.useRef)();

  const handleHidden = (...args) => {
    setExited(true);
    onExited == null ? void 0 : onExited(...args);
  };

  const Transition = transition;

  if (!container || !(show || Transition && !exited)) {
    return null;
  }

  const dialogProps = Object.assign({
    role,
    ref: modal.setDialogRef,
    // apparently only works on the dialog role element
    'aria-modal': role === 'dialog' ? true : undefined
  }, rest, {
    style,
    className,
    tabIndex: -1
  });
  let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, dialogProps, {
    children: /*#__PURE__*/react.cloneElement(children, {
      role: 'document'
    })
  }));

  if (Transition) {
    dialog = /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
      appear: true,
      unmountOnExit: true,
      in: !!show,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      children: dialog
    });
  }

  let backdropElement = null;

  if (backdrop) {
    const BackdropTransition = backdropTransition;
    backdropElement = renderBackdrop({
      ref: modal.setBackdropRef,
      onClick: handleBackdropClick
    });

    if (BackdropTransition) {
      backdropElement = /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropTransition, {
        appear: true,
        in: !!show,
        children: backdropElement
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [backdropElement, dialog]
    }), container)
  });
});
Modal.displayName = 'Modal';
/* harmony default export */ var esm_Modal = (Object.assign(Modal, {
  Manager: esm_ModalManager
}));
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/hasClass.js
var hasClass = __webpack_require__(11132);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0,hasClass/* default */.Z)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/querySelectorAll.js
var querySelectorAll = __webpack_require__(60930);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BootstrapModalManager.js





const Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};

class BootstrapModalManager extends esm_ModalManager {
  adjustAndStore(prop, element, adjust) {
    const actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
    // @ts-ignore

    element.dataset[prop] = actual;
    (0,css/* default */.Z)(element, {
      [prop]: `${parseFloat((0,css/* default */.Z)(element, prop)) + adjust}px`
    });
  }

  restore(prop, element) {
    const value = element.dataset[prop];

    if (value !== undefined) {
      delete element.dataset[prop];
      (0,css/* default */.Z)(element, {
        [prop]: value
      });
    }
  }

  setContainerStyle(containerState) {
    super.setContainerStyle(containerState);
    const container = this.getElement();
    addClass(container, 'modal-open');
    if (!containerState.scrollBarWidth) return;
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    (0,querySelectorAll/* default */.Z)(container, Selector.FIXED_CONTENT).forEach(el => this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
    (0,querySelectorAll/* default */.Z)(container, Selector.STICKY_CONTENT).forEach(el => this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
    (0,querySelectorAll/* default */.Z)(container, Selector.NAVBAR_TOGGLER).forEach(el => this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
  }

  removeContainerStyle(containerState) {
    super.removeContainerStyle(containerState);
    const container = this.getElement();
    removeClass(container, 'modal-open');
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    (0,querySelectorAll/* default */.Z)(container, Selector.FIXED_CONTENT).forEach(el => this.restore(paddingProp, el));
    (0,querySelectorAll/* default */.Z)(container, Selector.STICKY_CONTENT).forEach(el => this.restore(marginProp, el));
    (0,querySelectorAll/* default */.Z)(container, Selector.NAVBAR_TOGGLER).forEach(el => this.restore(marginProp, el));
  }

}

let sharedManager;
function getSharedManager(options) {
  if (!sharedManager) sharedManager = new BootstrapModalManager(options);
  return sharedManager;
}
/* harmony default export */ var esm_BootstrapModalManager = ((/* unused pure expression or super */ null && (BootstrapModalManager)));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(41068);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalBody.js

/* harmony default export */ var ModalBody = ((0,createWithBsPrefix/* default */.Z)('modal-body'));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalContext.js

const ModalContext = /*#__PURE__*/react.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide() {}

});
/* harmony default export */ var esm_ModalContext = (ModalContext);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalDialog.js




const ModalDialog = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  contentClassName,
  centered,
  size,
  fullscreen,
  children,
  scrollable,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  const dialogClass = `${bsPrefix}-dialog`;
  const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...props,
    ref: ref,
    className: classnames_default()(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(`${bsPrefix}-content`, contentClassName),
      children: children
    })
  });
});
ModalDialog.displayName = 'ModalDialog';
/* harmony default export */ var esm_ModalDialog = (ModalDialog);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalFooter.js

/* harmony default export */ var ModalFooter = ((0,createWithBsPrefix/* default */.Z)('modal-footer'));
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CloseButton.js




const propTypes = {
  'aria-label': (prop_types_default()).string,
  onClick: (prop_types_default()).func,

  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: prop_types_default().oneOf(['white'])
};
const defaultProps = {
  'aria-label': 'Close'
};
const CloseButton = /*#__PURE__*/react.forwardRef(({
  className,
  variant,
  ...props
}, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
  ref: ref,
  type: "button",
  className: classnames_default()('btn-close', variant && `btn-close-${variant}`, className),
  ...props
}));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ var esm_CloseButton = (CloseButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AbstractModalHeader.js







const AbstractModalHeader_defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
const AbstractModalHeader = /*#__PURE__*/react.forwardRef(({
  closeLabel,
  closeVariant,
  closeButton,
  onHide,
  children,
  ...props
}, ref) => {
  const context = (0,react.useContext)(esm_ModalContext);
  const handleClick = (0,useEventCallback/* default */.Z)(() => {
    context == null ? void 0 : context.onHide();
    onHide == null ? void 0 : onHide();
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    ...props,
    children: [children, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_CloseButton, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick
    })]
  });
});
AbstractModalHeader.defaultProps = AbstractModalHeader_defaultProps;
/* harmony default export */ var esm_AbstractModalHeader = (AbstractModalHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalHeader.js





const ModalHeader_defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
const ModalHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AbstractModalHeader, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix)
  });
});
ModalHeader.displayName = 'ModalHeader';
ModalHeader.defaultProps = ModalHeader_defaultProps;
/* harmony default export */ var esm_ModalHeader = (ModalHeader);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalTitle.js


const DivStyledAsH4 = (0,divWithClassName/* default */.Z)('h4');
/* harmony default export */ var ModalTitle = ((0,createWithBsPrefix/* default */.Z)('modal-title', {
  Component: DivStyledAsH4
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Modal.js
























const Modal_defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  animation: true,
  dialogAs: esm_ModalDialog
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
    timeout: null
  });
}

function BackdropTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
    timeout: null
  });
}
/* eslint-enable no-use-before-define */


const Modal_Modal = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  style,
  dialogClassName,
  contentClassName,
  children,
  dialogAs: Dialog,
  'aria-labelledby': ariaLabelledby,
  'aria-describedby': ariaDescribedby,
  'aria-label': ariaLabel,

  /* BaseModal props */
  show,
  animation,
  backdrop,
  keyboard,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus,
  enforceFocus,
  restoreFocus,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  ...props
}, ref) => {
  const [modalStyle, setStyle] = (0,react.useState)({});
  const [animateStaticModal, setAnimateStaticModal] = (0,react.useState)(false);
  const waitingForMouseUpRef = (0,react.useRef)(false);
  const ignoreBackdropClickRef = (0,react.useRef)(false);
  const removeStaticModalAnimationRef = (0,react.useRef)(null);
  const [modal, setModalRef] = (0,useCallbackRef/* default */.Z)();
  const mergedRef = (0,useMergedRefs/* default */.Z)(ref, setModalRef);
  const handleHide = (0,useEventCallback/* default */.Z)(onHide);
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  const modalContext = (0,react.useMemo)(() => ({
    onHide: handleHide
  }), [handleHide]);

  function getModalManager() {
    if (propsManager) return propsManager;
    return getSharedManager({
      isRTL
    });
  }

  function updateDialogStyle(node) {
    if (!canUseDOM/* default */.Z) return;
    const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
    const modalIsOverflowing = node.scrollHeight > (0,ownerDocument/* default */.Z)(node).documentElement.clientHeight;
    setStyle({
      paddingRight: containerIsOverflowing && !modalIsOverflowing ? scrollbarSize() : undefined,
      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? scrollbarSize() : undefined
    });
  }

  const handleWindowResize = (0,useEventCallback/* default */.Z)(() => {
    if (modal) {
      updateDialogStyle(modal.dialog);
    }
  });
  useWillUnmount(() => {
    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);
    removeStaticModalAnimationRef.current == null ? void 0 : removeStaticModalAnimationRef.current();
  }); // We prevent the modal from closing during a drag by detecting where the
  // the click originates from. If it starts in the modal and then ends outside
  // don't close.

  const handleDialogMouseDown = () => {
    waitingForMouseUpRef.current = true;
  };

  const handleMouseUp = e => {
    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
      ignoreBackdropClickRef.current = true;
    }

    waitingForMouseUpRef.current = false;
  };

  const handleStaticModalAnimation = () => {
    setAnimateStaticModal(true);
    removeStaticModalAnimationRef.current = (0,transitionEnd/* default */.Z)(modal.dialog, () => {
      setAnimateStaticModal(false);
    });
  };

  const handleStaticBackdropClick = e => {
    if (e.target !== e.currentTarget) {
      return;
    }

    handleStaticModalAnimation();
  };

  const handleClick = e => {
    if (backdrop === 'static') {
      handleStaticBackdropClick(e);
      return;
    }

    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
      ignoreBackdropClickRef.current = false;
      return;
    }

    onHide == null ? void 0 : onHide();
  };

  const handleEscapeKeyDown = e => {
    if (!keyboard && backdrop === 'static') {
      // Call preventDefault to stop modal from closing in restart ui,
      // then play our animation.
      e.preventDefault();
      handleStaticModalAnimation();
    } else if (keyboard && onEscapeKeyDown) {
      onEscapeKeyDown(e);
    }
  };

  const handleEnter = (node, isAppearing) => {
    if (node) {
      updateDialogStyle(node);
    }

    onEnter == null ? void 0 : onEnter(node, isAppearing);
  };

  const handleExit = node => {
    removeStaticModalAnimationRef.current == null ? void 0 : removeStaticModalAnimationRef.current();
    onExit == null ? void 0 : onExit(node);
  };

  const handleEntering = (node, isAppearing) => {
    onEntering == null ? void 0 : onEntering(node, isAppearing); // FIXME: This should work even when animation is disabled.

    (0,addEventListener/* default */.ZP)(window, 'resize', handleWindowResize);
  };

  const handleExited = node => {
    if (node) node.style.display = ''; // RHL removes it sometimes

    onExited == null ? void 0 : onExited(node); // FIXME: This should work even when animation is disabled.

    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);
  };

  const renderBackdrop = (0,react.useCallback)(backdropProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...backdropProps,
    className: classnames_default()(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
  }), [animation, backdropClassName, bsPrefix]);
  const baseModalStyle = { ...style,
    ...modalStyle
  }; // If `display` is not set to block, autoFocus inside the modal fails
  // https://github.com/react-bootstrap/react-bootstrap/issues/5102

  baseModalStyle.display = 'block';

  const renderDialog = dialogProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "dialog",
    ...dialogProps,
    style: baseModalStyle,
    className: classnames_default()(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`),
    onClick: backdrop ? handleClick : undefined,
    onMouseUp: handleMouseUp,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog, { ...props,
      onMouseDown: handleDialogMouseDown,
      className: dialogClassName,
      contentClassName: contentClassName,
      children: children
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ModalContext.Provider, {
    value: modalContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Modal, {
      show: show,
      ref: mergedRef,
      backdrop: backdrop,
      container: container,
      keyboard: true // Always set true - see handleEscapeKeyDown
      ,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      restoreFocusOptions: restoreFocusOptions,
      onEscapeKeyDown: handleEscapeKeyDown,
      onShow: onShow,
      onHide: onHide,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: onEntered,
      onExit: handleExit,
      onExiting: onExiting,
      onExited: handleExited,
      manager: getModalManager(),
      transition: animation ? DialogTransition : undefined,
      backdropTransition: animation ? BackdropTransition : undefined,
      renderBackdrop: renderBackdrop,
      renderDialog: renderDialog
    })
  });
});
Modal_Modal.displayName = 'Modal';
Modal_Modal.defaultProps = Modal_defaultProps;
/* harmony default export */ var react_bootstrap_esm_Modal = (Object.assign(Modal_Modal, {
  Body: ModalBody,
  Header: esm_ModalHeader,
  Title: ModalTitle,
  Footer: ModalFooter,
  Dialog: esm_ModalDialog,
  TRANSITION_DURATION: 300,
  BACKDROP_TRANSITION_DURATION: 150
}));

/***/ }),

/***/ 34051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;

    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }

    const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 76792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ useIsRTL; },
/* harmony export */   "pi": function() { return /* binding */ useBootstrapBreakpoints; },
/* harmony export */   "vE": function() { return /* binding */ useBootstrapPrefix; }
/* harmony export */ });
/* unused harmony exports DEFAULT_BREAKPOINTS, createBootstrapComponent, ThemeConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS
});
const {
  Consumer,
  Provider
} = ThemeContext;

function ThemeProvider({
  prefixes = {},
  breakpoints = DEFAULT_BREAKPOINTS,
  dir,
  children
}) {
  const contextValue = useMemo(() => ({
    prefixes: { ...prefixes
    },
    breakpoints,
    dir
  }), [prefixes, breakpoints, dir]);
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
}

function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return breakpoints;
}
function useIsRTL() {
  const {
    dir
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return dir === 'rtl';
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  const {
    prefix,
    forwardRefAs = isClassy ? 'ref' : 'innerRef'
  } = opts;
  const Wrapped = /*#__PURE__*/React.forwardRef(({ ...props
  }, ref) => {
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Component, { ...props,
      bsPrefix: bsPrefix
    });
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ThemeProvider)));

/***/ }),

/***/ 9337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23594);
/* harmony import */ var _restart_hooks_useMergedRefs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35654);
/* harmony import */ var _safeFindDOMNode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8285);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
  addEndListener,
  children,
  childRef,
  ...props
}, ref) => {
  const nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const mergedRef = (0,_restart_hooks_useMergedRefs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(nodeRef, childRef);

  const attachRef = r => {
    mergedRef((0,_safeFindDOMNode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(r));
  };

  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */


  const handleEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onEnter), [onEnter]);
  const handleEntering = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onEntering), [onEntering]);
  const handleEntered = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onEntered), [onEntered]);
  const handleExit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onExit), [onExit]);
  const handleExiting = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onExiting), [onExiting]);
  const handleExited = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onExited), [onExited]);
  const handleAddEndListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(addEndListener), [addEndListener]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
    ref: ref,
    ...props,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    children: typeof children === 'function' ? (status, innerProps) => children(status, { ...innerProps,
      ref: attachRef
    }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
      ref: attachRef
    })
  });
});
/* harmony default export */ __webpack_exports__["Z"] = (TransitionWrapper);

/***/ }),

/***/ 66611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createWithBsPrefix; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/camelize.js
var rHyphen = /-(.)/g;
function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js






const pascalCase = str => str[0].toUpperCase() + camelize(str).slice(1);

// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
function createWithBsPrefix(prefix, {
  displayName = pascalCase(prefix),
  Component,
  defaultProps
} = {}) {
  const BsComponent = /*#__PURE__*/react.forwardRef(({
    className,
    bsPrefix,
    as: Tag = Component || 'div',
    ...props
  }, ref) => {
    const resolvedPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, prefix);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
      ref: ref,
      className: classnames_default()(className, resolvedPrefix),
      ...props
    });
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}

/***/ }),

/***/ 39602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



/* harmony default export */ __webpack_exports__["Z"] = (className => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((p, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", { ...p,
  ref: ref,
  className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(p.className, className)
})));

/***/ }),

/***/ 8285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ safeFindDOMNode; }
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73935);

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return react_dom__WEBPACK_IMPORTED_MODULE_0__.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}

/***/ }),

/***/ 93825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ transitionEndListener; }
/* harmony export */ });
/* harmony import */ var dom_helpers_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91505);
/* harmony import */ var dom_helpers_transitionEnd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94305);



function parseDuration(node, property) {
  const str = (0,dom_helpers_css__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node, property) || '';
  const mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function transitionEndListener(element, handler) {
  const duration = parseDuration(element, 'transitionDuration');
  const delay = parseDuration(element, 'transitionDelay');
  const remove = (0,dom_helpers_transitionEnd__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element, e => {
    if (e.target === element) {
      remove();
      handler(e);
    }
  }, duration + delay);
}

/***/ }),

/***/ 34509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ triggerBrowserReflow; }
/* harmony export */ });
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight;
}

/***/ }),

/***/ 44036:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 72679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(()=>{var e={296:(e,t,r)=>{var o=/^\s+|\s+$/g,n=/^[-+]0x[0-9a-f]+$/i,i=/^0b[01]+$/i,s=/^0o[0-7]+$/i,c=parseInt,u="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,l="object"==typeof self&&self&&self.Object===Object&&self,a=u||l||Function("return this")(),f=Object.prototype.toString,p=Math.max,y=Math.min,d=function(){return a.Date.now()};function b(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function h(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&"[object Symbol]"==f.call(e)}(e))return NaN;if(b(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=b(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(o,"");var r=i.test(e);return r||s.test(e)?c(e.slice(2),r?2:8):n.test(e)?NaN:+e}e.exports=function(e,t,r){var o,n,i,s,c,u,l=0,a=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function m(t){var r=o,i=n;return o=n=void 0,l=t,s=e.apply(i,r)}function O(e){return l=e,c=setTimeout(g,t),a?m(e):s}function w(e){var r=e-u;return void 0===u||r>=t||r<0||f&&e-l>=i}function g(){var e=d();if(w(e))return P(e);c=setTimeout(g,function(e){var r=t-(e-u);return f?y(r,i-(e-l)):r}(e))}function P(e){return c=void 0,v&&o?m(e):(o=n=void 0,s)}function T(){var e=d(),r=w(e);if(o=arguments,n=this,u=e,r){if(void 0===c)return O(u);if(f)return c=setTimeout(g,t),m(u)}return void 0===c&&(c=setTimeout(g,t)),s}return t=h(t)||0,b(r)&&(a=!!r.leading,i=(f="maxWait"in r)?p(h(r.maxWait)||0,t):i,v="trailing"in r?!!r.trailing:v),T.cancel=function(){void 0!==c&&clearTimeout(c),l=0,o=u=n=c=void 0},T.flush=function(){return void 0===c?s:P(d())},T}},96:(e,t,r)=>{var o="Expected a function",n=/^\s+|\s+$/g,i=/^[-+]0x[0-9a-f]+$/i,s=/^0b[01]+$/i,c=/^0o[0-7]+$/i,u=parseInt,l="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,a="object"==typeof self&&self&&self.Object===Object&&self,f=l||a||Function("return this")(),p=Object.prototype.toString,y=Math.max,d=Math.min,b=function(){return f.Date.now()};function h(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function v(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&"[object Symbol]"==p.call(e)}(e))return NaN;if(h(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=h(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(n,"");var r=s.test(e);return r||c.test(e)?u(e.slice(2),r?2:8):i.test(e)?NaN:+e}e.exports=function(e,t,r){var n=!0,i=!0;if("function"!=typeof e)throw new TypeError(o);return h(r)&&(n="leading"in r?!!r.leading:n,i="trailing"in r?!!r.trailing:i),function(e,t,r){var n,i,s,c,u,l,a=0,f=!1,p=!1,m=!0;if("function"!=typeof e)throw new TypeError(o);function O(t){var r=n,o=i;return n=i=void 0,a=t,c=e.apply(o,r)}function w(e){return a=e,u=setTimeout(P,t),f?O(e):c}function g(e){var r=e-l;return void 0===l||r>=t||r<0||p&&e-a>=s}function P(){var e=b();if(g(e))return T(e);u=setTimeout(P,function(e){var r=t-(e-l);return p?d(r,s-(e-a)):r}(e))}function T(e){return u=void 0,m&&n?O(e):(n=i=void 0,c)}function j(){var e=b(),r=g(e);if(n=arguments,i=this,l=e,r){if(void 0===u)return w(l);if(p)return u=setTimeout(P,t),O(l)}return void 0===u&&(u=setTimeout(P,t)),c}return t=v(t)||0,h(r)&&(f=!!r.leading,s=(p="maxWait"in r)?y(v(r.maxWait)||0,t):s,m="trailing"in r?!!r.trailing:m),j.cancel=function(){void 0!==u&&clearTimeout(u),a=0,n=l=i=u=void 0},j.flush=function(){return void 0===u?c:T(b())},j}(e,t,{leading:n,maxWait:t,trailing:i})}},703:(e,t,r)=>{"use strict";var o=r(414);function n(){}function i(){}i.resetWarningCache=n,e.exports=function(){function e(e,t,r,n,i,s){if(s!==o){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:n};return r.PropTypes=r,r}},697:(e,t,r)=>{e.exports=r(703)()},414:e=>{"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}},t={};function r(o){var n=t[o];if(void 0!==n)return n.exports;var i=t[o]={exports:{}};return e[o](i,i.exports,r),i.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};(()=>{"use strict";r.r(o),r.d(o,{LazyLoadComponent:()=>J,LazyLoadImage:()=>ie,trackWindowScroll:()=>C});const e=__webpack_require__(67294);var t=r.n(e),n=r(697);const i=__webpack_require__(73935);var s=r.n(i);function c(){return"undefined"!=typeof window&&"IntersectionObserver"in window&&"isIntersecting"in window.IntersectionObserverEntry.prototype}function u(e){return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,o)}return r}function a(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function f(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function p(e,t){return(p=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function y(e,t){if(t&&("object"===u(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var b=function(e){e.forEach((function(e){e.isIntersecting&&e.target.onVisible()}))},h={},v=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&p(e,t)}(v,e);var r,o,n,i,u=(n=v,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=d(n);if(i){var r=d(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return y(this,e)});function v(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,v),(t=u.call(this,e)).supportsObserver=!e.scrollPosition&&e.useIntersectionObserver&&c(),t.supportsObserver){var r=e.threshold;t.observer=function(e){return h[e]=h[e]||new IntersectionObserver(b,{rootMargin:e+"px"}),h[e]}(r)}return t}return r=v,(o=[{key:"componentDidMount",value:function(){this.placeholder&&this.observer&&(this.placeholder.onVisible=this.props.onVisible,this.observer.observe(this.placeholder)),this.supportsObserver||this.updateVisibility()}},{key:"componentWillUnmount",value:function(){this.observer&&this.observer.unobserve(this.placeholder)}},{key:"componentDidUpdate",value:function(){this.supportsObserver||this.updateVisibility()}},{key:"getPlaceholderBoundingBox",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props.scrollPosition,t=this.placeholder.getBoundingClientRect(),r=s().findDOMNode(this.placeholder).style,o={left:parseInt(r.getPropertyValue("margin-left"),10)||0,top:parseInt(r.getPropertyValue("margin-top"),10)||0};return{bottom:e.y+t.bottom+o.top,left:e.x+t.left+o.left,right:e.x+t.right+o.left,top:e.y+t.top+o.top}}},{key:"isPlaceholderInViewport",value:function(){if("undefined"==typeof window||!this.placeholder)return!1;var e=this.props,t=e.scrollPosition,r=e.threshold,o=this.getPlaceholderBoundingBox(t),n=t.y+window.innerHeight,i=t.x,s=t.x+window.innerWidth,c=t.y;return Boolean(c-r<=o.bottom&&n+r>=o.top&&i-r<=o.right&&s+r>=o.left)}},{key:"updateVisibility",value:function(){this.isPlaceholderInViewport()&&this.props.onVisible()}},{key:"render",value:function(){var e=this,r=this.props,o=r.className,n=r.height,i=r.placeholder,s=r.style,c=r.width;if(i&&"function"!=typeof i.type)return t().cloneElement(i,{ref:function(t){return e.placeholder=t}});var u=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){a(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({display:"inline-block"},s);return void 0!==c&&(u.width=c),void 0!==n&&(u.height=n),t().createElement("span",{className:o,ref:function(t){return e.placeholder=t},style:u},i)}}])&&f(r.prototype,o),v}(t().Component);v.propTypes={onVisible:n.PropTypes.func.isRequired,className:n.PropTypes.string,height:n.PropTypes.oneOfType([n.PropTypes.number,n.PropTypes.string]),placeholder:n.PropTypes.element,threshold:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool,scrollPosition:n.PropTypes.shape({x:n.PropTypes.number.isRequired,y:n.PropTypes.number.isRequired}),width:n.PropTypes.oneOfType([n.PropTypes.number,n.PropTypes.string])},v.defaultProps={className:"",placeholder:null,threshold:100,useIntersectionObserver:!0};const m=v;var O=r(296),w=r.n(O),g=r(96),P=r.n(g),T=function(e){var t=getComputedStyle(e,null);return t.getPropertyValue("overflow")+t.getPropertyValue("overflow-y")+t.getPropertyValue("overflow-x")};const j=function(e){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t instanceof HTMLElement;){if(/(scroll|auto)/.test(T(t)))return t;t=t.parentNode}return window};function S(e){return(S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var E=["delayMethod","delayTime"];function _(){return(_=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function I(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function L(e,t){return(L=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function x(e,t){if(t&&("object"===S(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return R(e)}function R(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function k(e){return(k=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var D=function(){return"undefined"==typeof window?0:window.scrollX||window.pageXOffset},N=function(){return"undefined"==typeof window?0:window.scrollY||window.pageYOffset};const C=function(e){var r=function(r){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&L(e,t)}(a,r);var o,n,i,u,l=(i=a,u=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=k(i);if(u){var r=k(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return x(this,e)});function a(e){var r;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),(r=l.call(this,e)).useIntersectionObserver=e.useIntersectionObserver&&c(),r.useIntersectionObserver)return x(r);var o=r.onChangeScroll.bind(R(r));return"debounce"===e.delayMethod?r.delayedScroll=w()(o,e.delayTime):"throttle"===e.delayMethod&&(r.delayedScroll=P()(o,e.delayTime)),r.state={scrollPosition:{x:D(),y:N()}},r.baseComponentRef=t().createRef(),r}return o=a,(n=[{key:"componentDidMount",value:function(){this.addListeners()}},{key:"componentWillUnmount",value:function(){this.removeListeners()}},{key:"componentDidUpdate",value:function(){"undefined"==typeof window||this.useIntersectionObserver||j(s().findDOMNode(this.baseComponentRef.current))!==this.scrollElement&&(this.removeListeners(),this.addListeners())}},{key:"addListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement=j(s().findDOMNode(this.baseComponentRef.current)),this.scrollElement.addEventListener("scroll",this.delayedScroll,{passive:!0}),window.addEventListener("resize",this.delayedScroll,{passive:!0}),this.scrollElement!==window&&window.addEventListener("scroll",this.delayedScroll,{passive:!0}))}},{key:"removeListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement.removeEventListener("scroll",this.delayedScroll),window.removeEventListener("resize",this.delayedScroll),this.scrollElement!==window&&window.removeEventListener("scroll",this.delayedScroll))}},{key:"onChangeScroll",value:function(){this.useIntersectionObserver||this.setState({scrollPosition:{x:D(),y:N()}})}},{key:"render",value:function(){var r=this.props,o=(r.delayMethod,r.delayTime,function(e,t){if(null==e)return{};var r,o,n=function(e,t){if(null==e)return{};var r,o,n={},i=Object.keys(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||(n[r]=e[r]);return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r])}return n}(r,E)),n=this.useIntersectionObserver?null:this.state.scrollPosition;return t().createElement(e,_({forwardRef:this.baseComponentRef,scrollPosition:n},o))}}])&&I(o.prototype,n),a}(t().Component);return r.propTypes={delayMethod:n.PropTypes.oneOf(["debounce","throttle"]),delayTime:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool},r.defaultProps={delayMethod:"throttle",delayTime:300,useIntersectionObserver:!0},r};function M(e){return(M="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function B(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function V(e,t){return(V=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function W(e,t){if(t&&("object"===M(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function z(e){return(z=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var $=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&V(e,t)}(c,e);var r,o,n,i,s=(n=c,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=z(n);if(i){var r=z(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return W(this,e)});function c(e){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,c),s.call(this,e)}return r=c,(o=[{key:"render",value:function(){return t().createElement(m,this.props)}}])&&B(r.prototype,o),c}(t().Component);const U=C($);function q(e){return(q="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function F(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function H(e,t){return(H=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function Y(e,t){if(t&&("object"===q(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return X(e)}function X(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function A(e){return(A=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var G=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&H(e,t)}(u,e);var r,o,n,i,s=(n=u,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=A(n);if(i){var r=A(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return Y(this,e)});function u(e){var t;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),t=s.call(this,e);var r=e.afterLoad,o=e.beforeLoad,n=e.scrollPosition,i=e.visibleByDefault;return t.state={visible:i},i&&(o(),r()),t.onVisible=t.onVisible.bind(X(t)),t.isScrollTracked=Boolean(n&&Number.isFinite(n.x)&&n.x>=0&&Number.isFinite(n.y)&&n.y>=0),t}return r=u,(o=[{key:"componentDidUpdate",value:function(e,t){t.visible!==this.state.visible&&this.props.afterLoad()}},{key:"onVisible",value:function(){this.props.beforeLoad(),this.setState({visible:!0})}},{key:"render",value:function(){if(this.state.visible)return this.props.children;var e=this.props,r=e.className,o=e.delayMethod,n=e.delayTime,i=e.height,s=e.placeholder,u=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.width;return this.isScrollTracked||f&&c()?t().createElement(m,{className:r,height:i,onVisible:this.onVisible,placeholder:s,scrollPosition:u,style:l,threshold:a,useIntersectionObserver:f,width:p}):t().createElement(U,{className:r,delayMethod:o,delayTime:n,height:i,onVisible:this.onVisible,placeholder:s,style:l,threshold:a,width:p})}}])&&F(r.prototype,o),u}(t().Component);G.propTypes={afterLoad:n.PropTypes.func,beforeLoad:n.PropTypes.func,useIntersectionObserver:n.PropTypes.bool,visibleByDefault:n.PropTypes.bool},G.defaultProps={afterLoad:function(){return{}},beforeLoad:function(){return{}},useIntersectionObserver:!0,visibleByDefault:!1};const J=G;function K(e){return(K="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var Q=["afterLoad","beforeLoad","delayMethod","delayTime","effect","placeholder","placeholderSrc","scrollPosition","threshold","useIntersectionObserver","visibleByDefault","wrapperClassName","wrapperProps"];function Z(){return(Z=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function ee(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function te(e,t){return(te=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function re(e,t){if(t&&("object"===K(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function oe(e){return(oe=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var ne=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&te(e,t)}(c,e);var r,o,n,i,s=(n=c,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=oe(n);if(i){var r=oe(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return re(this,e)});function c(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,c),(t=s.call(this,e)).state={loaded:!1},t}return r=c,(o=[{key:"onImageLoad",value:function(){var e=this;return this.state.loaded?null:function(){e.props.afterLoad(),e.setState({loaded:!0})}}},{key:"getImg",value:function(){var e=this.props,r=(e.afterLoad,e.beforeLoad,e.delayMethod,e.delayTime,e.effect,e.placeholder,e.placeholderSrc,e.scrollPosition,e.threshold,e.useIntersectionObserver,e.visibleByDefault,e.wrapperClassName,e.wrapperProps,function(e,t){if(null==e)return{};var r,o,n=function(e,t){if(null==e)return{};var r,o,n={},i=Object.keys(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||(n[r]=e[r]);return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r])}return n}(e,Q));return t().createElement("img",Z({onLoad:this.onImageLoad()},r))}},{key:"getLazyLoadImage",value:function(){var e=this.props,r=e.beforeLoad,o=e.className,n=e.delayMethod,i=e.delayTime,s=e.height,c=e.placeholder,u=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.visibleByDefault,y=e.width;return t().createElement(J,{beforeLoad:r,className:o,delayMethod:n,delayTime:i,height:s,placeholder:c,scrollPosition:u,style:l,threshold:a,useIntersectionObserver:f,visibleByDefault:p,width:y},this.getImg())}},{key:"getWrappedLazyLoadImage",value:function(e){var r=this.props,o=r.effect,n=r.height,i=r.placeholderSrc,s=r.width,c=r.wrapperClassName,u=r.wrapperProps,l=this.state.loaded,a=l?" lazy-load-image-loaded":"";return t().createElement("span",Z({className:c+" lazy-load-image-background "+o+a,style:{backgroundImage:l||!i?"":"url(".concat(i,")"),backgroundSize:l||!i?"":"100% 100%",color:"transparent",display:"inline-block",height:n,width:s}},u),e)}},{key:"render",value:function(){var e=this.props,t=e.effect,r=e.placeholderSrc,o=e.visibleByDefault,n=e.wrapperClassName,i=e.wrapperProps,s=this.getLazyLoadImage();return(t||r)&&!o||n||i?this.getWrappedLazyLoadImage(s):s}}])&&ee(r.prototype,o),c}(t().Component);ne.propTypes={afterLoad:n.PropTypes.func,beforeLoad:n.PropTypes.func,delayMethod:n.PropTypes.string,delayTime:n.PropTypes.number,effect:n.PropTypes.string,placeholderSrc:n.PropTypes.string,threshold:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool,visibleByDefault:n.PropTypes.bool,wrapperClassName:n.PropTypes.string,wrapperProps:n.PropTypes.object},ne.defaultProps={afterLoad:function(){return{}},beforeLoad:function(){return{}},delayMethod:"throttle",delayTime:300,effect:"",placeholderSrc:null,threshold:100,useIntersectionObserver:!0,visibleByDefault:!1,wrapperClassName:""};const ie=ne})(),module.exports=o})();

/***/ }),

/***/ 25726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];

  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function capitalize(token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

var _require = __webpack_require__(78229),
    CAMELCASE = _require.CAMELCASE,
    SAME = _require.SAME,
    possibleStandardNamesOptimized = _require.possibleStandardNames;

var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */

var isCustomAttribute = RegExp.prototype.test.bind( // eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];

  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }

  return accumulator;
}, {});

exports.BOOLEAN = BOOLEAN;
exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
exports.NUMERIC = NUMERIC;
exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
exports.RESERVED = RESERVED;
exports.STRING = STRING;
exports.getPropertyInfo = getPropertyInfo;
exports.isCustomAttribute = isCustomAttribute;
exports.possibleStandardNames = possibleStandardNames;


/***/ }),

/***/ 78229:
/***/ (function(__unused_webpack_module, exports) {

// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME = 0;
exports.SAME = SAME;

// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE = 1;
exports.CAMELCASE = CAMELCASE;

exports.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};


/***/ }),

/***/ 23594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* binding */ ENTERED; },
  "d0": function() { return /* binding */ ENTERING; },
  "Wj": function() { return /* binding */ EXITED; },
  "Ix": function() { return /* binding */ EXITING; },
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(89611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 41476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(__webpack_require__(57848));
var utilities_1 = __webpack_require__(26678);
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;


/***/ }),

/***/ 26678:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.__esModule = true;
exports.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize);
};
exports.camelCase = camelCase;


/***/ }),

/***/ 57848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18139);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;


/***/ }),

/***/ 77635:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e,t,n,r,o){var f=r?o.arrayPrefix||"":"";if("object"===(void 0===t?"undefined":i(t))){return""+u(t,""+n+(""+e+f+(n&&"]")+"["),o)}return n&&n.length?""+n+e+"]"+f+"="+encodeURIComponent(t):""+e+f+"="+encodeURIComponent(t)}function o(e,t,n){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};return t.map(function(t){return r(e,t,n,!0,o)}).join("&")}function u(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},u=[];return u=Array.isArray(e)?e.map(function(e,o){return r(""+o,e,t,!0,n)}):Object.keys(e).filter(function(t){return void 0!==e[t]}).map(function(u){return e[u]&&Array.isArray(e[u])?o(""+u,e[u],t,n):r(u,e[u],t,!1,n)}),u.join("&").replace(/%20/g,"+")}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=u}])});

/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 31868:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"headerData":{"id":1,"locale":"en","published_at":"2022-11-25T09:59:23.480Z","created_at":"2022-11-25T09:59:19.595Z","updated_at":"2026-10-05T09:39:08.347Z","counsellingList":[{"id":1,"countryName":"USA","time":"20 mins","description":"Connect with our USA Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-usa?prefill=%7B%22Preferred%20Destination%22%3A%22Usa%22%7D","countryImage":{"id":3121,"name":"usa.png","alternativeText":"USA","caption":"USA","width":752,"height":752,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_usa_fdef150118.png","hash":"thumbnail_usa_fdef150118","mime":"image/png","name":"thumbnail_usa.png","path":null,"size":24.79,"width":156,"height":156}},"hash":"usa_fdef150118","ext":".png","mime":"image/png","size":53.95,"url":"https://assets.studies-overseas.com/usa_fdef150118.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T10:39:34.249Z","updated_at":"2023-12-18T10:39:34.270Z"}},{"id":2,"countryName":"Canada","time":"20 mins","description":"Connect with our Canada Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-canada?prefill=%7B%22Preferred%20Destination%22%3A%22Canada%22%7D","countryImage":{"id":3122,"name":"canada.png","alternativeText":"Canada","caption":"Canada","width":751,"height":752,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_canada_8252f2b119.png","hash":"thumbnail_canada_8252f2b119","mime":"image/png","name":"thumbnail_canada.png","path":null,"size":19.66,"width":156,"height":156}},"hash":"canada_8252f2b119","ext":".png","mime":"image/png","size":48.01,"url":"https://assets.studies-overseas.com/canada_8252f2b119.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T10:40:35.458Z","updated_at":"2023-12-18T10:40:35.478Z"}},{"id":3,"countryName":"Australia","time":"20 mins","description":"Connect with our Australia Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-australia?prefill=%7B%22Preferred%20Destination%22%3A%22Australia%22%7D","countryImage":{"id":3123,"name":"australia.png","alternativeText":"Australia","caption":"Australia","width":751,"height":752,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_australia_a9f8aafc96.png","hash":"thumbnail_australia_a9f8aafc96","mime":"image/png","name":"thumbnail_australia.png","path":null,"size":20.43,"width":156,"height":156}},"hash":"australia_a9f8aafc96","ext":".png","mime":"image/png","size":42.99,"url":"https://assets.studies-overseas.com/australia_a9f8aafc96.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T10:41:34.445Z","updated_at":"2023-12-18T10:41:34.467Z"}},{"id":5,"countryName":"UK","time":"20 mins","description":"Connect with our UK Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-uk?prefill=%7B%22Preferred%20Destination%22%3A%22Uk%22%7D","countryImage":{"id":3125,"name":"uk.png","alternativeText":"UK","caption":"UK","width":752,"height":751,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_uk_ff42847a88.png","hash":"thumbnail_uk_ff42847a88","mime":"image/png","name":"thumbnail_uk.png","path":null,"size":22.51,"width":156,"height":156}},"hash":"uk_ff42847a88","ext":".png","mime":"image/png","size":59.13,"url":"https://assets.studies-overseas.com/uk_ff42847a88.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T10:48:24.921Z","updated_at":"2023-12-18T10:48:24.950Z"}},{"id":6,"countryName":"New Zealand","time":"20 mins","description":"Connect with our New Zealand Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-new-zealand?prefill=%7B%22Preferred%20Destination%22%3A%22New%20Zealand%22%7D","countryImage":{"id":3143,"name":"New Zealand Flag.png","alternativeText":"","caption":"","width":752,"height":752,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_New_Zealand_Flag_86da2fc5bd.png","hash":"thumbnail_New_Zealand_Flag_86da2fc5bd","mime":"image/png","name":"thumbnail_New Zealand Flag.png","path":null,"size":20.22,"width":156,"height":156}},"hash":"New_Zealand_Flag_86da2fc5bd","ext":".png","mime":"image/png","size":56.5,"url":"https://assets.studies-overseas.com/New_Zealand_Flag_86da2fc5bd.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-21T11:21:09.776Z","updated_at":"2023-12-21T11:21:09.794Z"}},{"id":12,"countryName":"Singapore","time":"20 mins","description":"Connect with our Singapore Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-singapore?prefill=%7B%22Preferred%20Destination%22%3A%22Singapore%22%7D","countryImage":{"id":3144,"name":"Singapore Flag.png","alternativeText":"","caption":"","width":752,"height":752,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_Singapore_Flag_4219e9f504.png","hash":"thumbnail_Singapore_Flag_4219e9f504","mime":"image/png","name":"thumbnail_Singapore Flag.png","path":null,"size":13.06,"width":156,"height":156}},"hash":"Singapore_Flag_4219e9f504","ext":".png","mime":"image/png","size":40.75,"url":"https://assets.studies-overseas.com/Singapore_Flag_4219e9f504.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-21T11:21:09.779Z","updated_at":"2023-12-21T11:21:09.796Z"}},{"id":13,"countryName":"Dubai","time":"20 mins","description":"Connect with our Dubai Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-dubai?prefill=%7B%22Preferred%20Destination%22%3A%22Dubai%22%7D","countryImage":{"id":3145,"name":"Dubai Flag.png","alternativeText":"","caption":"","width":752,"height":752,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_Dubai_Flag_6966da4f82.png","hash":"thumbnail_Dubai_Flag_6966da4f82","mime":"image/png","name":"thumbnail_Dubai Flag.png","path":null,"size":10.99,"width":156,"height":156}},"hash":"Dubai_Flag_6966da4f82","ext":".png","mime":"image/png","size":33.61,"url":"https://assets.studies-overseas.com/Dubai_Flag_6966da4f82.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-21T11:21:09.817Z","updated_at":"2023-12-21T11:21:09.825Z"}},{"id":7,"countryName":"Ireland","time":"20 mins","description":"Connect with our Ireland Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-ireland?prefill=%7B%22Preferred%20Destination%22%3A%22Ireland%22%7D","countryImage":{"id":3127,"name":"ireland.png","alternativeText":"Ireland","caption":"Ireland","width":751,"height":751,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_ireland_b097d8180f.png","hash":"thumbnail_ireland_b097d8180f","mime":"image/png","name":"thumbnail_ireland.png","path":null,"size":13.07,"width":156,"height":156}},"hash":"ireland_b097d8180f","ext":".png","mime":"image/png","size":31.59,"url":"https://assets.studies-overseas.com/ireland_b097d8180f.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T10:50:38.552Z","updated_at":"2023-12-18T10:50:38.565Z"}},{"id":8,"countryName":"Europe","time":"20 mins","description":"Connect with our Europe Counselling Expert.","bookingLink":"https://zipme.at/kcoverseas-europe/meetings","countryImage":{"id":3129,"name":"Europe Zoho icon.png","alternativeText":"Europe Zoho icon","caption":"Europe Zoho icon","width":752,"height":752,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_Microsoft_Teams_image_10_0ec170752d.png","hash":"thumbnail_Microsoft_Teams_image_10_0ec170752d","mime":"image/png","name":"thumbnail_MicrosoftTeams-image__10_.png","path":null,"size":16.97,"width":156,"height":156}},"hash":"Microsoft_Teams_image_10_0ec170752d","ext":".png","mime":"image/png","size":63.33,"url":"https://assets.studies-overseas.com/Microsoft_Teams_image_10_0ec170752d.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T11:48:14.739Z","updated_at":"2023-12-18T11:49:09.194Z"}},{"id":9,"countryName":"Test Prep - IELTS, PTE, TOEFL, Duolingo, German Language","time":"20 mins","description":"Connect Online with our Coaching Expert","bookingLink":"https://zipme.at/kcoverseas-test-prep-ielts-pte-toefl-duolingo-german/meetings","countryImage":{"id":3128,"name":"Test Prep icon Zoho.png","alternativeText":"Test Prep icon Zoho","caption":"Test Prep icon Zoho","width":751,"height":751,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_Microsoft_Teams_image_4_556f7efe1f.png","hash":"thumbnail_Microsoft_Teams_image_4_556f7efe1f","mime":"image/png","name":"thumbnail_MicrosoftTeams-image__4_.png","path":null,"size":18.23,"width":156,"height":156}},"hash":"Microsoft_Teams_image_4_556f7efe1f","ext":".png","mime":"image/png","size":44.45,"url":"https://assets.studies-overseas.com/Microsoft_Teams_image_4_556f7efe1f.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T11:48:14.706Z","updated_at":"2023-12-18T11:48:42.994Z"}},{"id":10,"countryName":"Test Prep - GRE, GMAT, SAT, ACT","time":"30 mins","description":"Connect Online with our Coaching Expert","bookingLink":"https://zipme.at/kcoverseas-test-prep-gre-gmat-sat-act/meetings","countryImage":{"id":3128,"name":"Test Prep icon Zoho.png","alternativeText":"Test Prep icon Zoho","caption":"Test Prep icon Zoho","width":751,"height":751,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_Microsoft_Teams_image_4_556f7efe1f.png","hash":"thumbnail_Microsoft_Teams_image_4_556f7efe1f","mime":"image/png","name":"thumbnail_MicrosoftTeams-image__4_.png","path":null,"size":18.23,"width":156,"height":156}},"hash":"Microsoft_Teams_image_4_556f7efe1f","ext":".png","mime":"image/png","size":44.45,"url":"https://assets.studies-overseas.com/Microsoft_Teams_image_4_556f7efe1f.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-18T11:48:14.706Z","updated_at":"2023-12-18T11:48:42.994Z"}},{"id":14,"countryName":"Elan Loans","time":"30 Mins","description":"Connect Online with our Education Loan Expert","bookingLink":"https://zipme.at/kc-overseas-education-meetings/meetings?opentype=link","countryImage":{"id":3251,"name":"ELAN-logo.png","alternativeText":"","caption":"","width":180,"height":180,"formats":{"thumbnail":{"ext":".png","url":"https://assets.studies-overseas.com/thumbnail_ELAN_logo_4f1d769c0f.png","hash":"thumbnail_ELAN_logo_4f1d769c0f","mime":"image/png","name":"thumbnail_ELAN-logo.png","path":null,"size":7.93,"width":156,"height":156}},"hash":"ELAN_logo_4f1d769c0f","ext":".png","mime":"image/png","size":3.19,"url":"https://assets.studies-overseas.com/ELAN_logo_4f1d769c0f.png","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2024-07-25T11:11:05.409Z","updated_at":"2024-07-25T11:11:05.442Z"}}],"bookOnlineCounselling":{"id":2,"hideOnPages":[{"id":7,"link":"https://staging.studies-overseas.com/contact-us/*"}],"alwaysShowOnPages":[{"id":8,"link":"https://staging.studies-overseas.com/contact-us/study-abroad-consultants-in-amravati"},{"id":9,"link":"https://staging.studies-overseas.com/contact-us/study-abroad-consultants-in-nagpur-sadar"}]},"kcLogoBlue":{"id":3142,"name":"Group 230.svg","alternativeText":"","caption":"","width":611,"height":160,"formats":null,"hash":"Group_230_d971d2bc86","ext":".svg","mime":"image/svg+xml","size":18.2,"url":"https://assets.studies-overseas.com/Group_230_d971d2bc86.svg","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-21T07:21:16.235Z","updated_at":"2023-12-21T07:21:16.250Z"},"kcLogoBlack":{"id":3136,"name":"KC Black Logo - 687 x 180.svg","alternativeText":"","caption":"","width":687,"height":180,"formats":null,"hash":"KC_Black_Logo_687_x_180_f2988235f0","ext":".svg","mime":"image/svg+xml","size":17.62,"url":"https://assets.studies-overseas.com/KC_Black_Logo_687_x_180_f2988235f0.svg","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-19T13:25:56.396Z","updated_at":"2023-12-19T13:25:56.424Z"},"kcLogoWhite":{"id":3137,"name":"KC White Logo - 687 x 180.svg","alternativeText":"KC Overseas Education","caption":"","width":687,"height":180,"formats":null,"hash":"KC_White_Logo_687_x_180_c58c6251a6","ext":".svg","mime":"image/svg+xml","size":17.89,"url":"https://assets.studies-overseas.com/KC_White_Logo_687_x_180_c58c6251a6.svg","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-12-19T13:25:56.419Z","updated_at":"2024-03-05T10:53:15.220Z"},"localizations":[]},"footerData":{"id":1,"footerTitle":"About KC Overseas","footerDescription":"We are the fastest growing EdTech brand operating across geographies, facilitating international student recruitments by connecting students, recruitment entrepreneurs and global universities through our high-tech online platform – Course Finder.","copyright":"Copyright © KC Overseas Education 2004-2023","recognitionTitle":"Global Accreditations & Recognitions","published_at":"2021-12-29T06:56:19.125Z","created_at":"2021-12-29T06:56:14.579Z","updated_at":"2026-04-21T08:55:50.391Z","navColors":null,"locale":"en","footerImageUrl":"https://assets.studies-overseas.com/Group_225_93dd3a4682.svg","FooterImageAltTag":"KC Logo footer","hiringTitle":"We\'re Hiring!","hiringDescription":"Join the fastest growing EdTech brand offering endless learning and growth opportunities and advance your career with us.","hiringButtonLabel":"Apply Now","hiringButtonLink":"https://www.studies-overseas.com/careers","navigationsOne":[{"id":1,"title":"Study Destinations","href":"/study-destinations","subNav":[{"id":6,"href":"/country/study-in-usa","label":"United States","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":7,"href":"/country/study-in-canada","label":"Canada","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":8,"href":"/country/study-in-uk","label":"United Kingdom","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":9,"href":"/country/study-in-ireland","label":"Ireland","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":10,"href":"/country/study-in-australia","label":"Australia","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":11,"href":"/country/study-in-new-zealand","label":"New Zealand","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":12,"href":"/study-destinations/europe","label":"Europe","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":119,"href":"/study-destinations/asia","label":"Asia","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null}]},{"id":2,"title":"Login To","href":"","subNav":[{"id":13,"href":"https://coursefinder.ai","label":"Find my Course","target":"_blank","type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":14,"href":"https://www.elanloans.com","label":"Elan Loans","target":"_blank","type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null}]}],"navigationsTwo":[{"id":3,"title":"Services for Students","href":"/student-services/steps-to-study-abroad","subNav":[{"id":15,"href":"/student-services/steps-to-study-abroad#1","label":"Counselling","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":16,"href":"/test-preparation","label":"Test Preparation","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":17,"href":"/student-services/steps-to-study-abroad#3","label":"Course, Country & University Selection","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":18,"href":"/student-services/steps-to-study-abroad#4","label":"Applications & Admission","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":19,"href":"/student-services/study-abroad-scholarships","label":"Scholarships","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":20,"href":"/internships","label":"Internship","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":21,"href":"/student-services/education-loan-for-overseas-education","label":"Education Loan","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":59,"href":"/student-services/steps-to-study-abroad#8","label":"Visa Processing","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":120,"href":"/student-services/steps-to-study-abroad#9","label":"Allied Services","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":165,"href":"/study-abroad-consultants","label":"Study Abroad Consultants in India","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null}]},{"id":4,"title":"Services for Institutions","href":"/partners/institutions-universities","subNav":[]},{"id":5,"title":"Services for Partners","href":"/partners/study-abroad-association","subNav":[]},{"id":6,"title":"Services for Franchisee","href":"/entrepreneur/franchise-proposal","subNav":[]}],"navigationsThree":[{"id":7,"title":"Company","href":null,"subNav":[{"id":22,"href":"/aboutus","label":"About Us","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":23,"href":"/careers","label":"Careers","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":24,"href":"/news","label":"News & Events","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":147,"href":"/corporate-social-responsibility","label":"Corporate Social Responsibility","target":null,"type":"one","imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":149,"href":"https://assets.studies-overseas.com/CSR_Policy_87a36109e0.pdf","label":"CSR Policy","target":"_blank","type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":131,"href":"/blogs","label":"Blog","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":150,"href":"https://assets.studies-overseas.com/Po_SH_Policy_079cb534d0.pdf","label":"POSH Policy","target":"_blank","type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":25,"href":"/contact-us","label":"Contact Us","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":154,"href":"https://assets.studies-overseas.com/Student_Guide_293767a333.pdf","label":"How to Choose an Education Agent ?","target":"_blank","type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null}]},{"id":8,"title":"Search Universities","href":"/universities","subNav":[]},{"id":9,"title":"Upcoming Events","href":"/events","subNav":[]},{"id":10,"title":"Become KC Certified Counselor","href":"https://kcoverseas.thinkific.com/collections","subNav":[]},{"id":11,"title":"Book  Online  Counselling","href":"https://staging.studies-overseas.com/online-counselling","subNav":[]}],"bottomLinks":[{"id":26,"href":"/terms-and-condition","label":"Term & Conditions","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":27,"href":"/privacy-policy","label":"Privacy Policy","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null},{"id":28,"href":"/payment-and-refund-policy","label":"Payment Terms","target":null,"type":null,"imageAltTag":null,"title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":null}],"socialLink":[{"id":34,"href":"https://www.facebook.com/KCOverseasEdu","label":"facebook","target":"_blank","type":null,"imageAltTag":"facebook","title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":{"id":1452,"name":"facebook.svg","alternativeText":"Facebook","caption":"","width":38,"height":37,"formats":null,"hash":"facebook_d367658a5d","ext":".svg","mime":"image/svg+xml","size":0.7,"url":"https://assets.studies-overseas.com/facebook_d367658a5d.svg","previewUrl":null,"provider":"aws-s3","provider_metadata":null,"created_at":"2022-04-14T09:22:41.503Z","updated_at":"2022-06-01T11:31:23.552Z"}},{"id":35,"href":"https://twitter.com/KCOverseasEdu","label":"Twitter","target":"_blank","type":null,"imageAltTag":"twitter","title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":{"id":3092,"name":"Twiter Icon 2.svg","alternativeText":"Twitter","caption":"","width":40,"height":40,"formats":null,"hash":"Twiter_Icon_2_79ac73e30f","ext":".svg","mime":"image/svg+xml","size":2.31,"url":"https://assets.studies-overseas.com/Twiter_Icon_2_79ac73e30f.svg","previewUrl":null,"provider":"aws-s3-plus-cdn","provider_metadata":null,"created_at":"2023-10-10T07:28:44.439Z","updated_at":"2024-03-05T11:22:43.722Z"}},{"id":36,"href":"https://www.youtube.com/c/kcoverseasedu","label":"youtube","target":"_blank","type":null,"imageAltTag":"youtube","title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":{"id":1470,"name":"youtube.svg","alternativeText":"youtube","caption":"","width":38,"height":37,"formats":null,"hash":"youtube_7bbb19798c","ext":".svg","mime":"image/svg+xml","size":1.16,"url":"https://assets.studies-overseas.com/youtube_7bbb19798c.svg","previewUrl":null,"provider":"aws-s3","provider_metadata":null,"created_at":"2022-04-14T10:00:31.528Z","updated_at":"2022-06-01T11:31:56.817Z"}},{"id":37,"href":"https://www.instagram.com/KCOverseasEdu","label":"instagram","target":"_blank","type":null,"imageAltTag":"instagarm","title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":{"id":1469,"name":"ig.svg","alternativeText":"Instagram","caption":"","width":38,"height":37,"formats":null,"hash":"ig_2509cda7bf","ext":".svg","mime":"image/svg+xml","size":6.8,"url":"https://assets.studies-overseas.com/ig_2509cda7bf.svg","previewUrl":null,"provider":"aws-s3","provider_metadata":null,"created_at":"2022-04-14T10:00:31.528Z","updated_at":"2022-06-01T11:32:10.408Z"}},{"id":38,"href":"https://www.linkedin.com/company/kcoverseasedu","label":"linkedin","target":"_blank","type":null,"imageAltTag":"Linkedin","title":null,"toOnboardingEnabled":null,"onBoardingFlow":null,"image":{"id":1471,"name":"linkedin.svg","alternativeText":"Linkedin","caption":"","width":37,"height":38,"formats":null,"hash":"linkedin_15ec1e122a","ext":".svg","mime":"image/svg+xml","size":1.13,"url":"https://assets.studies-overseas.com/linkedin_15ec1e122a.svg","previewUrl":null,"provider":"aws-s3","provider_metadata":null,"created_at":"2022-04-14T10:00:31.534Z","updated_at":"2022-06-01T11:32:28.973Z"}}],"recognitiondata":{"id":1,"logoimages":[{"id":1003,"imageUrl":"https://assets.studies-overseas.com/61x60_01_167dbb523a.svg","alt":"Member of AIRC","imageAltTag":null},{"id":1004,"imageUrl":"https://assets.studies-overseas.com/recog_3_53bf493df1.svg","alt":"Qualified Education Agent Counsellor - PIER","imageAltTag":null},{"id":1006,"imageUrl":"https://assets.studies-overseas.com/recog_4_eb0030b89e.svg","alt":"Member of AAERI","imageAltTag":null},{"id":1007,"imageUrl":"https://assets.studies-overseas.com/recog_1_58ddf09c3f.svg","alt":"Professional Development Programme in Promoting UK Education and Training","imageAltTag":null},{"id":2067,"imageUrl":"https://assets.studies-overseas.com/ICEF_badge_Size_150x50_pixel_78c3c0166a.png","alt":"ICEF Badge","imageAltTag":null}]},"recognitions":[],"localizations":[]},"fetchedAt":"2026-11-05T05:38:40.609Z"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);